export const en = {
  "common.back": "Back",
  "common.search": "Search",
  "common.continue": "Continue",
  "common.skip": "Skip",
  "common.signIn": "Sign in",
  "common.refresh": "Refresh",
  "common.close": "Close",
  "common.loading": "Loading…",
  "common.done": "Done",
  "common.optional": "optional",
  "common.settings": "Settings",
  "common.systemDefault": "System default",

  "language.system": "System default",
  "language.en": "English",
  "language.tr": "Türkçe",

  "sidebar.goToThreads": "Go to threads",
  "sidebar.settings": "Settings",
  "sidebar.usage": "Usage",
  "sidebar.memory": "Memory",
  "sidebar.team": "Team",
  "sidebar.organization": "Organization",
  "sidebar.agents": "Agents",
  "sidebar.workflows": "Workflows",
  "sidebar.routines": "Routines",
  "sidebar.knowledge": "Knowledge",
  "sidebar.vault": "Vault",
  "sidebar.allowance": "Allowance",
  "allowance.subtitle":
    "Actions Morrow wants to take on your behalf are held here until you say yes. Approve or deny below — or reply YES / NO on the channel.",
  "allowance.empty.title": "Nothing needs your approval right now.",
  "allowance.empty.description":
    "When Morrow wants to send a message or take an action as you, it'll ask here first.",
  "allowance.refresh": "Refresh",
  "sidebar.activities": "Activities",
  "sidebar.messages": "Messages",
  "sidebar.searchThreads": "Search threads",
  "sidebar.clearSearch": "Clear thread search",
  "sidebar.newThread": "New thread",
  "sidebar.newThreadShortcut": "New thread ({shortcut})",
  "sidebar.newThreadInCurrent": "New thread in current project: Shift+click",
  "sidebar.newThreadInCurrentShortcut": "New thread in current project: Shift+click ({shortcut})",
  "sidebar.filterByProject": "Filter threads by project",
  "sidebar.workspace": "Workspace",
  "sidebar.filterByWorkspace": "Filter threads by workspace",
  "sidebar.workspaceSettings": "Workspace settings for {name}",
  "sidebar.addWorkspace": "Add workspace",
  "sidebar.renameWorkspace": "Rename",
  "sidebar.removeWorkspace": "Remove",
  "sidebar.workspaceSettingsAction": "Settings",
  "sidebar.workspaceActions": "Workspace actions",
  "sidebar.renameWorkspaceTitle": "Rename workspace",
  "sidebar.renameWorkspaceDescription": "Update the display name for this workspace.",
  "sidebar.workspaceTitleLabel": "Workspace name",
  "sidebar.workspaceRenameEmpty": "Workspace name cannot be empty",
  "sidebar.workspaceRenameFailed": "Failed to rename workspace",
  "sidebar.removeWorkspaceConfirm": 'Remove workspace "{name}"?',
  "sidebar.removeWorkspaceWithThreads":
    'Remove workspace "{name}" and delete its {count} thread(s)?',
  "sidebar.removeWorkspaceThreadsWarning":
    "This permanently clears conversation history for those threads.",
  "sidebar.removeWorkspaceDiskWarning": "Files on disk are not touched.",
  "sidebar.removeWorkspaceUndoWarning": "This action cannot be undone.",
  "sidebar.workspaceNotEmpty": "Workspace is not empty",
  "sidebar.workspaceNotEmptyDescription":
    "Delete all threads in this workspace before removing it.",
  "sidebar.removeAnyway": "Remove anyway",
  "sidebar.workspaceRemoveFailed": 'Failed to remove "{name}"',
  "sidebar.allProjects": "All projects",
  "sidebar.noThreadsFound": "No threads found",
  "sidebar.noThreadsYet": "No threads yet",
  "sidebar.noThreadsInProject": "No threads in {name} yet",
  "sidebar.settled": "Settled",
  "sidebar.settledCount": "Settled ({count})",
  "sidebar.snoozed": "Snoozed",
  "sidebar.snoozedCount": "Snoozed ({count})",
  "sidebar.showMore": "Show {count} more",
  "sidebar.working": "Working",
  "sidebar.monitoring": "Monitoring",
  "sidebar.approval": "Approval",
  "sidebar.input": "Input",
  "sidebar.failed": "Failed",
  "sidebar.woke": "Woke",
  "sidebar.done": "Done",
  "sidebar.pinned": "Pinned",
  "sidebar.signIn": "Sign in",
  "sidebar.account": "Account",

  "settings.breadcrumb": "Settings",
  "settings.search": "Search",
  "settings.searchAria": "Search settings",
  "settings.clearSearch": "Clear settings search",
  "settings.noResults": "No settings found",
  "settings.searchResults": "Settings search results",
  "settings.section.general": "General",
  "settings.section.appearance": "Appearance",
  "settings.section.keybindings": "Keybindings",
  "settings.section.providers": "Providers",
  "settings.section.connections": "Connections",
  "settings.section.comms": "Messaging",
  "settings.section.triggers": "Triggers",
  "settings.section.organization": "Organization",
  "settings.section.packages": "Packages",
  "settings.section.billing": "Billing",
  "settings.section.archive": "Archive",
  "settings.section.diagnostics": "Diagnostics",
  "settings.section.about": "About",
  "settings.section.support": "Support",
  "settings.section.legal": "Legal",
  "settings.section.account": "Account",
  "settings.account.manageTitle": "Manage account",
  "settings.account.manageDescription":
    "Update your profile, email, password, and security settings.",
  "settings.account.manageAction": "Manage",
  "settings.account.signOutTitle": "Sign out",
  "settings.account.signOutDescription": "Sign out of Morrow on this device.",
  "settings.account.signOutAction": "Sign out",
  "settings.search.colorScheme": "Color scheme",
  "settings.search.theme": "Themes",
  "settings.search.glassOpacity": "Glass opacity",
  "settings.search.environmentIdentification": "Environment identification",
  "settings.search.interfaceFont": "Interface font",
  "settings.search.promptFont": "Prompt font",
  "settings.search.fontSmoothing": "Font smoothing",
  "settings.search.language": "Language",
  "settings.search.timeFormat": "Time format",
  "settings.search.archiveConfirmation": "Archive confirmation",
  "settings.search.deleteConfirmation": "Delete confirmation",
  "settings.search.textGenerationModel": "Text generation model",
  "settings.search.diagnostics": "Diagnostics",
  "settings.search.keybindings": "Keybindings",
  "settings.search.providers": "Providers",
  "settings.search.remoteEnvironments": "Remote environments",
  "settings.connections.departmentsAria": "Filter connectors by department",
  "settings.connections.dept.all": "All",
  "settings.connections.dept.comms": "Comms",
  "settings.connections.dept.dev": "Dev",
  "settings.connections.dept.work": "Work",
  "settings.connections.dept.crm": "CRM",
  "settings.connections.dept.data": "Data",
  "settings.connections.dept.finance": "Finance",
  "settings.connections.dept.ai": "AI",
  "settings.connections.dept.other": "Other",
  "settings.connections.rowTitle": "Connect an app or MCP server",
  "settings.connections.rowDescription":
    "Connect the apps and MCP servers MorrowOS can act on. Search thousands of Composio toolkits, then connect with a click.",
  "settings.connections.searchPlaceholder": "Search apps and MCP servers…",
  "settings.connections.searchAria": "Search connectors",
  "settings.connections.connected": "Connected",
  "settings.connections.connect": "Connect",
  "settings.connections.connecting": "Connecting…",
  "settings.connections.disconnect": "Disconnect",
  "settings.connections.disconnectApp": "Disconnect {name}",
  "settings.connections.signInToConnect": "Sign in to connect apps",
  "settings.connections.loading": "Loading connectors…",
  "settings.connections.noMatch": "No connectors match “{query}”.",
  "settings.connections.noInDepartment": "No connectors in {department}.",
  "settings.connections.none": "No connectors found.",
  "settings.connections.loadMore": "Load more ({loaded} of {total})",
  "settings.connections.count": "{count} connectors",
  "settings.connections.searchFailed": "Search failed",
  "settings.connections.loadMoreFailed": "Failed to load more",
  "settings.connections.connectFailed":
    "Could not start the connection. Check the Composio API key on the server.",
  "settings.connections.logoAlt": "{name} logo",
  "settings.connections.tagline.whatsapp": "Read & send as you",
  "settings.connections.tagline.businessEmail": "Read & send from your inbox",
  "settings.connections.tagline.businessEmailOneMailbox": "1 mailbox — manage",
  "settings.connections.tagline.businessEmailMailboxes": "{count} mailboxes — manage",
  "settings.connections.tagline.browser": "Act in your browser",
  "settings.connections.tagline.browserConnected": "Connected — manage",
  "settings.connections.toolkitTagline.default": "Act in this app as you",
  "settings.connections.toolkitTagline.email": "Read & send email as you",
  "settings.connections.toolkitTagline.calendar": "View & schedule events as you",
  "settings.connections.toolkitTagline.messaging": "Read & send messages as you",
  "settings.connections.toolkitTagline.workTracking": "Track & update work as you",
  "settings.connections.toolkitTagline.docs": "Read & update docs as you",
  "settings.connections.toolkitTagline.data": "Read & update records as you",
  "settings.connections.toolkitTagline.files": "Browse & manage files as you",
  "settings.connections.toolkitTagline.crm": "Contacts & deals as you",
  "settings.connections.toolkitTagline.finance": "Payments & billing as you",
  "settings.connections.toolkitTagline.design": "Designs & feedback as you",
  "settings.connections.toolkitTagline.meetings": "Meetings & schedule as you",
  "settings.connections.toolkitTagline.ai": "Models & AI workflows as you",
  "settings.connections.toolkitTagline.gmail": "Read & send email as you",
  "settings.connections.toolkitTagline.googlecalendar": "View & schedule events as you",
  "settings.connections.toolkitTagline.googledrive": "Browse & manage files as you",
  "settings.connections.toolkitTagline.googlesheets": "Read & edit spreadsheets as you",
  "settings.connections.toolkitTagline.googledocs": "Read & edit documents as you",
  "settings.connections.toolkitTagline.googleslides": "Read & edit presentations as you",
  "settings.connections.toolkitTagline.slack": "Read & post in channels as you",
  "settings.connections.toolkitTagline.notion": "Read & update pages as you",
  "settings.connections.toolkitTagline.github": "Issues, PRs & repos as you",
  "settings.connections.toolkitTagline.linear": "Track & update issues as you",
  "settings.connections.toolkitTagline.jira": "Tickets & boards as you",
  "settings.connections.toolkitTagline.discord": "Read & send in servers as you",
  "settings.connections.toolkitTagline.outlook": "Read & send email as you",
  "settings.connections.toolkitTagline.hubspot": "Contacts & deals as you",
  "settings.connections.toolkitTagline.asana": "Tasks & projects as you",
  "settings.connections.toolkitTagline.figma": "Designs & comments as you",
  "settings.connections.toolkitTagline.trello": "Boards & cards as you",
  "settings.connections.toolkitTagline.zoom": "Meetings & schedule as you",
  "settings.connections.toolkitTagline.dropbox": "Files & folders as you",
  "settings.connections.toolkitTagline.airtable": "Bases & records as you",
  "settings.connections.toolkitTagline.microsoftTeams": "Chat & meetings as you",
  "settings.connections.toolkitTagline.gitlab": "Issues, MRs & repos as you",
  "settings.connections.toolkitTagline.bitbucket": "Repos & pull requests as you",
  "settings.connections.toolkitTagline.salesforce": "Leads & opportunities as you",
  "settings.connections.toolkitTagline.intercom": "Conversations & contacts as you",
  "settings.connections.toolkitTagline.zendesk": "Tickets & customers as you",
  "settings.connections.toolkitTagline.shopify": "Orders & products as you",
  "settings.connections.toolkitTagline.stripe": "Payments & customers as you",
  "settings.comms.channelsTitle": "Your channels",
  "settings.comms.channelsDescription":
    "Connect your own ports — the places you already talk — so Morrow can hear you and reach you there. Each connection is yours alone.",
  "settings.comms.signInBody":
    "Sign in to connect your channels — each connection is tied to your account so only you can reach your Morrow.",
  "settings.comms.signInCta": "Sign in to connect",
  "settings.comms.connected": "Connected",
  "settings.comms.serverError": "Could not reach the server.",
  "settings.comms.disconnectAria": "Disconnect {name}",
  "settings.comms.addTo": "Add to {label}",
  "settings.comms.connect": "Connect",
  "settings.comms.comingSoon": "Coming soon on this workspace",
  "settings.comms.testSend": "Send test message",
  "settings.comms.testSent": "Sent — check your chat",
  "settings.comms.testFailed": "Failed — try again",
  "settings.comms.allowance.title": "Allowance",
  "settings.comms.allowance.description":
    "Morrow is waiting on your OK before it acts on your behalf. Approve or deny here — or just reply YES / NO on the channel.",
  "settings.comms.allowance.waiting": "Waiting for your approval",
  "settings.comms.allowance.approve": "Approve",
  "settings.comms.allowance.deny": "Deny",
  "settings.comms.whatsapp.label": "WhatsApp Business",
  "settings.comms.whatsapp.tagline": "Text Morrow on its own number.",
  "settings.comms.whatsapp.pitch":
    "Message Morrow like a contact on its business number — ask anything, drop a voice note or a file, and get your briefings, all in the chat you check anyway.",
  "settings.comms.whatsapp.cap.answers": "Ask & get answers",
  "settings.comms.whatsapp.cap.voice": "Voice notes & files",
  "settings.comms.whatsapp.cap.briefings": "Daily briefings",
  "settings.comms.whatsapp.qrTitle": "Connect WhatsApp",
  "settings.comms.whatsapp.qrReadyHint":
    "Scan with your phone's camera, or tap below — WhatsApp opens with a pre-filled message. Just hit send and you're connected. No number or codes to type.",
  "settings.comms.whatsapp.openWhatsApp": "Open WhatsApp & send",
  "settings.comms.whatsapp.waitingMessage": "Waiting for your message…",
  "settings.comms.whatsapp.scanHint":
    "Scan a QR with WhatsApp to connect — no number or codes to type.",
  "settings.comms.whatsapp.connect": "Connect WhatsApp",
  "settings.comms.telegram.label": "Telegram",
  "settings.comms.telegram.tagline": "One tap and you're talking.",
  "settings.comms.telegram.pitch":
    "Connect in a single tap — no codes. Chat with Morrow, forward messages for it to remember, and get instant replies.",
  "settings.comms.telegram.cap.connect": "One-tap connect",
  "settings.comms.telegram.cap.forward": "Forward to remember",
  "settings.comms.telegram.cap.replies": "Instant replies",
  "settings.comms.telegram.pending":
    "Tap Start in Telegram — this updates automatically once you're linked.",
  "settings.comms.telegram.hint": "Opens Telegram with a one-tap Start button. No codes to type.",
  "settings.comms.telegram.connect": "Connect Telegram",
  "settings.comms.slack.label": "Slack",
  "settings.comms.slack.tagline": "Bring Morrow into your workspace.",
  "settings.comms.slack.pitch":
    "Add Morrow to Slack in one click. @-mention it in any channel or DM it directly — answers, summaries and updates where your team already works.",
  "settings.comms.slack.cap.add": "Add in one click",
  "settings.comms.slack.cap.mention": "@-mention in channels",
  "settings.comms.slack.cap.dm": "Direct messages",
  "settings.comms.discord.label": "Discord",
  "settings.comms.discord.tagline": "Add the Morrow bot to your server.",
  "settings.comms.discord.pitch":
    "Invite Morrow to a server in one click. Mention it in a channel or DM it — it replies inline for you and your community.",
  "settings.comms.discord.cap.invite": "One-click invite",
  "settings.comms.discord.cap.mention": "Mention in channels",
  "settings.comms.discord.cap.dm": "Direct messages",
  "settings.comms.install.approveHint":
    "Approve Morrow on {label} — this updates automatically once it's added.",
  "settings.triggers.intro":
    "Triggers are the moments Morrow watches for on your apps — a new email, a calendar invite, a mention. Turn one on and Morrow starts noticing it.",
  "settings.triggers.introFollowUp":
    "You'll point these at actions — replies, summaries, routines — as you build workflows.",
  "settings.triggers.listeningNow": "{count} listening now.",
  "settings.triggers.when": "When",
  "settings.triggers.needsSetup": "Needs setup",
  "settings.triggers.turnOn": "Turn on {name}",
  "settings.triggers.turnOff": "Turn off {name}",
  "settings.triggers.needsValueFirst": "This trigger needs a value first — setup UI is coming.",
  "settings.triggers.connectAppFirst": "Turning this on will connect the app first.",
  "settings.triggers.noTriggersForApp": "This app doesn't offer any triggers yet.",
  "settings.triggers.connectThenListen":
    "Turn any of these on and we'll connect {app} first, then start listening.",
  "settings.triggers.enabledCount": "{count} on",
  "settings.triggers.connected": "Connected",
  "settings.triggers.notConnected": "Not connected",
  "settings.triggers.genericWatches": "Events from this app that Morrow can notice.",
  "settings.triggers.watches.gmail": "New mail, replies, and labels landing in your inbox.",
  "settings.triggers.watches.googlecalendar": "Invites, changes, and events about to start.",
  "settings.triggers.watches.slack": "Mentions, DMs, and messages in the channels you pick.",
  "settings.triggers.watches.github": "Issues, pull requests, pushes, and reviews.",
  "settings.triggers.watches.notion": "New and updated pages across your workspace.",
  "settings.triggers.watches.linear": "Issues created, assigned, and moved across states.",
  "settings.triggers.watches.googledrive": "Files added, shared, or changed in your Drive.",
  "settings.triggers.watches.googlesheets": "New rows and edits in the sheets you track.",
  "settings.triggers.whatsapp.summary":
    "Incoming messages from your contacts — each rule runs a workflow.",
  "settings.triggers.whatsapp.linked": "Linked",
  "settings.triggers.whatsapp.notLinked": "Not linked",
  "settings.triggers.whatsapp.linkFirstBefore": "Link your WhatsApp first in",
  "settings.triggers.whatsapp.linkFirstAfter": ", then add rules here.",
  "settings.triggers.whatsapp.runs": "→ runs {name}",
  "settings.triggers.whatsapp.noRules":
    "No rules yet — add one below to run a workflow when a message arrives.",
  "settings.triggers.whatsapp.createWorkflowBefore": "Create a",
  "settings.triggers.whatsapp.createWorkflowAfter": "first, then point a WhatsApp rule at it.",
  "settings.triggers.whatsapp.match.all": "Any message",
  "settings.triggers.whatsapp.match.contact": "From a contact",
  "settings.triggers.whatsapp.match.keyword": "Contains keyword",
  "settings.triggers.whatsapp.match.fromContact": "From {value}",
  "settings.triggers.whatsapp.match.aContact": "a contact",
  "settings.triggers.whatsapp.match.contains": 'Contains "{value}"',
  "settings.triggers.whatsapp.run": "→ run",
  "settings.triggers.whatsapp.chooseWorkflow": "Choose workflow…",
  "settings.triggers.whatsapp.addRule": "Add rule",
  "settings.triggers.whatsapp.remove": "Remove",
  "settings.triggers.whatsapp.aWorkflow": "a workflow",
  "settings.triggers.whatsapp.workflowLink": "workflow",
  "settings.triggers.whatsapp.settingsWhatsApp": "Settings › WhatsApp",
  "sidebar.errorOccurred": "Error occurred",
  "sidebar.branchMismatch": "You're currently checked out on another branch.",
  "sidebar.terminalProcesses": "{count} terminal processes running",
  "sidebar.terminalProcess": "{count} terminal process running",
  "chat.tool.readEmail": "Read email",
  "chat.tool.searchEmail": "Search email",
  "chat.tool.sendEmail": "Send email",
  "chat.tool.app.browser": "Browser",
  "chat.tool.app.whatsapp": "WhatsApp",
  "chat.tool.app.morrow": "Morrow",
  "chat.tool.app.email": "Email",
  "chat.tool.app.vault": "Vault",
  "chat.tool.vault.list": "List files",
  "chat.tool.vault.search": "Search",
  "chat.tool.vault.read": "Read",
  "chat.tool.vault.shareLink": "Share link",
  "chat.tool.vault.makePublic": "Make public",
  "chat.tool.browse": "Browse",
  "chat.tool.message": "Message",
  "chat.tool.browser.navigate": "Navigate",
  "chat.tool.browser.click": "Click",
  "chat.tool.browser.type": "Type",
  "chat.tool.browser.screenshot": "Screenshot",
  "chat.tool.browser.scroll": "Scroll",
  "chat.tool.browser.wait": "Wait",
  "chat.tool.browser.extract": "Extract",
  "chat.tool.browser.fill": "Fill",
  "chat.tool.browser.back": "Back",
  "chat.tool.browser.forward": "Forward",
  "chat.tool.browser.close": "Close",
  "chat.tool.browser.open": "Open",
  "chat.tool.browser.generic": "{action}",
  "chat.tool.whatsapp.send": "Send",
  "chat.tool.whatsapp.read": "Read",
  "chat.tool.memory.recall": "Memory",
  "chat.tool.memory.save": "Remember",
  "chat.tool.listAgents": "List agents",
  "chat.tool.knowledge.search": "Knowledge",
  "chat.tool.searchItems": "Search items",
  "chat.tool.showImage": "Show image",
  "chat.tool.showImages": "Show images",
  "chat.tool.generateImage": "Generate image",
  "chat.tool.generatePdf": "Generate PDF",
  "chat.tool.connectApp": "Connect app",
  "chat.tool.activateTools": "Activate tools",
  "chat.tool.spawnSubagent": "Spawn sub-agent",
  "chat.tool.searchWeb": "Searching the web",
  "chat.tool.searchNews": "Search news",
  "chat.tool.searchTopic": "Search {topic}",
  "chat.tool.working": "Working",
  "chat.work.searchingWeb": "Searching the web",
  "chat.work.searchedWeb": "Searched the web",
  "chat.work.reading": "Reading",
  "chat.work.read": "Read",
  "chat.work.editingFiles": "Editing files",
  "chat.work.editedFiles": "Edited files",
  "chat.work.runningCommand": "Running a command",
  "chat.work.ranCommand": "Ran a command",
  "chat.work.thinking": "Thinking",
  "chat.work.usingApp": "Using a connected app",
  "chat.work.usedApp": "Used a connected app",
  "chat.work.working": "Working",
  "chat.connect.title": "Connect {app}",
  "chat.connect.connectedTitle": "{app} connected",
  "chat.connect.alreadyLinked": "{app} is already linked",
  "chat.connect.needsAccess": "Morrow needs {app} access to continue",
  "chat.connect.error": "Couldn't start — try again",
  "chat.connect.connected": "Connected",
  "chat.connect.connect": "Connect",
  "chat.connect.connecting": "Connecting…",
  "chat.agent.answer": "Answer",
  "workflows.title": "Workflows",
  "workflows.subtitle":
    "Tasks Morrow does for you, on its own. Create one, set it up, and see its runs.",
  "workflows.create": "New workflow",
  "workflows.import": "Import",
  "workflows.import.reading": "Reading…",
  "workflows.import.okTitle": "Workflow imported",
  "workflows.import.okBody":
    "It came in turned off, so nothing runs until you enable it. Check it over first.",
  "workflows.import.cleanBody": "Everything in the file came across.",
  "workflows.import.warningsTitle": "Needs your attention before this will run:",
  "workflows.import.droppedTitle": "Not included in this file:",
  "workflows.import.dropped.vaultFiles": "{count} vault file(s)",
  "workflows.import.dropped.contactTriggers":
    "{count} trigger(s) that only fired for one specific contact",
  "workflows.import.dropped.webhookUrls": "{count} webhook URL(s)",
  "workflows.import.errorTitle": "Couldn't import that file",
  "workflows.import.error.unreadable":
    "That file isn't valid JSON. Pick the .json file an export produced.",
  "workflows.import.error.notAnExport":
    "That isn't a MorrowOS workflow export. Pick the .json file the Export action downloads.",
  "workflows.import.error.unsupportedVersion":
    "That export came from a newer MorrowOS. Update, then import it again.",
  "workflows.import.error.rejected": "The server wouldn't take that export.",
  "workflows.import.openWorkflow": "Open workflow",
  "workflows.import.dismiss": "Done",
  "workflows.export.failed": "Couldn't export that workflow.",
  "workflows.export.saved": "Exported — check your downloads.",
  "workflows.create.failed": "Couldn't create that workflow — nothing was saved. Try again.",
  "workflows.loadFailed":
    "Couldn't load your workflows. They're still there — this is just the list.",
  "workflows.loadRetry": "Try again",
  "browser.sessions.title": "Connected browsers",
  "browser.sessions.subtitleOne": "The browser Morrow acts in.",
  "browser.sessions.subtitleMany":
    "More than one browser is paired. Morrow drives the one marked below — pick another if that's not the one you're using.",
  "browser.sessions.unnamed": "Unnamed browser",
  "browser.sessions.driving": "Driving",
  "browser.sessions.online": "Connected",
  "browser.sessions.offline": "Not connected",
  "browser.sessions.lastSeen": "last seen {when}",
  "browser.sessions.chosenByYou": "chosen by you",
  "browser.sessions.makePrimary": "Make primary",
  "browser.sessions.unsetPrimary": "Primary",
  "browser.sessions.disconnect": "Disconnect",
  "browser.sessions.disconnectAll": "Disconnect all",
  "browser.sessions.forgetNote":
    "Disconnecting removes a browser from Morrow; its extension keeps its token, so it reconnects if you open it again. To revoke for good, unpair it in the extension.",
  "browser.sessions.justNow": "just now",
  "browser.sessions.minutesAgo": "{count}m ago",
  "browser.sessions.hoursAgo": "{count}h ago",
  "browser.sessions.daysAgo": "{count}d ago",
  "browser.sessions.never": "never",
  "workflows.rename.hint": "Click to rename",
  "workflows.rename.label": "Name",
  "workflows.rename.failed": "Couldn't rename that — the old name is still saved.",
  "workflows.duplicate.failed": "Couldn't duplicate that workflow.",
  "workflows.empty": "No workflows yet. Click {create}.",
  "workflows.create.emptyCreate": "+ Create",
  "workflows.empty.title": "No workflows yet",
  "workflows.new.title": "New workflow",
  "workflows.new.namePlaceholder": "Workflow name (e.g. Sales replies)",
  "workflows.new.instructionPlaceholder":
    "Describe what this workflow should do — the more specific, the better. e.g. You're the seller for Acme. When someone messages my WhatsApp about a product, answer their questions using my catalog, keep chatting until they're ready, and tell me on Slack when it's a hot lead.",
  "workflows.new.manualShow": "Set up manually (triggers, apps & permissions) — optional",
  "workflows.new.manualHide": "Hide manual setup",
  "workflows.new.triggersSection": "Triggers · what makes it run",
  "workflows.new.noTriggers":
    "No triggers yet — it runs when you ask from a chat. Add message, app-event, and schedule triggers below (as many as you like).",
  "workflows.new.appsSection": "Apps it may use",
  "workflows.new.capabilities": "Capabilities",
  "workflows.new.cap.browser": "Browser",
  "workflows.new.cap.memoryRead": "Read memory",
  "workflows.new.cap.memoryWrite": "Write memory",
  "workflows.new.cap.vault": "Files / vault",
  "workflows.new.vaultAll": "All vault files (tick specific files to restrict).",
  "workflows.new.vaultCount": "Only these {count} file(s).",
  "workflows.new.vaultEmpty": "No vault files yet.",
  "workflows.new.autonomy": "Autonomy",
  "workflows.new.autonomy.read": "Read-only",
  "workflows.new.autonomy.approval": "Ask before acting",
  "workflows.new.autonomy.autonomous": "Autonomous",
  "workflows.new.createButton": "Create workflow",
  "workflows.card.noDescription": "No description yet — open to set it up.",
  "workflows.card.triggers": "{count} trigger",
  "workflows.card.triggersPlural": "{count} triggers",
  "workflows.card.runs": "{count} run",
  "workflows.card.runsPlural": "{count} runs",
  "workflows.card.edit": "Edit",
  "workflows.card.duplicate": "Duplicate",
  "workflows.card.export": "Export",
  "workflows.card.delete": "Delete",
  "workflows.card.enable": "Enable",
  "workflows.card.pause": "Pause",
  "workflows.card.paused": "Paused",
  "workflows.card.active": "Active",
  "workflows.toggle.failed": "Couldn't change that just now — try again.",
  "workflows.card.viewRuns": "View runs",
  "workflows.card.hideRuns": "Hide runs",
  "workflows.card.stopRun": "Stop",
  "workflows.match.anyMessage": "any message",
  "workflows.match.fromContact": "from {value}",
  "workflows.match.aContact": "a contact",
  "workflows.match.containing": 'containing "{value}"',
  "workflows.apps.searchPlaceholder": "Search all 1,000+ apps…",
  "workflows.apps.searching": "Searching…",
  "workflows.apps.noMatch": "No apps match.",
  "workflows.apps.connected": "connected",
  "workflows.apps.scopeEmpty": "Nothing picked → the workflow may use all your connected apps.",
  "workflows.apps.scopeFenced": "Fenced to {count} app(s). A dot = already connected.",
  "workflows.composer.source.chat": "From chat",
  "workflows.composer.source.comms": "Comms message",
  "workflows.composer.source.triggers": "Triggers",
  "workflows.composer.source.schedule": "Schedule",
  "workflows.composer.source.vault": "Vault folder",
  "workflows.composer.vault.hint":
    "Run this whenever a file lands in one of your vault folders — one run per file, told what the file is and what it says.",
  "workflows.composer.vault.loading": "Loading your folders…",
  "workflows.composer.vault.noFolders": "You have no vault folders yet.",
  "workflows.composer.vault.goToVault": "Make one in the Vault",
  "workflows.composer.vault.chip": "New file in {folder}",
  "workflows.composer.vault.unknownFolder": "a vault folder",
  "workflows.composer.whatsapp.selected":
    "This workflow runs when someone messages your personal WhatsApp. Add another match below, or remove it above.",
  "workflows.composer.whatsapp.hint":
    "Run this when someone messages your personal WhatsApp (any message, a specific contact, or a keyword).",
  "workflows.composer.chat.hint":
    "Already on — ask for this workflow by name in any chat and it runs. Nothing to set up here. Pick another source above if you also want it to start on its own.",
  "workflows.composer.addTrigger": "Add trigger",
  "workflows.composer.addSchedule": "Add schedule",
  "workflows.composer.discordNote":
    "Discord inbound needs a gateway bot (rolling out); saves now, fires once it lands.",
  "workflows.composer.noTriggersYet": "No triggers set up yet — turn some on in",
  "workflows.composer.settingsTriggers": "Settings › Triggers",
  "workflows.composer.thenPick": ", then pick them here.",
  "workflows.composer.tapApp": "Tap an app to attach its trigger. Manage the list in",
  "workflows.composer.schedule.next": "next: ",
  "workflows.composer.schedule.invalidCron": "Enter a valid cron to preview the next runs.",
  "workflows.composer.cadence.daily": "Every day",
  "workflows.composer.cadence.weekdays": "Weekdays",
  "workflows.composer.cadence.weekly": "Weekly",
  "workflows.composer.cadence.hourly": "Hourly",
  "workflows.composer.cadence.everyNMinutes": "Minutes",
  "workflows.composer.cadence.everyNHours": "Hours",
  "workflows.composer.cadence.custom": "Custom",
  "workflows.composer.every.prefix": "Every",
  "workflows.composer.every.minutes": "minutes",
  "workflows.composer.every.hours": "hours",
  "workflows.composer.atMinute": "at minute",
  "workflows.composer.atTime": "at",
  "workflows.composer.cronPlaceholder": "cron e.g. 0 9 * * 1-5",
  "workflows.composer.matchPlaceholder.contact": "contact / number / jid",
  "workflows.composer.matchPlaceholder.keyword": "keyword",
  "workflows.setup.back": "Workflows",
  "workflows.setup.overviewHint": "Its activity, triggers and runs at a glance.",
  "workflows.setup.triggers": "Triggers",
  "workflows.setup.runsFromChat": "Runs from chat.",
  "workflows.setup.apps": "Apps",
  "workflows.setup.allConnectedApps": "All connected apps",
  "workflows.setup.capabilities": "Capabilities · autonomy",
  "workflows.setup.appsOnly": "apps only",
  "workflows.setup.runs": "Runs",
  "workflows.setup.testRun": "Test run",
  "workflows.setup.noRunsYet":
    "No runs yet. Test-run it, or wait for a trigger to fire. Here's how the log will look:",
  "workflows.setup.runCompleted": "Completed",
  "workflows.setup.runFailed": "Failed — {error}",
  "workflows.setup.runFailedShort": "Failed",
  "workflows.setup.exampleRuns": "Example — real runs replace this",
  "workflows.setup.edit": "Edit",
  "workflows.setup.chat": "Chat",
  "workflows.setup.test": "Test",
  "workflows.setup.save": "Save",
  "workflows.setup.done": "Done",
  "workflows.setup.connect": "Connect",
  "workflows.setup.myWhatsapp": "My WhatsApp",
  "workflows.setup.runsFromChatAdd": "Runs from chat. Add triggers:",
  "workflows.setup.instruction": "Instruction",
  "workflows.setup.instructionPlaceholder": "What Morrow runs each time. Type it, or use Build.",
  "workflows.setup.editWithAi": "Edit with AI",
  "workflows.setup.clarifyBuild": "Clarify, then Build again:",
  "workflows.setup.buildWorkflow": "Build this workflow",
  "workflows.setup.skipManual": "Skip — build manually",
  "workflows.setup.send": "Send",
  "workflows.setup.chatEmpty":
    'Describe the workflow to build it, or ask for changes — e.g. "add a Slack ping", "only reply to Ali", "check my calendar first". I\'ll do it and tell you what changed.',
  "workflows.setup.chatWorking": "working…",
  "workflows.schedule.dow.0": "Sunday",
  "workflows.schedule.dow.1": "Monday",
  "workflows.schedule.dow.2": "Tuesday",
  "workflows.schedule.dow.3": "Wednesday",
  "workflows.schedule.dow.4": "Thursday",
  "workflows.schedule.dow.5": "Friday",
  "workflows.schedule.dow.6": "Saturday",
  "workflows.schedule.noSchedule": "(no schedule)",
  "workflows.schedule.everyHour": "Every hour at :{minute}",
  "workflows.schedule.everyMinute": "Every minute",
  "workflows.schedule.everyNMinutes": "Every {n} minutes",
  "workflows.schedule.everyNHours": "Every {n}h at :{minute}",
  "workflows.schedule.everyDayAt": "Every day at {time}",
  "workflows.schedule.everyWeekdayAt": "Every weekday at {time}",
  "workflows.schedule.everyDowAt": "Every {day} at {time}",
  "routines.title": "Routines",
  "routines.subtitle":
    "A workflow that runs on a schedule — set what it does and when, and it runs on its own.",
  "routines.new": "New routine",
  "routines.loading": "Loading…",
  "routines.empty": "No routines yet. Create one — a name, what it does, and when.",
  "routines.nameLabel": "Name",
  "routines.namePlaceholder": "Name — e.g. Morning briefing",
  "routines.descriptionPlaceholder":
    "What should it do? e.g. Summarize my unread emails and message me the highlights on WhatsApp.",
  "routines.whenItRuns": "When it runs",
  "routines.instructionLabel": "What it should do",
  "routines.nextRunLabel": "Next {when}",
  "routines.cancel": "Cancel",
  "routines.create": "Create routine",
  "routines.empty.title": "No routines yet",
  "routines.empty.description":
    "Name it, describe what it should do, and pick a schedule — Morrow builds the workflow from there.",
  "routines.newDialog.description":
    "A routine is a scheduled workflow. You can refine the flow after it's created.",
  "routines.nextRun": "· next {when}",
  "routines.deleteAria": "Delete routine's schedule",
  "routines.duplicateAria": "Duplicate routine",
  "workflows.canvas.kind.trigger": "Trigger",
  "workflows.canvas.kind.app": "App",
  "workflows.canvas.kind.browser": "Browser (your device)",
  "workflows.canvas.kind.cloudBrowser": "Cloud Browser",
  "workflows.canvas.kind.computer": "Cloud Computer",
  "workflows.canvas.kind.vault": "Vault",
  "workflows.canvas.kind.decision": "If / Else",
  "workflows.canvas.kind.foreach": "For each",
  "workflows.canvas.forEach.list": "List",
  "workflows.canvas.forEach.sourceSheet": "Rows of a Google Sheet",
  "workflows.canvas.forEach.sourceStep": "Items from an earlier step",
  "workflows.canvas.forEach.sheetLink": "Sheet link or ID",
  "workflows.canvas.forEach.sheetTab": "Tab name",
  "workflows.canvas.forEach.skipWhere": "Skip rows where",
  "workflows.canvas.forEach.column": "column",
  "workflows.canvas.forEach.value": "value",
  "workflows.canvas.forEach.eachItem": "For each item",
  "workflows.canvas.forEach.bodyBrowser": "In the browser",
  "workflows.canvas.forEach.bodyApp": "With a connected app",
  "workflows.canvas.forEach.bodyAi": "AI only (write, summarize)",
  "workflows.canvas.forEach.bodyPlaceholder":
    "e.g. Post the attached image to {item.Link} with no caption. Use {item.Column} for any column.",
  "workflows.canvas.forEach.atOnce": "How many at a time",
  "workflows.canvas.forEach.secondsApart": "sec apart",
  "workflows.canvas.forEach.onFailSkip": "If one fails: keep going",
  "workflows.canvas.forEach.onFailStop": "If one fails: stop",
  "workflows.canvas.forEach.saveTo": "Save each result to the sheet",
  "workflows.canvas.forEach.outcomeColumn": "Result column",
  "workflows.canvas.forEach.noteColumn": "Note column",
  "workflows.canvas.forEach.dryRun": "Dry run",
  "workflows.canvas.forEach.dryRunHint":
    "Goes up to the final click on each item but doesn't press it. Saves nothing.",
  "workflows.canvas.trigger.needsImage": "Needs an image to run",
  "workflows.canvas.trigger.needsAttachment": "Needs an attachment to run",
  "workflows.canvas.trigger.att.any": "Any file",
  "workflows.canvas.trigger.att.image": "Image",
  "workflows.canvas.trigger.att.document": "Document",
  "workflows.canvas.forEach.bodyEmptyTitle": "Runs for every item",
  "workflows.canvas.forEach.bodyEmptyHint": "Add the step(s) to do per item. They run in parallel.",
  "workflows.canvas.forEach.addStep": "Add step",
  "workflows.canvas.forEach.summary": "{n} at a time · {fail}",
  "workflows.canvas.forEach.perItem": "For each item",
  "workflows.canvas.kind.output": "Output",
  "workflows.canvas.delete": "Delete",
  "workflows.canvas.editTriggers": "Edit triggers",
  "workflows.canvas.edit": "Edit",
  "workflows.canvas.insertTitle": "Insert a step here",
  "workflows.canvas.insertApp": "+ App",
  "workflows.canvas.insertBrowser": "+ Browser",
  "workflows.canvas.insertDecision": "+ If/Else",
  "workflows.canvas.feedsData": "Feeds data",
  "workflows.canvas.feedsDataOn": "✓ Feeds data",
  "workflows.canvas.dependsHint":
    "Make this an EXPLICIT data source: its output is fed into the next step before that step runs. (A plain edge already passes output along; this names it as data.)",
  "workflows.canvas.dependsEdgeTitle": "Explicit data source — click to edit",
  "workflows.canvas.modelGate": "Gate · fast",
  "workflows.canvas.modelQuick": "Quick · fast",
  "workflows.canvas.modelFull": "Thorough",
  "workflows.canvas.modelFullTitle": "Thinks it through and can use tools",
  "workflows.canvas.chipGate": "Runs first · cheap",
  "workflows.canvas.chipRouter": "Picks one route · cheap",
  "workflows.canvas.chipLoopsBack": "Loops back to {target}",
  "workflows.canvas.chipUses": "Uses: {source}",
  "workflows.canvas.chipParallel": "Parallel-capable",
  "workflows.canvas.chipAgent": "Agent {n}",
  "workflows.canvas.agentHint":
    "Each step runs as its OWN agent turn (its colour) and sees only its sources' outputs — not a shared conversation. A decision runs on the cheap model either way: a plain yes/no check runs before the costly steps, while one with routes runs in its own place in the flow and picks what happens next.",
  "workflows.canvas.dependsHandle":
    "Depends on — drag another step's output here to feed its data in before this step runs. Multiple allowed.",
  "workflows.canvas.dependsHandleLabel": "depends",
  "workflows.canvas.removeEdge": "Disconnect",
  "workflows.canvas.removeApp": "Remove this app",
  "workflows.canvas.loopsBack": "loops back",
  "workflows.canvas.addAnotherApp": "Add another app…",
  "workflows.setup.branchKept":
    "Kept your branching flow. The AI builder can only draw a straight line, so applying its version would have deleted your routes and loop — the rest of its changes were applied.",
  "workflows.canvas.appModeAll": "Needs both",
  "workflows.canvas.appModeAny": "Either one",
  "workflows.canvas.removeEdgeHint":
    "Remove this connection. The steps stay; only the link between them goes.",
  "workflows.canvas.close": "Close",
  "workflows.canvas.routes.title": "Routes",
  "workflows.canvas.routes.hint":
    "This step picks ONE route. Drag a route's own dot to whatever should run next — point one back at an earlier step to loop.",
  "workflows.canvas.routes.add": "Add a route",
  "workflows.canvas.routes.remove": "Remove this route",
  "workflows.canvas.routes.label": "Name",
  "workflows.canvas.routes.labelPlaceholder": "More rows",
  "workflows.canvas.routes.when": "Take it when",
  "workflows.canvas.routes.enable": "Let this step choose between routes",
  "workflows.canvas.routes.enableHint":
    "Instead of just stopping the flow, give it named exits you can wire up separately.",
  "workflows.canvas.routes.moreDefault": "More to do",
  "workflows.canvas.routes.doneDefault": "Finished",
  "workflows.canvas.routes.loopsTo": "loops back",
  "workflows.canvas.routes.when.hasMoreItems": "Items are still left",
  "workflows.canvas.routes.when.contains": "The result mentions",
  "workflows.canvas.routes.when.notContains": "The result doesn't mention",
  "workflows.canvas.routes.when.ask": "Let the model judge",
  "workflows.canvas.routes.when.always": "Anything else",
  "workflows.canvas.routes.valuePlaceholder": "BLOCKED",
  "workflows.canvas.routes.askPlaceholder": "Did the post actually go live?",
  "workflows.canvas.routes.orderHint": "Checked top to bottom — the first match wins.",
  "workflows.canvas.routes.maxPasses": "Loop limit",
  "workflows.canvas.routes.maxPassesHint":
    "How many times round before it stops and reports what it managed. Keeps a loop that never drains from running forever.",
  "workflows.canvas.end.whenDone": "When done",
  "workflows.canvas.end.modeMessage": "Send a message",
  "workflows.canvas.end.modeSave": "Save to Vault",
  "workflows.canvas.end.modeWebhook": "Call a webhook",
  "workflows.canvas.end.modeNone": "Just finish (no message)",
  "workflows.canvas.end.webhookPlaceholder": "https://… (POST the result here)",
  "workflows.canvas.insp.close": "Close",
  "workflows.canvas.insp.instruction": "This step's instruction",
  "workflows.canvas.insp.notes": "Notes (optional)",
  "workflows.canvas.insp.instructionPlaceholder": "What this step should do…",
  "workflows.canvas.insp.model": "How carefully to think",
  "workflows.canvas.insp.modelFast": "Quick",
  "workflows.canvas.insp.modelHint":
    "Thorough can use tools and handle a step with judgement in it. Quick is a cheap yes/no-grade check — far cheaper and faster, but it can't use tools, so only pick it for a simple sort-or-classify step.",
  "workflows.canvas.insp.decisionModelNote":
    "A decision always runs the quick way, and a plain yes/no check like this one runs before the expensive steps — so an irrelevant run costs almost nothing.",
  "workflows.canvas.insp.routerModelNote":
    "A decision always runs the quick way. This one has routes, so it runs where it sits in the flow — after the steps feeding it — and picks which route goes next.",
  "workflows.canvas.insp.uses": "What this step reads",
  "workflows.canvas.insp.removeSource": "Stop reading this step",
  "workflows.canvas.insp.noSources":
    "Just the step before it. Add a step below to also read something from earlier in the flow.",
  "workflows.canvas.insp.addSource": "Also read a step…",
  "workflows.canvas.insp.waitsHint":
    "This step waits for its sources' data, then sees each one labeled by name.",
  "workflows.canvas.insp.parallelHint":
    "This step runs after the previous step and receives its output.",
  "workflows.canvas.insp.outputs": "Named outputs",
  "workflows.canvas.insp.outputsHint":
    "Fields a later step can read as {{ThisStep.field}}. This step is asked to end its reply with a JSON object of exactly these keys.",
  "workflows.canvas.insp.outputsPlaceholder": "Add a field, e.g. price — Enter",
  "workflows.canvas.insp.removeOutput": "Remove field",
  "workflows.canvas.insp.forEachSource": "List to loop over",
  "workflows.canvas.insp.forEachSourceHint":
    "Which source's output is the list this step iterates over.",
  "workflows.canvas.addKind": "Add {kind}",
  "workflows.canvas.chooseApp": "Choose an app…",
  "workflows.canvas.searchApps": "Search 1000+ apps…",
  "workflows.canvas.noConnectedApps": "No connected apps — type to search all.",
  "workflows.canvas.noMatches": "No matches.",
  "workflows.canvas.badgePersonal": "personal",
  "workflows.canvas.appDoInOrder": "Do, in order",
  "workflows.canvas.appActionPlaceholder": "e.g. read latest emails",
  "workflows.canvas.removeAction": "Remove action",
  "workflows.canvas.thenMore": "then…",
  "workflows.canvas.browserPlaceholder":
    "What to do on the web — e.g. open the CRM and grab the lead's status",
  "workflows.canvas.cloudBrowserPlaceholder":
    "What to do on the web (managed browser, no device needed) — e.g. log in and export the report",
  "workflows.canvas.computerPlaceholder":
    "What to run — e.g. call this API and parse the JSON, or process the uploaded file",
  "workflows.canvas.outputPlaceholder":
    "What comes out — e.g. reply to the person / message me the free slots",
  "workflows.canvas.sendOn": "Send on",
  "workflows.canvas.autonomous":
    "Keep working it (reply back-and-forth, don't stop after one message)",
  "workflows.canvas.decisionHint": "Continue only if this is true — otherwise stop the flow.",
  "workflows.canvas.routes.cardHint":
    "Goes ONE way. Drag a route's dot to what runs next — drag one back to an earlier step and it loops.",
  "workflows.canvas.decisionPlaceholder":
    "e.g. the email is from someone at Summing / the message is about a meeting",
  "workflows.canvas.vaultPickFiles": "Pick files it can use",
  "workflows.canvas.vaultFilesSelected": "{count} file selected",
  "workflows.canvas.vaultFilesSelectedPlural": "{count} files selected",
  "workflows.canvas.vaultEmpty":
    "No files in your Vault yet — add them in the Vault, then tick the ones it can use here.",
  "workflows.canvas.defaultTrigger": "From chat / a trigger",
  "workflows.canvas.defaultNewTrigger": "New trigger",
  "workflows.setup.fromChat": "From chat",
  "workflows.setup.fromChatTrigger": "From chat / a trigger",
  "workflows.setup.defaultOutputText": "Message me the result",
  "workflows.setup.eventFallback": "event",
  "workflows.setup.notFound": "Workflow not found.",
  "workflows.setup.loadingWorkflow": "Loading workflow…",
  "workflows.setup.runsTab": "Runs",
  "workflows.setup.runsTabCount": "Runs ({count})",
  "workflows.setup.noRunsChat": "No runs yet. Hit Test, or wait for a trigger to fire.",
  "workflows.setup.chatAiPlaceholder": "Ask AI to build or change it…",
  "workflows.setup.plan.buildingTitle": "Building your workflow…",
  "workflows.setup.plan.understandingTitle": "Understanding your request…",
  "workflows.setup.plan.buildingBody": "Turning the plan into triggers, steps and instructions.",
  "workflows.setup.plan.understandingBody":
    "Reading your description, cleaning it up, and deciding what it needs.",
  "workflows.setup.plan.heresThePlan": "Here's the plan",
  "workflows.setup.plan.startsWhen": "Starts when",
  "workflows.setup.plan.tools": "Tools it'll use",
  "workflows.setup.plan.howItWorks": "How it'll work",
  "workflows.setup.plan.worthClarifying": "Worth clarifying",
  "workflows.setup.plan.clarifyHint":
    "Answer these in the chat below, or build now and refine after.",
  "workflows.setup.plan.chatTitle": "Chat — refine the plan",
  "workflows.setup.plan.thinking": "thinking…",
  "workflows.setup.plan.inputPlaceholder": "Ask for changes or answer its questions…",
  "workflows.setup.toast.typeIntent": "Type what it should do, then Build.",
  "workflows.setup.toast.couldNotBuild":
    "Couldn't build right now — check the model relay, or add steps manually.",
  "workflows.setup.toast.builtEndToEnd":
    "Built end-to-end — triggers, flow and instruction are set. Test it.",
  "workflows.setup.toast.builtLive": "Built it — triggers, flow and steps are set. It's live.",
  "workflows.setup.toast.couldNotBuildShort":
    "Couldn't build right now — try again, or add steps manually.",
  "workflows.setup.toast.saved": "Saved — this workflow is live.",
  "workflows.setup.toast.buildFirst": "Build the flow first (add steps, or draft with AI).",
  "workflows.setup.toast.couldNotRun": "Couldn't start the run.",
  "workflows.setup.missing.prefix": "To run this you still need to:",
  "workflows.setup.missing.connect": "connect {apps}",
  "workflows.setup.missing.pickApp": "pick an app for the empty steps",
  "workflows.canvas.channel.any": "Any / let it decide",
  "workflows.canvas.channel.personalWhatsapp": "WhatsApp — my personal (connection)",
  "workflows.canvas.channel.whatsapp": "WhatsApp — comms",
  "workflows.canvas.channel.telegram": "Telegram — comms",
  "workflows.canvas.channel.slack": "Slack — comms",
  "workflows.canvas.channel.discord": "Discord — comms",
  "workflows.canvas.channel.chat": "Morrow chat",
  "settings.search.organization": "Organization",
  "settings.search.organizationMembers": "Members and roles",
  "settings.search.packages": "Packages",
  "settings.search.packagesAddons": "Add-ons & credit funds",
  "settings.search.archive": "Archived threads",
  "settings.search.helpCenter": "Help Center",
  "settings.search.submitRequest": "Submit a request",
  "settings.search.systemStatus": "System status",
  "settings.search.supportSetup": "Setup & getting started",
  "settings.search.supportIntegrations": "Integrations",
  "settings.search.supportMemory": "Company memory",
  "settings.search.supportSecurity": "Security & privacy",
  "settings.search.supportBilling": "Billing & plans",
  "settings.search.supportFaq": "FAQ",
  "settings.search.supportEmail": "General support",
  "settings.search.supportSecurityEmail": "Security contact",
  "settings.search.supportLegalEmail": "Legal contact",
  "settings.search.supportPhone": "Phone",
  "settings.search.supportBookCall": "Book a call",
  "settings.search.privacyPolicy": "Privacy Policy",
  "settings.search.termsOfService": "Terms of Service",
  "settings.search.dpa": "Data Processing Addendum",
  "settings.search.cookiePolicy": "Cookie Policy",
  "settings.search.trustCenter": "Trust Center",
  "settings.search.legalCompany": "Enortic, Inc.",
  "settings.language.description": "Interface language. System default follows your browser or OS.",
  "settings.timeFormat.description": "System default follows your browser or OS clock preference.",
  "settings.timeFormat.12hour": "12-hour",
  "settings.timeFormat.24hour": "24-hour",
  "settings.timeFormat.aria": "Timestamp format",
  "settings.glassOpacity.description":
    "Control how transparent glass surfaces are. Higher values make menus, dialogs, and the composer more solid.",
  "settings.environmentIdentification.description":
    "Choose how Dev and Nightly environments are identified.",
  "settings.environmentIdentification.artwork": "Artwork",
  "settings.environmentIdentification.pill": "Version pill",
  "settings.environmentIdentification.none": "None",
  "settings.interfaceFont.description": "The font used across the whole MorrowOS interface.",
  "settings.interfaceFont.size": "Interface font size",
  "settings.promptFont.description": "Only the box you write prompts in. Mono works well here.",
  "settings.promptFont.size": "Prompt font size",
  "settings.fontSmoothing.description":
    "Render text with thinner grayscale anti-aliasing instead of macOS's heavier default.",
  "settings.archiveConfirmation.description":
    "Require a second click on the inline archive action before a thread is archived.",
  "settings.deleteConfirmation.description": "Ask before deleting a thread and its chat history.",
  "settings.textGenerationModel.description":
    "Default model for generated text like thread titles.",
  "settings.about.version": "Current version of the application.",
  "settings.diagnostics.view": "View diagnostics",
  "settings.appearance.mode": "Appearance mode",
  "settings.appearance.system": "System",
  "settings.appearance.light": "Light",
  "settings.appearance.dark": "Dark",
  "settings.appearance.followSystem": "Follow the system appearance",
  "settings.appearance.useLight": "Use light mode",
  "settings.appearance.useDark": "Use dark mode",
  "settings.appearance.intro": "Choose how MorrowOS looks. Use a built-in theme or make your own.",
  "settings.appearance.createTheme": "Create theme",
  "settings.appearance.importTheme": "Import theme",
  "settings.typography": "Typography",
  "settings.reset.language": "language",
  "settings.reset.timeFormat": "time format",
  "settings.reset.toDefault": "Reset to default",
  "settings.reset.aria": "Reset {label} to default",
  "settings.reset.glassOpacity": "glass opacity",
  "settings.reset.environmentIdentification": "environment identification",
  "settings.reset.fontSmoothing": "font smoothing",
  "settings.reset.backgroundActivity": "background activity",
  "settings.reset.archiveConfirmation": "archive confirmation",
  "settings.reset.deleteConfirmation": "delete confirmation",
  "settings.reset.textGenerationModel": "text generation model",
  "settings.glassOpacity.aria": "Glass opacity",
  "settings.fontSmoothing.aria": "Font smoothing",
  "settings.archiveConfirmation.aria": "Confirm thread archiving",
  "settings.deleteConfirmation.aria": "Confirm thread deletion",
  "settings.backgroundActivity": "Background activity",
  "settings.backgroundActivity.balanced": "Balanced",
  "settings.backgroundActivity.performance": "Performance",
  "settings.backgroundActivity.batterySaver": "Battery saver",
  "settings.backgroundActivity.advanced": "Advanced",
  "settings.backgroundActivity.description.balanced":
    "Pauses background probes when clients are idle, the host is locked, or low power mode is active.",
  "settings.backgroundActivity.description.performance":
    "Allows scoped background probes while any subscribed client remains connected.",
  "settings.backgroundActivity.description.batterySaver":
    "Also pauses background probes when the host or client is on battery.",
  "settings.backgroundActivity.description.advanced":
    "Uses custom background intervals with the selected shared power policy.",
  "settings.backgroundActivity.description.advancedCurrent":
    "{description} Current shared policy: {policy}.",
  "settings.backgroundActivity.policyTooltip":
    "This shared policy gates background work such as Git refreshes and provider health probes after their individual intervals elapse.",
  "settings.backgroundActivity.aria": "Background activity profile",
  "settings.backgroundActivity.configure": "Configure background activity",
  "settings.backgroundActivity.configureAria": "Configure advanced background activity",
  "settings.backgroundActivity.dialogTitle": "Background activity",
  "settings.backgroundActivity.dialogDescription":
    "Tune the shared power policy and the background intervals that feed it.",
  "settings.backgroundActivity.sharedPolicy": "Shared policy",
  "settings.backgroundActivity.sharedPolicyDescription":
    "Controls whether background work may run after a subscribed interval fires.",
  "settings.backgroundActivity.sharedPolicyAria": "Shared background policy",
  "settings.backgroundActivity.gitFetch": "Git fetch interval",
  "settings.backgroundActivity.gitFetchDescription":
    "Refresh remote branch status in the background.",
  "settings.backgroundActivity.gitFetchDecrease": "Decrease Git fetch interval",
  "settings.backgroundActivity.gitFetchInput": "Git fetch interval in seconds",
  "settings.backgroundActivity.gitFetchIncrease": "Increase Git fetch interval",
  "settings.backgroundActivity.providerHealth": "Provider health interval",
  "settings.backgroundActivity.providerHealthDescription":
    "Refresh provider availability, versions, auth state, and model metadata.",
  "settings.backgroundActivity.providerHealthDecrease": "Decrease provider health interval",
  "settings.backgroundActivity.providerHealthInput": "Provider health interval in seconds",
  "settings.backgroundActivity.providerHealthIncrease": "Increase provider health interval",
  "settings.backgroundActivity.hostPower": "Host power monitor",
  "settings.backgroundActivity.hostPowerDescription":
    "Poll host power state while clients are active.",
  "settings.backgroundActivity.hostPowerDecrease": "Decrease active host power interval",
  "settings.backgroundActivity.hostPowerInput": "Active host power interval in seconds",
  "settings.backgroundActivity.hostPowerIncrease": "Increase active host power interval",
  "settings.backgroundActivity.idleHost": "Idle host monitor",
  "settings.backgroundActivity.idleHostDescription":
    "Poll host power state when no foreground client is active.",
  "settings.backgroundActivity.idleHostDecrease": "Decrease idle host power interval",
  "settings.backgroundActivity.idleHostInput": "Idle host power interval in seconds",
  "settings.backgroundActivity.idleHostIncrease": "Increase idle host power interval",
  "settings.backgroundActivity.seconds": "seconds",
  "settings.backgroundActivity.pauseHostLocked": "Pause when host is locked",
  "settings.backgroundActivity.pauseHostLowPower": "Pause on host low power",
  "settings.backgroundActivity.pauseClientLowPower": "Pause on client low power",
  "settings.backgroundActivity.pauseOnBattery": "Pause on battery",
  "settings.backgroundActivity.resetAll": "Reset all",
  "settings.backgroundActivity.policyDetails": "Background policy details",
  "settings.archive.loading": "Loading archived threads",
  "settings.archive.loadError": "Could not load archived threads",
  "settings.archive.empty": "No archived threads",
  "settings.archive.checking": "Checking connected environments.",
  "settings.archive.emptyDescription": "Archived threads will appear here.",
  "settings.archive.unarchive": "Unarchive",
  "settings.archive.delete": "Delete",
  "settings.archive.archivedRelative": "Archived {time}",
  "settings.archive.createdRelative": "Created {time}",
  "settings.archive.unarchiveFailed": "Failed to unarchive thread",
  "settings.archive.deleteFailed": "Failed to delete thread",
  "settings.archive.actionFailed": "Archived thread action failed",
  "settings.archive.errorOccurred": "An error occurred.",
  "settings.organization.signIn": "Sign in to manage organizations.",
  "settings.organization.personalAccount":
    "You're currently using your personal account. Create or select an organization from the switcher in the sidebar to invite members and manage roles.",
  "settings.organization.disabled":
    "Organizations aren't enabled for this instance. Enable Organizations in your Clerk dashboard to create teams, invite members, and manage roles.",
  "settings.organization.personal": "Personal account",
  "settings.organization.currentDescription":
    "The organization your workspace is currently active in.",
  "settings.organization.manageAction": "Manage",
  "settings.organization.switchTitle": "Switch organization",
  "settings.organization.switchDescription":
    "Change which organization is active, or switch back to your personal account.",
  "settings.organization.createTitle": "Create organization",
  "settings.organization.createDescription":
    "Start a new organization to collaborate with your team.",
  "settings.organization.createAction": "Create",
  "settings.organization.changeLogo": "Change logo",
  "settings.organization.changeLogoDescription":
    "Upload a square image to represent your organization across MorrowOS.",
  "settings.organization.uploadingLogo": "Uploading…",
  "settings.organization.pageDescription": "Manage your team, roles, and organization identity.",
  "settings.organization.membersTitle": "Members and roles",
  "settings.organization.membersDescription":
    "Invite teammates, assign roles, and manage who has access.",
  "settings.organization.roleAdmin": "Admin",
  "settings.organization.roleMember": "Member",
  "settings.organization.memberCount": "{count} members",
  "settings.organization.inviteTitle": "Invite member",
  "settings.organization.inviteDescription": "Send an email invitation to join this organization.",
  "settings.organization.inviteEmailPlaceholder": "name@company.com",
  "settings.organization.inviteAction": "Invite",
  "settings.organization.inviting": "Inviting…",
  "settings.organization.inviteFailed": "Could not send invitation. Try again.",
  "settings.organization.noMembers": "No members yet.",
  "settings.organization.pendingInvitations": "Pending invitations",
  "settings.organization.revokeInvitation": "Revoke",
  "settings.organization.removeMember": "Remove {name}",
  "settings.organization.changeRole": "Change role for {name}",
  "settings.providers.description":
    "A read-only overview of the models MorrowOS can run, grouped by company across Cloudflare Workers AI and AWS Bedrock. Adding your own provider keys isn't available yet.",
  "settings.providers.comingSoon": "Coming soon",
  "settings.providers.moreOnTheWay": "More providers on the way",
  "settings.providers.requestAccess": "Request early access and we'll notify you when they land.",
  "settings.providers.soon": "Soon",
  "settings.providers.models": "{count} models",
  "settings.providers.model": "{count} model",
  "settings.keybindings.search": "Search keybindings",
  "settings.keybindings.add": "Add keybinding",
  "settings.keybindings.openFile": "Open keybindings.json",
  "settings.keybindings.browserWarning":
    "Some shortcuts may be claimed by the browser before MorrowOS sees them. Use the desktop app for better keybinding support.",
  "settings.keybindings.binding": "{count} binding",
  "settings.keybindings.bindings": "{count} bindings",
  "settings.about.versionLabel": "Version",
  "settings.support.open": "Open",
  "settings.support.email": "Email",
  "settings.support.call": "Call",
  "settings.support.getHelp": "Get help",
  "settings.support.helpCenter.description":
    "Browse setup, memory, integrations, billing, and enterprise topics.",
  "settings.support.submitRequest.description":
    "Open a 30-minute support request. We’ll route it to the right team.",
  "settings.support.systemStatus.description": "Component health and incident updates for Morrow.",
  "settings.support.topics": "Help topics",
  "settings.support.topic.setup.description":
    "First project, team invites, roles, and how Mor starts from company memory.",
  "settings.support.topic.integrations.description":
    "Connect Slack, Jira, GitHub, Notion, and the rest of the catalog.",
  "settings.support.topic.memory.description":
    "What gets written, who can see it, exporting, and wiping a project.",
  "settings.support.topic.security.description":
    "Local-first data, KVKK, requesting a DPA, SSO, and model-training policy.",
  "settings.support.topic.billing.description":
    "Seats, integrations, invoices, cancellation, and deleting cloud data.",
  "settings.support.topic.faq.description": "Common questions about Morrow and company memory.",
  "settings.support.contact": "Contact",
  "settings.support.bookCall.description":
    "Share details for a faster response; our team will take it from there.",
  "settings.legal.documents": "Documents",
  "settings.legal.privacy.description":
    "How Enortic collects, uses, and protects personal data when you use Morrow.",
  "settings.legal.terms.description": "Terms that govern use of Morrow and the Morrow website.",
  "settings.legal.dpa.description":
    "Data processing addendum for cloud, managed, and shared-workspace use.",
  "settings.legal.cookies.description": "How cookies are used on the Morrow website.",
  "settings.legal.trust.description": "Security, access, encryption, and compliance for Morrow.",
  "settings.legal.company": "Company",
  "settings.legal.company.description":
    "Enortic, Inc., a Delaware corporation. Dover, DE 19904, United States.",

  "onboarding.stepOf": "Step {current} of {total}",
  "onboarding.accountType.title": "How will you use Morrow?",
  "onboarding.accountType.subtitle": "Pick one — you can change it later.",
  "onboarding.accountType.individual": "Just me",
  "onboarding.accountType.individualHint": "A personal workspace connected to your own apps.",
  "onboarding.accountType.company": "My company",
  "onboarding.accountType.companyHint": "Create an organization and invite your team.",
  "onboarding.company.title": "Your company",
  "onboarding.company.subtitle":
    "A name, a logo, and a website or LinkedIn page so Morrow can get to know you.",
  "onboarding.tools.title": "Connect your tools",
  "onboarding.tools.subtitle": "Hook up one app now. You can add the rest later from Settings.",
  "onboarding.invite.title": "Invite the team",
  "onboarding.invite.subtitle": "Bring people in after the workspace has a name and a tool.",
  "onboarding.companyName": "Company name",
  "onboarding.website": "Website or LinkedIn",
  "onboarding.websitePlaceholder": "acme.com or linkedin.com/company/acme",
  "onboarding.websiteError": "Enter a valid link, like acme.com or a LinkedIn page",
  "onboarding.inviteError": "That doesn’t look like an email",
  "onboarding.connectedCount": "{connected} of {total} connected",
  "onboarding.addEmail": "Add email",
  "onboarding.removeEmail": "Remove {email}",
  "onboarding.addEmailsHint": "Add emails, or skip for now.",
  "onboarding.personTitle": "Title",
  "onboarding.personTitlePlaceholder": "Product lead",
  "onboarding.personRole": "Role",
  "onboarding.personRolePlaceholder": "Product",
  "onboarding.invitePerson.email": "Email",
  "onboarding.invitePerson.title": "Title",
  "onboarding.invitePerson.titlePlaceholder": "Product lead",
  "onboarding.invitePerson.function": "What they do",
  "onboarding.invitePerson.functionPlaceholder": "e.g. Runs growth marketing",
  "onboarding.invitePerson.description": "About",
  "onboarding.invitePerson.descriptionPlaceholder": "What they do here",
  "onboarding.invitePerson.access": "Access level",
  "onboarding.invitePerson.add": "Add",
  "onboarding.pendingInvite": "Invited",
  "onboarding.signInToInvite": "Sign in to send invites. You can still skip and do this later.",
  "onboarding.sendAndStart": "Send and start",
  "onboarding.startChatting": "Start chatting",
  "onboarding.teamFallback": "My team",
  "onboarding.orgLogo": "Logo",
  "onboarding.orgLogoAdd": "Add a logo",
  "onboarding.orgLogoChange": "Change logo",
  "onboarding.orgExisting": "Using your existing organization {name}.",
  "onboarding.orgDisabled":
    "Organizations aren’t enabled yet, so we saved this locally. You can still continue.",
  "onboarding.lookingUpCompany": "Looking up the company…",
  "onboarding.connectCap": "Upgrade to a paid plan to connect more than {max} apps.",
  "onboarding.profile.title": "Tell us about you",
  "onboarding.profile.subtitle":
    "A couple of quick answers so Morrow can tailor itself to your work.",
  "onboarding.profile.role": "Your role",
  "onboarding.profile.rolePlaceholder": "Founder, engineer, marketer…",
  "onboarding.profile.roleOption.founder": "Founder",
  "onboarding.profile.roleOption.ceo": "CEO",
  "onboarding.profile.roleOption.cto": "CTO",
  "onboarding.profile.roleOption.engineer": "Engineer",
  "onboarding.profile.roleOption.devops": "DevOps",
  "onboarding.profile.roleOption.product": "Product manager",
  "onboarding.profile.roleOption.designer": "Designer",
  "onboarding.profile.roleOption.marketer": "Marketer",
  "onboarding.profile.roleOption.sales": "Sales",
  "onboarding.profile.roleOption.operations": "Operations",
  "onboarding.profile.roleOption.projectManager": "Project manager",
  "onboarding.profile.roleOption.customerSuccess": "Customer success",
  "onboarding.profile.roleOption.dataAnalyst": "Data analyst",
  "onboarding.profile.roleOption.hr": "HR",
  "onboarding.profile.roleOption.finance": "Finance",
  "onboarding.profile.roleOption.legal": "Legal",
  "onboarding.profile.roleOption.support": "Support",
  "onboarding.profile.roleOption.content": "Content creator",
  "onboarding.profile.roleOption.consultant": "Consultant",
  "onboarding.profile.roleOption.freelancer": "Freelancer",
  "onboarding.profile.roleOption.student": "Student",
  "onboarding.profile.industry": "Industry",
  "onboarding.profile.industryPlaceholder": "SaaS, agency, e-commerce…",
  "onboarding.profile.industryOption.saas": "SaaS",
  "onboarding.profile.industryOption.startup": "Startup",
  "onboarding.profile.industryOption.technology": "Technology",
  "onboarding.profile.industryOption.agency": "Agency",
  "onboarding.profile.industryOption.marketing": "Marketing",
  "onboarding.profile.industryOption.ecommerce": "E-commerce",
  "onboarding.profile.industryOption.retail": "Retail",
  "onboarding.profile.industryOption.consulting": "Consulting",
  "onboarding.profile.industryOption.finance": "Finance",
  "onboarding.profile.industryOption.insurance": "Insurance",
  "onboarding.profile.industryOption.healthcare": "Healthcare",
  "onboarding.profile.industryOption.education": "Education",
  "onboarding.profile.industryOption.media": "Media",
  "onboarding.profile.industryOption.gaming": "Gaming",
  "onboarding.profile.industryOption.realEstate": "Real estate",
  "onboarding.profile.industryOption.manufacturing": "Manufacturing",
  "onboarding.profile.industryOption.logistics": "Logistics",
  "onboarding.profile.industryOption.hospitality": "Hospitality",
  "onboarding.profile.industryOption.foodBeverage": "Food & beverage",
  "onboarding.profile.industryOption.travel": "Travel",
  "onboarding.profile.industryOption.construction": "Construction",
  "onboarding.profile.industryOption.energy": "Energy",
  "onboarding.profile.industryOption.fashion": "Fashion",
  "onboarding.profile.industryOption.legal": "Legal",
  "onboarding.profile.industryOption.nonprofit": "Nonprofit",
  "onboarding.profile.industryOption.government": "Government",
  "onboarding.profile.teamSize": "Team size",
  "onboarding.profile.teamSizePlaceholder": "Select a size",
  "onboarding.profile.goal": "What do you want help with?",
  "onboarding.profile.goalPlaceholder": "Draft emails, plan my week…",

  "landing.greeting": "Ready when you are, {name}.",
  "landing.subtitle": "Ask anything, or start with one of these.",
  "landing.quickPicks": "Quick starts",
  "landing.cta": "Let's do this",
  "landing.connectApp": "Connect {app} to run this",

  "authWelcome.title": "Hey, I'm Morrow.",
  "authWelcome.subtitle":
    "Your company's AI operator. Connect your tools and I'll turn what's already in email, Slack, and your CRM into briefings, drafts, and plans you can act on today.",
  "authWelcome.outcomesHeading": "What I'll do for your company",
  "authWelcome.trial.badge": "7-day free trial",
  "authWelcome.trial.tagline": "Start with a real briefing for your company — free for 7 days.",
  "authWelcome.cta": "Start your free trial",
  "authWelcome.reassure": "Free to start · Cancel anytime, no strings attached",
  "authWelcome.signin.prompt": "Already have an account?",
  "authWelcome.signin.link": "Sign in",
  "authWelcome.outcome.briefing.title": "Reach your customers",
  "authWelcome.outcome.briefing.desc":
    "Write outreach and follow-up emails — ready to send, to the right people.",
  "authWelcome.outcome.pipeline.title": "Post on social",
  "authWelcome.outcome.pipeline.desc":
    "Create posts, add visuals, and publish or schedule them for you.",
  "authWelcome.outcome.align.title": "Schedule meetings",
  "authWelcome.outcome.align.desc":
    "Book customer calls, send invites, and add them to your calendar.",
  "landing.suggest.siteClause": " Use {website} as the source.",
  "landing.suggest.briefClause": " What we know: {brief}",
  "landing.suggest.income": "Income statement",
  "landing.suggest.expenses": "Expenses",
  "landing.suggest.invoices": "Invoices",
  "landing.suggest.incomeDesc": "What came in this month",
  "landing.suggest.expensesDesc": "What went out this month",
  "landing.suggest.invoicesDesc": "What's owed and what's due",
  "landing.suggest.report": "Weekly report",
  "landing.suggest.marketingPlan": "Marketing plan",
  "landing.suggest.productBrief": "Product brief",
  "landing.suggest.pipeline": "Sales plan",
  "landing.suggest.competitors": "Competitive look",
  "landing.suggest.thisWeek": "This week's plan",
  "landing.suggest.campaign": "Campaign idea",
  "landing.suggest.brand": "Brand brief",
  "landing.suggest.nextShip": "What to ship next",
  "landing.suggest.outreach": "Outreach draft",
  "landing.suggest.week": "Plan my week",
  "landing.suggest.email": "Write an email",
  "landing.suggest.decide": "Help me decide",
  "landing.suggest.write": "Write something",
  "landing.suggest.incomePrompt":
    "Put together my income statement for this month. Ask what you need, then lay it out simply.",
  "landing.suggest.expensesPrompt":
    "List and summarize my expenses for this month. Ask what you need first.",
  "landing.suggest.invoicesPrompt":
    "Help me track invoices — what's owed, what's due, and what to send next.",
  "landing.suggest.reportDesc": "The week's numbers, wins, and what's stuck",
  "landing.suggest.marketingPlanDesc": "A focused plan to grow reach this month",
  "landing.suggest.productBriefDesc": "Shape the next feature into a clear brief",
  "landing.suggest.pipelineDesc": "A plan to move deals forward",
  "landing.suggest.competitorsDesc": "See how you stack up against rivals",
  "landing.suggest.thisWeekDesc": "The few things that matter this week",
  "landing.suggest.campaignDesc": "One sharp idea you can ship soon",
  "landing.suggest.brandDesc": "Voice, look, and promise in one place",
  "landing.suggest.nextShipDesc": "Decide what deserves to go out next",
  "landing.suggest.outreachDesc": "A warm, personal first message",
  "landing.suggest.weekDesc": "Turn a busy week into a clear plan",
  "landing.suggest.emailDesc": "A few clear lines",
  "landing.suggest.decideDesc": "Weigh the options and pick a path",
  "landing.suggest.writeDesc": "Draft something worth sharing",
  "landing.suggest.memory": "What you remember",
  "landing.suggest.meetingPrep": "Meeting prep",
  "landing.suggest.standup": "Standup",
  "landing.suggest.vaultSearch": "Find a doc",
  "landing.suggest.memoryDesc": "Goals and context in one place",
  "landing.suggest.meetingPrepDesc": "Walk in prepared",
  "landing.suggest.standupDesc": "Yesterday, today, blockers",
  "landing.suggest.vaultSearchDesc": "Hunt down the file you need",
  "landing.suggest.reportPrompt":
    "Write a weekly report for {name}.{site} Cover what's working, what's stuck, and the next three actions.",
  "landing.suggest.marketingPlanPrompt":
    "Draft a 30-day marketing plan for {name}.{site} Include audience, offer, channels, and one campaign to run first.",
  "landing.suggest.productBriefPrompt":
    "Turn {name} into a product brief.{site} Cover audience, offer, and the next ship.",
  "landing.suggest.pipelinePrompt":
    "Write a sales plan for {name}.{site} Who to sell to, the pitch, and the next five outreaches.",
  "landing.suggest.competitorsPrompt":
    "Who competes with {name}, and how should we position?{site}",
  "landing.suggest.thisWeekPrompt":
    "Plan my week. What matters, what can wait, and the first three moves.",
  "landing.suggest.campaignPrompt": "Propose one campaign {name} can ship in two weeks.{site}",
  "landing.suggest.brandPrompt":
    "Write a brand brief for {name}.{site} Voice, promise, and what to say next.",
  "landing.suggest.nextShipPrompt":
    "What should {name} ship next?{site} Scope, why now, and the first milestone.",
  "landing.suggest.outreachPrompt":
    "Draft outreach {name} can send this week.{site} Who, why them, and the message.",
  "landing.suggest.weekPrompt":
    "Plan my week. Prioritize what matters, what can wait, and the first three moves.",
  "landing.suggest.emailPrompt": "Help me write a clear email. Ask what I need, then draft it.",
  "landing.suggest.decidePrompt":
    "Help me decide. Lay out options, tradeoffs, and a recommendation.",
  "landing.suggest.writePrompt":
    "Help me write something I can send today. Keep it short and specific.",
  "landing.suggest.memoryPrompt":
    "What do you already know about {name}?{site} Summarize goals, context, and open threads I should keep in mind.",
  "landing.suggest.meetingPrepPrompt":
    "Prep me for today's meetings.{site} Pull context, likely questions, and three talking points.",
  "landing.suggest.standupPrompt":
    "Draft my standup for {name}.{site} Yesterday, today, blockers — keep it tight.",
  "landing.suggest.vaultSearchPrompt":
    "Help me find the right doc in Vault for {name}.{site} Ask what I need, then search and summarize matches.",

  "connect.connected": "Connected",
  "connect.connect": "Connect",
  "connect.connecting": "Connecting…",
  "connect.disconnect": "Disconnect",
  "connect.disconnectApp": "Disconnect {name}",
  "connect.logoAlt": "{name} logo",
  "connect.connectApp": "Connect {name}",

  "composer.placeholder": "Ask anything, or connect an app…",
  "composer.placeholderApproval": "Resolve this approval request to continue",
  "composer.placeholderPending":
    "Type your own answer, or leave this blank to use the selected option",
  "composer.placeholderPlan":
    "Add feedback to refine the plan, or leave this blank to implement it",
  "composer.placeholderChooseProject": "Choose a project above to start a thread",
  "composer.placeholderEnableProvider": "Enable a provider in Settings to send a message",
  "composer.send": "Send message",
  "composer.sending": "Sending",
  "composer.sendingEllipsis": "Sending...",
  "composer.connecting": "Connecting",
  "composer.preparingWorktree": "Preparing worktree",
  "composer.environmentDisconnected": "Environment disconnected",
  "composer.stop": "Stop generation",
  "workflowRun.badge": "Workflow",
  "workflowRun.stop": "Stop run",
  "workflowRun.finished": "Run finished",
  "workflowRun.statusRunning": "Running",
  "workflowRun.statusOk": "Completed",
  "workflowRun.statusFailed": "Failed",
  "workflowRun.statusSkipped": "Skipped",
  "composer.refine": "Refine",
  "composer.implement": "Implement",
  "composer.implementNewThread": "Implement in a new thread",
  "composer.implementationActions": "Implementation actions",
  "composer.submit": "Submit",
  "composer.next": "Next",
  "composer.nextQuestion": "Next question",
  "composer.submitAnswer": "Submit answer",
  "composer.submitAnswers": "Submit answers",
  "composer.submitting": "Submitting...",
  "composer.previous": "Previous",
  "composer.previousQuestion": "Previous question",
  "composer.emptyConversation": "Send a message to start the conversation.",
  "composer.dictationUnsupported": "Voice dictation is not supported in this browser",
  "composer.dictationBlocked":
    "Speech recognition is blocked. Enable Dictation in system settings, or try Chrome.",
  "composer.dictationMicDenied": "Microphone permission denied",
  "composer.dictationNoMic": "No microphone was found",
  "composer.dictationMicBusy":
    "Couldn't access the microphone. It may be in use or blocked by the system.",
  "composer.dictationNetwork": "Voice dictation couldn't reach the speech service",
  "composer.unconnectedTools": "Apps you can connect",
  "composer.dictationInsecure": "Voice dictation needs HTTPS or localhost",
  "composer.dictationFailed": "Voice dictation could not start",

  "chat.newThreadIn": "New thread in {name}",
  "chat.threadTitle": "Thread title",
  "chat.threadActions": "Thread actions for {title}",
  "chat.threadBreadcrumb": "Thread breadcrumb",
  "chat.working": "Working…",

  "memory.title": "Memory",
  "memory.subtitle": "Long-term context from CogniMemo",
  "memory.subtitlePersonal": "Your personal memories from chat and connected apps",
  "memory.subtitleOrg": "Shared organizational memories from CogniMemo",
  "memory.subtitleUnconfigured": "Connect CogniMemo to see company memory here",
  "memory.toggle": "CogniMemo memory",
  "memory.resultsFor": "Results for “{query}”",
  "memory.searchPlaceholder": "Search memories",
  "memory.search": "Search",
  "memory.loading": "Loading memories…",
  "memory.emptyUnconfigured":
    "CogniMemo is not configured on this server yet. Memories will appear here once the API key is set.",
  "memory.emptySearch": "No memories match this search.",
  "memory.empty": "No memories yet. Content you store in CogniMemo will appear here.",

  "knowledge.title": "Knowledge base",
  "knowledge.subtitle": "What MorrowOS knows about you",
  "vault.title": "Vault",
  "vault.subtitle": "Your files, always here to attach",
  "vault.empty": "Your vault is empty",
  "vault.emptyHint": "Files you upload or attach in chat show up here.",
  "vault.upload": "Upload",
  "vault.uploading": "Uploading…",
  "vault.reindex": "Re-index",
  "vault.reindexing": "Re-indexing…",
  "vault.reindexHint":
    "Make already-uploaded files searchable and index their items for the assistant",
  "vault.reindexStarted": "Re-indexing {count} file(s) — searchable results appear shortly",
  "vault.reindexFailed": "Couldn't start re-indexing",
  "vault.itemsIndexed": "{count} items · searchable",
  "vault.dropHint": "Drop files here to upload",
  "vault.deleteFailed": "Couldn't delete this file",
  "vault.folderCreateFailed": "Couldn't create that folder",
  "vault.moveFailed": "Couldn't move that file",
  "vault.dropIntoFolder": "Drop to put it in {name}",
  "vault.openFailed": "Couldn't open this file",
  "vault.folders": "Folders",
  "vault.files": "Files",
  "vault.folder.all": "All files",
  "vault.folder.documents": "Documents",
  "vault.folder.spreadsheets": "Spreadsheets",
  "vault.folder.images": "Images",
  "vault.folder.media": "Media",
  "vault.folder.other": "Other",
  "vault.filesCount": "{count} Files",
  "vault.folderEmpty": "No files in this folder yet.",
  "vault.col.name": "Name",
  "vault.col.type": "Type",
  "vault.col.size": "Size",
  "vault.col.addedBy": "Added by",
  "vault.col.actions": "Actions",
  "vault.addedByYou": "You",
  "vault.viewList": "List view",
  "vault.viewGrid": "Grid view",
  "vault.createFolder": "New folder",
  "vault.createFolderTitle": "Create folder",
  "vault.createFolderHint": "Organize your vault files into folders.",
  "vault.folderName": "Folder name",
  "vault.folderNamePlaceholder": "e.g. Onboarding",
  "vault.createFolderCancel": "Cancel",
  "vault.moveToFolder": "Move to folder",
  "vault.removeFromFolder": "Remove from folder",
  "vault.folderActions": "Folder options",
  "vault.renameFolder": "Rename folder",
  "vault.renameFolderTitle": "Rename folder",
  "vault.rename": "Rename",
  "vault.deleteFolder": "Delete folder",
  "vault.deleteFolderTitle": "Delete “{name}”?",
  "vault.deleteFolderBody": "This folder has {count} files. Choose what happens to them.",
  "vault.deleteFolderBodyEmpty": "This folder is empty.",
  "vault.deleteFolderKeepFiles": "Remove folder, keep files",
  "vault.deleteFolderKeepFilesHint": "The folder is removed. Its files go back to Unfiled.",
  "vault.deleteFolderWithFiles": "Delete folder and its files",
  "vault.deleteFolderWithFilesHint": "The folder and everything inside it are permanently deleted.",
  "vault.folderDeleted": "Folder deleted",
  "vault.folderDeleteFailed": "Couldn't delete that folder.",
  "vault.folderRenamed": "Folder renamed",
  "vault.folderRenameFailed": "Couldn't rename that folder.",
  "vault.cancel": "Cancel",
  "vault.uploadingFile": "Uploading file…",
  "vault.previewUnavailable": "Preview isn't available for this file type.",
  "vault.download": "Download",
  "vault.viewText": "View text",
  "vault.attachFromDevice": "From device",
  "vault.attachFromVault": "From vault",
  "vault.pickTitle": "Attach from vault",
  "vault.pickSubtitle": "Pick a file to attach to your message",
  "knowledge.docHeading": "Profile",
  "knowledge.loading": "Loading your knowledge base…",
  "knowledge.empty":
    "MorrowOS is still learning about you… As you work together, what it learns will appear here.",
  "knowledge.emptyTitle": "MorrowOS is getting to know you",
  "knowledge.emptyBody":
    "There's nothing here yet — and that's expected. As you chat and work together, MorrowOS quietly builds a picture of who you are. What it learns will grow into this page.",
  "knowledge.emptyCategoriesLabel": "What will show up here",
  "knowledge.catPreferences": "Preferences",
  "knowledge.catProjects": "Projects & work",
  "knowledge.catGoals": "Goals",
  "knowledge.catStyle": "Working style",
  "knowledge.tabAboutYou": "About you",
  "knowledge.tabStyle": "Your style",
  "knowledge.tabPreferences": "Preferences",
  "knowledge.tabOrganization": "Organization",
  "knowledge.emptyTabTitle": "Nothing learned yet",
  "knowledge.emptyTabBody":
    "As you and MorrowOS work together, what it learns for this section will appear here.",

  "usage.title": "Usage & Credits",
  "usage.subtitle": "Metering across all model calls",
  "usage.unavailable":
    "Usage endpoints are unavailable. No calls have been metered yet, or the server is offline.",
  "usage.yourUsage": "Your Usage",
  "usage.user": "User:",
  "usage.credits": "Credits",
  "usage.calls": "Calls",
  "usage.tokensIn": "Tokens In",
  "usage.tokensOut": "Tokens Out",
  "usage.globalMonitor": "Global Monitor",
  "usage.totalCredits": "Total Credits",
  "usage.users": "Users",
  "usage.totalCalls": "Total Calls",
  "usage.totalTokens": "Total Tokens",
  "usage.topUsers": "Top Users by Credits",
  "usage.empty": "No usage recorded yet.",

  "commandPalette.openSettings": "Open settings",
  "commandPalette.openMemory": "Open memory",
  "commandPalette.openUsage": "Open usage",
  "commandPalette.openTeam": "Open team",
  "commandPalette.openAgents": "Open agents",
  "commandPalette.openMessages": "Open messages",

  "team.title": "Team",
  "team.subtitle": "People on {name}",
  "team.untitled": "this workspace",
  "team.joinHint": "Invite someone by email. They or an admin can set their title and role.",
  "team.joinName": "Name",
  "team.joinEmail": "Email",
  "team.joinTitle": "Title",
  "team.joinRole": "Role",
  "team.joinFunction": "What they do",
  "team.joinDescription": "About",
  "team.joinAccess": "Access level",
  "team.roleAdmin": "Admin",
  "team.roleMember": "Member",
  "team.join": "Invite",
  "team.addMember": "Add member",
  "team.namePlaceholder": "Name",
  "team.emailPlaceholder": "teammate@acme.com",
  "team.titlePlaceholder": "Product lead",
  "team.rolePlaceholder": "Product",
  "team.functionPlaceholder": "e.g. Runs growth marketing",
  "team.descriptionPlaceholder": "What they do here",
  "team.members": "Members",
  "team.empty": "No one has joined yet.",
  "team.emptyHint":
    "Invite teammates to share agents, knowledge and connected apps — and set what each member can access.",
  "team.seatsUsage": "{used} / {limit} seats",
  "team.orgMemory": "Organizational memory",
  "team.orgMemoryEmpty":
    "MorrowOS hasn’t learned anything about your organization yet. It grows as you work.",
  "team.orgMemoryRebuild": "Rebuild",
  "team.orgMemoryRebuilding": "Rebuilding…",
  "organization.title": "Organization",
  "organization.subtitle": "Your company’s shared memory, people, and AI workers.",
  "organization.noOrg": "No active organization. Create or join one to see your organization here.",
  "identity.personBadge": "Personal profile",
  "identity.organizationBadge": "Company profile",
  "identity.email": "Email",
  "identity.members": "Team",
  "identity.industry": "Industry",
  "identity.website": "Website",
  "identity.memberSince": "Member since",
  "identity.about": "About",
  "identity.knowledgeHint":
    "MorrowOS builds this profile from your chats, connected apps, and how you work.",
  "identity.orgHint":
    "Shared context for everyone in your organization — projects, norms, and how you operate.",
  "team.invited": "Invited",
  "team.pendingInvite": "Invited",
  "team.profileHint": "Set your title and role.",
  "team.profilePending": "Title and role not set yet",
  "team.openProfile": "Open profile",
  "team.openDetail": "Open {name}'s profile",
  "team.editOtherSubtitle": "Update how this person appears on the team.",
  "team.viewOnlyHint": "Only this person or an admin can edit this profile.",
  "team.grant.title": "Access grants",
  "team.grant.vaultManage": "Manage org vault",
  "team.grant.vaultRequest": "Cross-vault access",
  "team.grant.billingAccess": "Billing access",
  "team.grant.orgKbAccess": "Org knowledge base",
  "team.you": "You",
  "team.websiteHint": "Suggestions and action items will use {website}.",
  "profile.team.title": "Title and role",
  "profile.team.subtitle": "This is how you appear on the team.",
  "profile.team.save": "Save",
  "profile.avatar.title": "Portrait",
  "profile.avatar.choose": "Choose {character}",
  "profile.avatar.upload": "Upload",
  "profile.avatar.uploadError": "Could not use that image. Try a smaller photo.",
  "profile.clerk.profileNav": "Profile",
  "profile.clerk.firstName": "First name",
  "profile.clerk.lastName": "Last name",
  "profile.clerk.avatarHint": "Open Update profile to choose your portrait.",

  "agents.title": "Agents",
  "agents.subtitle": "Roles that take work on their own",
  "agents.openDetail": "Open {role} details",
  "agents.hr.role": "HR",
  "agents.hr.blurb": "Handles people work: hiring notes, titles, onboarding, and team health.",
  "agents.hr.skill.hiring": "Hiring",
  "agents.hr.skill.onboarding": "Onboarding",
  "agents.hr.skill.health": "Team health",
  "agents.marketing.role": "Marketing",
  "agents.marketing.blurb":
    "Shapes the story, drafts campaigns, and turns the company site into a brief.",
  "agents.marketing.skill.story": "Story",
  "agents.marketing.skill.campaigns": "Campaigns",
  "agents.marketing.skill.brief": "Brief",
  "agents.mor.role": "CEO",
  "agents.mor.blurb": "The blue mascot. Picks up team work and writes the result back.",
  "agents.mor.skill.team": "Team",
  "agents.mor.skill.pickup": "Takes work",
  "agents.mor.skill.result": "Result",
  "agents.product.role": "Product",
  "agents.product.blurb": "Turns requests into a backlog: scope, priority, and the next ship.",
  "agents.product.skill.scope": "Scope",
  "agents.product.skill.priority": "Priority",
  "agents.product.skill.ship": "Next ship",
  "agents.strategy.role": "Strategy",
  "agents.strategy.blurb":
    "Compares options, maps risks, and brings a short plan back to the team.",
  "agents.strategy.skill.options": "Options",
  "agents.strategy.skill.risks": "Risks",
  "agents.strategy.skill.plan": "Plan",
  "agents.finance.role": "Finance",
  "agents.finance.blurb": "Tracks spend, usage, and the numbers behind a decision.",
  "agents.finance.skill.spend": "Spend",
  "agents.finance.skill.usage": "Usage",
  "agents.finance.skill.numbers": "Numbers",
  "agents.sales.role": "Sales",
  "agents.sales.blurb": "Follows the pipeline, drafts outreach, and flags the next close.",
  "agents.sales.skill.pipeline": "Pipeline",
  "agents.sales.skill.outreach": "Outreach",
  "agents.sales.skill.close": "Close",
  "agents.support.role": "Support",
  "agents.support.blurb": "Turns inbox and Slack into answers the rest of the team can act on.",
  "agents.support.skill.inbox": "Inbox",
  "agents.support.skill.slack": "Slack",
  "agents.support.skill.answers": "Answers",

  "agents.workspace.subtitle": "Autonomous role-holders that work on their own over time.",
  "agents.workspace.loading": "Loading agents…",
  "agents.workspace.empty.title": "No agents yet",
  "agents.workspace.empty.description":
    "An agent is a role you hand off — give it goals and access, and it works on its own over time.",
  "agents.workspace.newAgent": "New agent",
  "agents.workspace.demo": "Demo",
  "agents.workspace.resume": "Resume",
  "agents.workspace.pause": "Pause",
  "agents.workspace.status.active": "Active",
  "agents.workspace.status.paused": "Paused",
  "agents.workspace.status.archived": "Archived",
  "agents.workspace.create.title": "New agent",
  "agents.workspace.create.description":
    "Name the role and its goal. You can refine everything after it's created.",
  "agents.workspace.field.mascot": "Mascot",
  "agents.workspace.field.name": "Name",
  "agents.workspace.field.role": "Role",
  "agents.workspace.field.goals": "Goals / mandate",
  "agents.workspace.field.autonomy": "Autonomy",
  "agents.workspace.field.tools": "Tools / apps",
  "agents.workspace.field.capabilities": "Capabilities",
  "agents.workspace.placeholder.mascot": "…or paste your own emoji / image URL",
  "agents.workspace.placeholder.name": "e.g. Ravi — HR",
  "agents.workspace.placeholder.role": "e.g. Head of Recruiting",
  "agents.workspace.placeholder.goals": "What should this agent pursue on its own?",
  "agents.workspace.placeholder.appsAdvanced": "Advanced: extra slugs, comma-separated",
  "agents.workspace.connectedApps.hint":
    "Pick from your connected apps. None selected = all connected apps allowed.",
  "agents.workspace.connectedApps.none":
    "No connected apps yet — connect apps in Settings, or type slugs below.",
  "agents.workspace.createAgent": "Create agent",
  "agents.workspace.untitled": "Untitled agent",
  "agents.workspace.notFound": "Agent not found",
  "agents.workspace.backToAgents": "Back to agents",
  "agents.workspace.backAria": "Back to agents",
  "agents.workspace.detailsTitle": "Agent details",
  "agents.workspace.computer": "Computer",
  "agents.workspace.computerOpenTitle": "Open the agent's Computer — watch its browser & terminal",
  "agents.workspace.typing": "typing…",
  "agents.workspace.statusLabel.paused": "paused",
  "agents.workspace.statusLabel.active": "active",
  "agents.workspace.emptyChat.title": "Say hi to {name}",
  "agents.workspace.emptyChat.body":
    "It runs as itself — its persona, tools, and autonomy. Ask it to do something, or tap Computer to watch it work.",
  "agents.workspace.preparingConversation": "Preparing conversation…",
  "agents.workspace.messagePlaceholder": "Message {name}…",
  "agents.workspace.listening": "Listening…",
  "agents.workspace.attachFiles": "Attach files",
  "agents.workspace.dictate": "Dictate",
  "agents.workspace.stopDictation": "Stop dictation",
  "agents.workspace.dictateTitle": "Dictate with your microphone",
  "agents.workspace.send": "Send",
  "agents.workspace.removeAttachment": "Remove {name}",
  "agents.workspace.autonomy.read": "Read-only — proposes, never acts",
  "agents.workspace.autonomy.approval": "Approval — asks before outward actions",
  "agents.workspace.autonomy.autonomous": "Autonomous — acts within its mandate",
  "agents.workspace.cap.cloudBrowser": "Cloud browser",
  "agents.workspace.cap.browser": "Local browser",
  "agents.workspace.cap.vault": "Vault / files",
  "agents.workspace.cap.memoryWrite": "Memory",
  "agents.workspace.cap.email": "Email",
  "agents.workspace.source.message": "Message",
  "agents.workspace.source.comms": "Comms",
  "agents.workspace.source.event": "Event",
  "agents.workspace.source.schedule": "Schedule",
  "agents.workspace.source.delegation": "Delegation",
  "agents.workspace.source.test": "Manual run",
  "agents.workspace.computerTitle": "{name}'s Computer",
  "agents.workspace.computer.using": "Using Computer",
  "agents.workspace.computer.liveHost": "Live · {host}",
  "agents.workspace.computer.liveAgentBrowser": "Live · agent's browser",
  "agents.workspace.computer.yourBrowser": "Your browser · drive it",
  "agents.workspace.computer.tab.browser": "Browser",
  "agents.workspace.computer.tab.terminal": "Computer",
  "agents.workspace.computer.restartScreen": "Restart screen",
  "agents.workspace.computer.restartBrowser": "Restart the browser",
  "agents.workspace.computer.collapse": "Collapse computer",
  "agents.workspace.computer.collapseTitle": "Collapse",
  "agents.workspace.computer.live": "live",
  "agents.workspace.computer.idle": "idle",
  "agents.workspace.computer.jumpToLive": "Jump to live",
  "agents.workspace.computer.shellOutput": "Shell output",
  "agents.workspace.computer.startingBrowser": "Starting {name}'s browser…",
  "agents.workspace.computer.screenError": "Couldn't start the screen — tap restart to retry.",
  "agents.workspace.computer.retry": "Retry",
  "agents.workspace.computer.iframeTitle": "Agent browser",
  "agents.workspace.computer.embedBlocked": "The live view can't embed here.",
  "agents.workspace.computer.openInTab": "Open the screen in a tab",
  "agents.workspace.computer.preparingScreen": "Preparing the screen…",
  "agents.workspace.computer.terminalEmpty": "No command output yet. Ask {name} to run something —",
  "agents.workspace.computer.terminalExample": 'run python3 -c "print(2+2)"',
  "agents.workspace.computer.outputLabel": "output · {index}",
  "agents.workspace.profile.roleFallback": "Agent",
  "agents.workspace.profile.runNow": "Run now",
  "agents.workspace.profile.section.mascot": "Mascot",
  "agents.workspace.profile.section.identity": "Identity",
  "agents.workspace.profile.section.personality": "Personality & goals",
  "agents.workspace.profile.personalityHint": "What this agent is and pursues",
  "agents.workspace.profile.section.permissions": "Permissions",
  "agents.workspace.profile.connectedApps": "Connected apps",
  "agents.workspace.profile.connectedAppsHint": "· comma-separated, blank = all",
  "agents.workspace.profile.appsPlaceholder": "gmail, googlecalendar, slack",
  "agents.workspace.profile.section.autonomy": "Autonomy & schedule",
  "agents.workspace.profile.schedule": "Schedule",
  "agents.workspace.profile.scheduleHint": "· cron, blank = only when messaged",
  "agents.workspace.profile.schedulePlaceholder": "0 9 * * *",
  "agents.workspace.profile.section.tags": "Tags (reach it over comms)",
  "agents.workspace.profile.tagPlaceholder": "new tag (without @)",
  "agents.workspace.profile.removeTag": "Remove",
  "agents.workspace.profile.runLogs": "Run logs ({count})",
  "agents.workspace.profile.noRuns": "Nothing yet — it hasn't run.",
  "agents.workspace.profile.runFallback": "run",
  "agents.workspace.profile.delete": "Delete",
  "agents.workspace.profile.save": "Save changes",

  "messages.title": "Messages",
  "messages.subtitle": "Team conversation",
  "messages.placeholder": "Message the team. Use @mor to call Mor.",
  "messages.empty": "No messages yet. Start the team thread here.",
  "messages.send": "Send",
  "messages.you": "You",
  "messages.morPickedUp": "Mor picked this up in the conversation.",
  "messages.flow.briefing": "Morning briefing",
  "messages.flow.briefingPrompt": "@mor give the team a morning briefing.",
  "messages.flow.inbox": "Inbox",
  "messages.flow.inboxPrompt": "@mor summarize the inbox for the team.",
  "messages.flow.calendar": "Calendar",
  "messages.flow.calendarPrompt": "@mor what’s on the calendar today?",
  "commandPalette.newThreadIn": "New thread in...",
  "commandPalette.toggleThemeEditor": "Toggle theme editor",

  "sidebar.searchUniversal": "Search threads, people, files, and pages",
  "sidebar.searchPlaceholder": "Search threads, people, files…",
  "sidebar.noSearchResults": "No results found",
  "sidebar.searchGroup.threads": "Threads",
  "sidebar.searchGroup.pages": "Pages",
  "sidebar.searchGroup.agents": "Agents",
  "sidebar.searchGroup.members": "Team",
  "sidebar.searchGroup.vault": "Vault",
  "sidebar.searchGroup.knowledge": "Knowledge",
  "settings.organization.demoHint":
    "Demo data — Clerk Organizations are not enabled on this instance.",
  "memory.count": "{count} memories",
  "memory.emptyTitle": "Your long-term memory is empty",
  "memory.emptyTitleOrg": "Your organization memory is empty",
  "memory.emptyBody":
    "Nothing here yet — that's normal. As you work with MorrowOS, CogniMemo quietly stores what matters so agents can remember you across threads and sessions.",
  "memory.emptyBodyOrg":
    "Nothing here yet — that's normal. As your team works with MorrowOS, CogniMemo stores shared context so everyone stays aligned across threads and sessions.",
  "memory.emptySectionsLabel": "What CogniMemo does",
  "memory.sectionWhat": "What it is",
  "memory.sectionWhatHint":
    "CogniMemo is MorrowOS's external memory layer — a durable store for facts, decisions, and context beyond a single chat.",
  "memory.sectionWhatHintOrg":
    "CogniMemo holds your organization's shared memory — durable facts, decisions, and context that belong to the whole team.",
  "memory.sectionPurpose": "What it's for",
  "memory.sectionPurposeHint":
    "Carry what you've already shared into every new thread so you don't repeat yourself and agents stay aligned with your goals.",
  "memory.sectionPurposeHintOrg":
    "Carry what your team has already shared into every thread so people don't repeat themselves and agents stay aligned with company goals.",
  "memory.sectionCapture": "How it captures",
  "memory.sectionCaptureHint":
    "Agents save important moments from chat — preferences, project details, and decisions — as discrete memories in CogniMemo.",
  "memory.sectionCaptureHintOrg":
    "Agents save important moments from team chat — project details, norms, and decisions — as shared memories in CogniMemo.",
  "memory.sectionRecall": "How it recalls",
  "memory.sectionRecallHint":
    "When you chat or search here, relevant memories surface by meaning, not just keywords — so the right context shows up when needed.",
  "memory.graph.selectNode": "Select a node in the graph to see its details.",
  "memory.graph.kind.company": "Company",
  "memory.graph.kind.department": "Department",
  "memory.graph.kind.employee": "Employee",
  "memory.graph.kind.round": "Round",
  "memory.graph.kind.tool": "Tool",
  "memory.graph.zoomIn": "Zoom in",
  "memory.graph.zoomOut": "Zoom out",
  "memory.graph.resetView": "Reset view",
  "memory.graph.aria": "Company memory graph",
  "memory.graph.ariaPersonal": "Personal memory graph",
  "memory.graph.ariaOrg": "Organization memory graph",
  "memory.graph.hoverHint": "Hover or select a node to see details.",
  "memory.graph.filterDepartment": "Department",
  "memory.graph.allDepartments": "All departments",
  "memory.graph.filterKind": "Node type",
  "memory.graph.allKinds": "All types",
  "memory.detail.title": "Title",
  "memory.detail.role": "Role",
  "memory.detail.email": "Email",
  "memory.detail.about": "About",
  "memory.detail.content": "Content",
  "memory.detail.type": "Type",
  "memory.detail.created": "Created",
  "memory.detail.score": "Relevance",
  "memory.detail.tool": "Tool",
  "memory.detail.toolHint": "A connected integration linked to this part of company memory.",
  "memory.detail.departmentHint": "People and memories grouped by how the team is organized.",
  "memory.detail.companyHint": "The center of your organization’s shared memory graph.",
  "memory.detail.breadcrumb": "Path",
  "memory.detail.clusterItems": "Grouped items",
  "memory.detail.related": "Related",
  "memory.detail.department": "Department",
  "memory.detail.owner": "Owner",
  "memory.view.graph": "Graph",
  "memory.view.list": "List",
  "knowledge.catPreferencesHint": "Tools, notifications, and defaults you prefer.",
  "knowledge.catProjectsHint": "What you're building, your role, and current focus.",
  "knowledge.catGoalsHint": "What you're working toward over time.",
  "knowledge.catStyleHint": "How you communicate and like to collaborate.",
  "knowledge.error.forbidden":
    "You don't have permission to view this knowledge. Ask your organization admin for access.",
  "knowledge.error.notFound": "Nothing here yet.",
  "knowledge.error.unavailable": "Couldn't load this right now. Try refreshing.",
  "usage.currentPlan": "Current plan",
  "usage.recommendedPlan": "Recommended for you",
  "usage.topPlan": "You're on our top plan.",
  "usage.upgrade": "Upgrade",
  "usage.usageThisPeriod": "Usage this period",
  "usage.includedFeatures": "Included features",
  "pricing.title": "Plans",
  "pricing.subtitle": "{planName} plan · {tier} tier",
  "pricing.subtitleAudience": "{audience} plans",
  "pricing.individual": "Individual",
  "pricing.business": "Business",
  "pricing.manageBilling": "Manage billing",
  "pricing.opening": "Opening…",
  "pricing.loading": "Loading plans…",
  "pricing.unavailable": "Plans are unavailable right now. Try refreshing in a moment.",
  "pricing.noPlans": "No plans are published for this audience yet.",
  "pricing.current": "Current",
  "pricing.popular": "Popular",
  "pricing.currentPlan": "Current plan",
  "pricing.included": "Included",
  "pricing.upgrade": "Upgrade",
  "pricing.redirecting": "Redirecting…",
  "pricing.perMonth": "/ month",
  "pricing.free": "Free",
  "pricing.unlimited": "Unlimited",
  "pricing.compareTitle": "Compare plans",
  "pricing.compareSubtitle": "Full feature breakdown for each tier",
  "pricing.featureColumn": "Feature",
  "pricing.detailsTitle": "Billing details",
  "pricing.cap.modelPay": "Pay-tier models",
  "pricing.cap.modelSuper": "Super-tier models",
  "pricing.cap.modelMax": "Max-tier models",
  "pricing.cap.agentTurns": "Agent turns / month",
  "pricing.cap.toolCalls": "Tool calls / month",
  "pricing.cap.subagents": "Concurrent sub-agents",
  "pricing.cap.connectors": "Connected apps",
  "pricing.cap.seats": "Seats included",
  "pricing.faq.resetQ": "When does usage reset?",
  "pricing.faq.resetA":
    "Metered limits reset at the start of each billing period. Free plans reset monthly from your account creation date.",
  "pricing.faq.changeQ": "Can I change plans anytime?",
  "pricing.faq.changeA":
    "Yes. Upgrades take effect immediately and are prorated. Downgrades apply at the end of the current billing period.",
  "pricing.faq.limitQ": "What happens when I hit a limit?",
  "pricing.faq.limitA":
    "MorrowOS warns you as you approach limits, then blocks the action once the allowance is exhausted. Upgrade or wait for the next period to continue.",
  "pricing.faq.billingQ": "How does team billing work?",
  "pricing.faq.billingA":
    "Business plans include a set number of seats. Additional members can be invited up to your seat allowance. Billing is managed through Stripe.",
  "pricing.faq.cancelQ": "Can I cancel anytime?",
  "pricing.faq.cancelA":
    "Yes. Use Manage billing to open the Stripe portal where you can cancel, update payment methods, and download invoices.",
  "pricing.introBusiness":
    "Compare business plans for your organization, or top up with a one-off fund.",
  "pricing.introIndividual": "Compare plans and switch to the one that fits your workflow.",
  "pricing.addonsTitle": "Add-ons & credit funds",
  "pricing.addonsIntro": "One-off top-ups that stack on your current package.",
  "pricing.loadingAddons": "Loading add-ons…",
  "pricing.buy": "Buy",
  "pricing.oneOff": "one-off",
  "pricing.includedAria": "Included",
  "pricing.notIncludedAria": "Not included",
  "pricing.saveUpTo": "Save up to {percent}%",
  "pricing.discountOff": "{percent}% off",
  "pricing.billedPerMonth": "per month, {note}",
  "pricing.startTrial": "Start 7-day free trial",
  "pricing.trialNote": "7 days free, then {price}/mo · cancel anytime",
  "pricing.modelsRow": "AI models",
  "pricing.modelsRowDescription": "Which models your agents can run.",
  "pricing.interval.month": "Monthly",
  "pricing.interval.quarter": "Quarterly",
  "pricing.interval.year": "Yearly",
  "pricing.interval.billedMonthly": "billed monthly",
  "pricing.interval.billedQuarterly": "billed quarterly",
  "pricing.interval.billedYearly": "billed yearly",
  "pricing.tagline.free": "For very small teams",
  "pricing.tagline.pay": "For growing teams",
  "pricing.tagline.super": "For scaling businesses",
  "pricing.tagline.max": "For large organizations",
  "pricing.category.modelsAi": "Models & AI",
  "pricing.category.agentsAutomation": "Agents & automation",
  "pricing.category.toolsConnectors": "Tools & connectors",
  "pricing.category.browserCompute": "Browser & compute",
  "pricing.category.storageKnowledge": "Storage & knowledge",
  "pricing.category.collaborationOrg": "Collaboration & org",
  "pricing.category.other": "Other",
  "pricing.cap.agentsMax": "Agents",
  "pricing.cap.workflows": "Workflows",
  "pricing.cap.routines": "Scheduled routines",
  "pricing.cap.fullToolLibrary": "Full tool library (1,100+)",
  "pricing.cap.customConnectors": "Custom connectors",
  "pricing.cap.customAgents": "Custom agents",
  "pricing.cap.browser": "Browser automation",
  "pricing.cap.vaultStorage": "Vault storage",
  "pricing.cap.persistentMemory": "Persistent memory",
  "pricing.cap.memoryStorage": "Memory storage",
  "pricing.cap.knowledgeBase": "Knowledge base",
  "pricing.cap.orgMemory": "Organization memory",
  "pricing.cap.rolesPermissions": "Roles & permissions",
  "pricing.feature.allModels": "Access to all models",
  "pricing.feature.advancedStandard": "Advanced + standard models",
  "pricing.feature.standardModels": "Standard models",
  "pricing.feature.freeModels": "Free models",
  "pricing.feature.unlimitedToolCalls": "Unlimited tool calls",
  "pricing.feature.toolCallsMonth": "{count} tool calls / month",
  "pricing.feature.unlimitedAgents": "Unlimited agents",
  "pricing.feature.agents": "{count} agent",
  "pricing.feature.agentsPlural": "{count} agents",
  "pricing.feature.concurrentSubagents": "{count} concurrent sub-agents",
  "pricing.feature.unlimitedConnectors": "Unlimited connected apps",
  "pricing.feature.connectors": "{count} connected apps",
  "pricing.feature.unlimitedVault": "Unlimited vault storage",
  "pricing.feature.vaultStorage": "{size} vault storage",
  "pricing.feature.persistentMemory": "Persistent memory",
  "pricing.feature.memoryStorage": "{size} memory storage",
  "pricing.feature.knowledgeBase": "Knowledge base",
  "pricing.feature.orgMemory": "Organization memory",
  "pricing.feature.rolesPermissions": "Roles & permissions",
  "pricing.feature.memberSeats": "{count} member seats",
  "team.edit": "Edit",
  "team.detail.about": "About",
  "team.detail.email": "Email",
  "team.detail.location": "Location",
  "team.detail.joined": "Joined",
  "team.detail.reportsTo": "Reports to",
  "team.detail.timezone": "Timezone",
  "contextPanel.title": "Context panel",
  "contextPanel.actions": "Actions",
  "contextPanel.toggle": "Toggle context panel",
  "contextPanel.close": "Close panel",
  "contextPanel.subAgentDetail": "Sub-agent detail",
  "contextPanel.stagingTitle": "Context panel (staging)",
  "contextPanel.stagingHint": "Design preview — not wired to live thread events.",

  "activities.title": "Activities",
  "activities.subtitle": "What Morrow and your team did — today at a glance.",
  "activities.prompt.placeholder": "Ask Morrow anything…",
  "activities.prompt.send": "Start chat",
  "activities.prompt.noProjectTitle": "Choose a project first",
  "activities.prompt.noProjectDescription": "Add a project to start a thread from here.",
  "activities.mock.banner":
    "Preview — sample data only. Real org feed ships with the activity API (Faz 1). Disable with ?mock=0.",
  "activities.apiPending":
    "Live org feed is not connected yet. Use preview data in dev or ?mock=1.",
  "activities.timeline": "Timeline",
  "activities.timeline.hint":
    "Chronological order for the selected day — tap an item for full steps.",
  "activities.timeline.empty": "No activity for this day with the current filters.",
  "activities.quickAccess.title": "Quick access",
  "activities.quickAccess.hint": "Latest files, threads, and workflows from this day.",
  "activities.quickAccess.empty": "No files or links for this day with the current filters.",
  "activities.detail.progress": "Progress",
  "activities.step.queued": "Queued",
  "activities.step.executing": "Executing",
  "activities.step.finished": "Finished",
  "activities.step.requested": "Requested",
  "activities.step.review": "Review",
  "activities.step.decision": "Decision",
  "activities.step.triggered": "Triggered",
  "activities.step.scheduled": "Scheduled",
  "activities.step.due": "Due",
  "activities.step.ran": "Ran",
  "activities.step.received": "Received",
  "activities.step.processing": "Processing",
  "activities.step.delivered": "Delivered",
  "activities.step.started": "Started",
  "activities.step.inProgress": "In progress",
  "activities.lane.todo": "To do",
  "activities.lane.doing": "In progress",
  "activities.lane.done": "Done",
  "activities.lane.empty": "Nothing here for this day.",
  "activities.lane.viewAll": "View all",
  "activities.lane.allDialogHint": "{count} activities for this day in this lane.",
  "activities.lane.showStack": "Stack view",
  "activities.lane.moreCount": "+{count} more",
  "activities.lane.expandStack": "Show all {count} activities in this lane",
  "activities.filter.member": "Team member",
  "activities.filter.memberShort": "Member",
  "activities.filter.allMembers": "All members",
  "activities.filter.status": "Status",
  "activities.filter.statusShort": "Status",
  "activities.filter.allStatuses": "All statuses",
  "activities.filter.kind": "Source",
  "activities.filter.kindShort": "Source",
  "activities.filter.allKinds": "All sources",
  "activities.filter.tapToChoose": "Tap to filter",
  "activities.status.needsApproval": "Needs approval",
  "activities.status.pending": "Scheduled",
  "activities.status.running": "Running",
  "activities.status.completed": "Completed",
  "activities.status.failed": "Failed",
  "activities.status.approved": "Approved",
  "activities.status.denied": "Denied",
  "activities.kind.tool": "Morrow tool",
  "activities.kind.allowance": "Approval",
  "activities.kind.workflow": "Workflow",
  "activities.kind.agent": "Agent",
  "activities.kind.comms": "Comms",
  "activities.kind.schedule": "Routine",
  "activities.kind.board": "Agent board",
  "activities.detail.agent": "Agent",
  "activities.detail.tool": "Tool",
  "activities.detail.file": "File",
  "activities.detail.workflow": "Workflow",
  "activities.detail.links": "Open",
  "activities.detail.openThread": "Thread",
  "activities.detail.runSteps": "Steps",
  "activities.detail.viewFullConversation": "View full conversation",
  "activities.detail.openAgent": "Agent",
  "activities.detail.openWorkflow": "Workflow",
  "activities.detail.openAllowance": "Allowance",
  "activities.detail.openFile": "File in vault",
  "activities.mock.linksHint": "Links are disabled in preview — IDs are fictional.",
  "activities.action.review": "Review",
  "activities.action.runNow": "Run now",
  "activities.action.view": "View",
  "activities.action.cancel": "Cancel",
  "activities.action.retry": "Retry",
} as const;

export type MessageKey = keyof typeof en;

export const tr = {
  "common.back": "Geri",
  "common.search": "Ara",
  "common.continue": "Devam",
  "common.skip": "Atla",
  "common.signIn": "Giriş yap",
  "common.refresh": "Yenile",
  "common.close": "Kapat",
  "common.loading": "Yükleniyor…",
  "common.done": "Tamam",
  "common.optional": "isteğe bağlı",
  "common.settings": "Ayarlar",
  "common.systemDefault": "Sistem varsayılanı",

  "language.system": "Sistem varsayılanı",
  "language.en": "English",
  "language.tr": "Türkçe",

  "sidebar.goToThreads": "Sohbetlere git",
  "sidebar.settings": "Ayarlar",
  "sidebar.usage": "Kullanım",
  "sidebar.memory": "Bellek",
  "sidebar.team": "Takım",
  "sidebar.organization": "Kuruluş",
  "sidebar.agents": "Ajanlar",
  "sidebar.workflows": "İş akışları",
  "sidebar.routines": "Rutinler",
  "sidebar.knowledge": "Bilgi",
  "sidebar.vault": "Kasa",
  "sidebar.allowance": "İzin",
  "allowance.subtitle":
    "Morrow’un sizin adınıza yapmak istediği işlemler, siz onaylayana kadar burada bekler. Aşağıdan onaylayın veya reddedin — ya da kanalda YES / NO yazın.",
  "allowance.empty.title": "Şu an onayınızı bekleyen bir şey yok.",
  "allowance.empty.description":
    "Morrow sizin adınıza mesaj göndermek veya bir işlem yapmak istediğinde önce burada sorar.",
  "allowance.refresh": "Yenile",
  "sidebar.activities": "Aktiviteler",
  "sidebar.messages": "Mesajlaşma",
  "sidebar.searchThreads": "Sohbetlerde ara",
  "sidebar.clearSearch": "Aramayı temizle",
  "sidebar.newThread": "Yeni sohbet",
  "sidebar.newThreadShortcut": "Yeni sohbet ({shortcut})",
  "sidebar.newThreadInCurrent": "Açık projedeki yeni sohbet: Shift+tık",
  "sidebar.newThreadInCurrentShortcut": "Açık projedeki yeni sohbet: Shift+tık ({shortcut})",
  "sidebar.filterByProject": "Sohbetleri projeye göre filtrele",
  "sidebar.workspace": "Çalışma alanı",
  "sidebar.filterByWorkspace": "Sohbetleri çalışma alanına göre filtrele",
  "sidebar.workspaceSettings": "{name} çalışma alanı ayarları",
  "sidebar.addWorkspace": "Çalışma alanı ekle",
  "sidebar.renameWorkspace": "Yeniden adlandır",
  "sidebar.removeWorkspace": "Kaldır",
  "sidebar.workspaceSettingsAction": "Ayarlar",
  "sidebar.workspaceActions": "Çalışma alanı işlemleri",
  "sidebar.renameWorkspaceTitle": "Çalışma alanını yeniden adlandır",
  "sidebar.renameWorkspaceDescription": "Bu çalışma alanının görünen adını güncelleyin.",
  "sidebar.workspaceTitleLabel": "Çalışma alanı adı",
  "sidebar.workspaceRenameEmpty": "Çalışma alanı adı boş olamaz",
  "sidebar.workspaceRenameFailed": "Çalışma alanı yeniden adlandırılamadı",
  "sidebar.removeWorkspaceConfirm": '"{name}" çalışma alanı kaldırılsın mı?',
  "sidebar.removeWorkspaceWithThreads":
    '"{name}" çalışma alanı ve içindeki {count} sohbet silinsin mi?',
  "sidebar.removeWorkspaceThreadsWarning":
    "Bu işlem bu sohbetlerin konuşma geçmişini kalıcı olarak siler.",
  "sidebar.removeWorkspaceDiskWarning": "Diskteki dosyalara dokunulmaz.",
  "sidebar.removeWorkspaceUndoWarning": "Bu işlem geri alınamaz.",
  "sidebar.workspaceNotEmpty": "Çalışma alanı boş değil",
  "sidebar.workspaceNotEmptyDescription":
    "Kaldırmadan önce bu çalışma alanındaki tüm sohbetleri silin.",
  "sidebar.removeAnyway": "Yine de kaldır",
  "sidebar.workspaceRemoveFailed": '"{name}" kaldırılamadı',
  "sidebar.allProjects": "Tüm projeler",
  "sidebar.noThreadsFound": "Sohbet bulunamadı",
  "sidebar.noThreadsYet": "Henüz sohbet yok",
  "sidebar.noThreadsInProject": "{name} içinde henüz sohbet yok",
  "sidebar.settled": "Tamamlananlar",
  "sidebar.settledCount": "Tamamlananlar ({count})",
  "sidebar.snoozed": "Ertelenenler",
  "sidebar.snoozedCount": "Ertelenenler ({count})",
  "sidebar.showMore": "{count} tane daha göster",
  "sidebar.working": "Çalışıyor",
  "sidebar.monitoring": "İzleniyor",
  "sidebar.approval": "Onay",
  "sidebar.input": "Girdi",
  "sidebar.failed": "Başarısız",
  "sidebar.woke": "Uyandı",
  "sidebar.done": "Bitti",
  "sidebar.pinned": "Sabitlendi",
  "sidebar.signIn": "Giriş yap",
  "sidebar.account": "Hesap",

  "settings.breadcrumb": "Ayarlar",
  "settings.search": "Ara",
  "settings.searchAria": "Ayarlarda ara",
  "settings.clearSearch": "Ayar aramasını temizle",
  "settings.noResults": "Ayar bulunamadı",
  "settings.searchResults": "Ayar arama sonuçları",
  "settings.section.general": "Genel",
  "settings.section.appearance": "Görünüm",
  "settings.section.keybindings": "Kısayollar",
  "settings.section.providers": "Sağlayıcılar",
  "settings.section.connections": "Bağlantılar",
  "settings.section.comms": "Mesajlaşma",
  "settings.section.triggers": "Tetikleyiciler",
  "settings.section.organization": "Organizasyon",
  "settings.section.packages": "Paketler",
  "settings.section.billing": "Faturalandırma",
  "settings.section.archive": "Arşiv",
  "settings.section.diagnostics": "Tanılama",
  "settings.section.about": "Hakkında",
  "settings.section.support": "Destek",
  "settings.section.legal": "Yasal",
  "settings.section.account": "Hesap",
  "settings.account.manageTitle": "Hesabı yönet",
  "settings.account.manageDescription":
    "Profilini, e-postanı, parolanı ve güvenlik ayarlarını güncelle.",
  "settings.account.manageAction": "Yönet",
  "settings.account.signOutTitle": "Çıkış yap",
  "settings.account.signOutDescription": "Bu cihazda Morrow'dan çıkış yap.",
  "settings.account.signOutAction": "Çıkış yap",
  "settings.search.colorScheme": "Renk düzeni",
  "settings.search.theme": "Temalar",
  "settings.search.glassOpacity": "Cam opaklığı",
  "settings.search.environmentIdentification": "Ortam kimliği",
  "settings.search.interfaceFont": "Arayüz yazı tipi",
  "settings.search.promptFont": "İstem yazı tipi",
  "settings.search.fontSmoothing": "Yazı tipi yumuşatma",
  "settings.search.language": "Dil",
  "settings.search.timeFormat": "Saat biçimi",
  "settings.search.archiveConfirmation": "Arşiv onayı",
  "settings.search.deleteConfirmation": "Silme onayı",
  "settings.search.textGenerationModel": "Metin üretim modeli",
  "settings.search.diagnostics": "Tanılama",
  "settings.search.keybindings": "Kısayollar",
  "settings.search.providers": "Sağlayıcılar",
  "settings.search.remoteEnvironments": "Uzak ortamlar",
  "settings.connections.departmentsAria": "Bağlantıları departmana göre filtrele",
  "settings.connections.dept.all": "Tümü",
  "settings.connections.dept.comms": "İletişim",
  "settings.connections.dept.dev": "Geliştirme",
  "settings.connections.dept.work": "İş",
  "settings.connections.dept.crm": "CRM",
  "settings.connections.dept.data": "Veri",
  "settings.connections.dept.finance": "Finans",
  "settings.connections.dept.ai": "AI",
  "settings.connections.dept.other": "Diğer",
  "settings.connections.rowTitle": "Bir uygulama veya MCP sunucusu bağlayın",
  "settings.connections.rowDescription":
    "MorrowOS’un kullanabileceği uygulamaları ve MCP sunucularını bağlayın. Binlerce Composio aracını arayıp tek tıkla bağlayın.",
  "settings.connections.searchPlaceholder": "Uygulama ve MCP sunucularında ara…",
  "settings.connections.searchAria": "Bağlantılarda ara",
  "settings.connections.connected": "Bağlı",
  "settings.connections.connect": "Bağla",
  "settings.connections.connecting": "Bağlanıyor…",
  "settings.connections.disconnect": "Bağlantıyı kes",
  "settings.connections.disconnectApp": "{name} bağlantısını kes",
  "settings.connections.signInToConnect": "Uygulama bağlamak için giriş yapın",
  "settings.connections.loading": "Bağlantılar yükleniyor…",
  "settings.connections.noMatch": "“{query}” ile eşleşen bağlantı yok.",
  "settings.connections.noInDepartment": "{department} içinde bağlantı yok.",
  "settings.connections.none": "Bağlantı bulunamadı.",
  "settings.connections.loadMore": "Daha fazla yükle ({loaded} / {total})",
  "settings.connections.count": "{count} bağlantı",
  "settings.connections.searchFailed": "Arama başarısız",
  "settings.connections.loadMoreFailed": "Daha fazlası yüklenemedi",
  "settings.connections.connectFailed":
    "Bağlantı başlatılamadı. Sunucudaki Composio API anahtarını kontrol edin.",
  "settings.connections.logoAlt": "{name} logosu",
  "settings.connections.tagline.whatsapp": "Senin adına oku ve gönder",
  "settings.connections.tagline.businessEmail": "Gelen kutundan senin adına oku ve gönder",
  "settings.connections.tagline.businessEmailOneMailbox": "1 posta kutusu — yönet",
  "settings.connections.tagline.businessEmailMailboxes": "{count} posta kutusu — yönet",
  "settings.connections.tagline.browser": "Tarayıcında senin adına işlem yap",
  "settings.connections.tagline.browserConnected": "Bağlı — yönet",
  "settings.connections.toolkitTagline.default": "Bu uygulamada senin adına işlem yap",
  "settings.connections.toolkitTagline.email": "E-postayı senin adına oku ve gönder",
  "settings.connections.toolkitTagline.calendar": "Etkinlikleri gör ve planla",
  "settings.connections.toolkitTagline.messaging": "Mesajları senin adına oku ve gönder",
  "settings.connections.toolkitTagline.workTracking": "İşleri senin adına takip et ve güncelle",
  "settings.connections.toolkitTagline.docs": "Belgeleri senin adına oku ve güncelle",
  "settings.connections.toolkitTagline.data": "Kayıtları senin adına oku ve güncelle",
  "settings.connections.toolkitTagline.files": "Dosyalara göz at ve yönet",
  "settings.connections.toolkitTagline.crm": "Kişiler ve anlaşmalar senin adına",
  "settings.connections.toolkitTagline.finance": "Ödemeler ve faturalar senin adına",
  "settings.connections.toolkitTagline.design": "Tasarımlar ve geri bildirim senin adına",
  "settings.connections.toolkitTagline.meetings": "Toplantılar ve takvim senin adına",
  "settings.connections.toolkitTagline.ai": "Modeller ve AI iş akışları senin adına",
  "settings.connections.toolkitTagline.gmail": "E-postayı senin adına oku ve gönder",
  "settings.connections.toolkitTagline.googlecalendar": "Etkinlikleri gör ve planla",
  "settings.connections.toolkitTagline.googledrive": "Dosyalara göz at ve yönet",
  "settings.connections.toolkitTagline.googlesheets": "Tabloları senin adına oku ve düzenle",
  "settings.connections.toolkitTagline.googledocs": "Belgeleri senin adına oku ve düzenle",
  "settings.connections.toolkitTagline.googleslides": "Sunumları senin adına oku ve düzenle",
  "settings.connections.toolkitTagline.slack": "Kanallarda senin adına oku ve yaz",
  "settings.connections.toolkitTagline.notion": "Sayfaları senin adına oku ve güncelle",
  "settings.connections.toolkitTagline.github": "Issue, PR ve repolar senin adına",
  "settings.connections.toolkitTagline.linear": "Görevleri senin adına takip et ve güncelle",
  "settings.connections.toolkitTagline.jira": "Ticket ve panolar senin adına",
  "settings.connections.toolkitTagline.discord": "Sunucularda senin adına oku ve gönder",
  "settings.connections.toolkitTagline.outlook": "E-postayı senin adına oku ve gönder",
  "settings.connections.toolkitTagline.hubspot": "Kişiler ve anlaşmalar senin adına",
  "settings.connections.toolkitTagline.asana": "Görevler ve projeler senin adına",
  "settings.connections.toolkitTagline.figma": "Tasarımlar ve yorumlar senin adına",
  "settings.connections.toolkitTagline.trello": "Panolar ve kartlar senin adına",
  "settings.connections.toolkitTagline.zoom": "Toplantılar ve takvim senin adına",
  "settings.connections.toolkitTagline.dropbox": "Dosya ve klasörler senin adına",
  "settings.connections.toolkitTagline.airtable": "Tabanlar ve kayıtlar senin adına",
  "settings.connections.toolkitTagline.microsoftTeams": "Sohbet ve toplantılar senin adına",
  "settings.connections.toolkitTagline.gitlab": "Issue, MR ve repolar senin adına",
  "settings.connections.toolkitTagline.bitbucket": "Repolar ve pull request’ler senin adına",
  "settings.connections.toolkitTagline.salesforce": "Lead ve fırsatlar senin adına",
  "settings.connections.toolkitTagline.intercom": "Konuşmalar ve kişiler senin adına",
  "settings.connections.toolkitTagline.zendesk": "Ticket’lar ve müşteriler senin adına",
  "settings.connections.toolkitTagline.shopify": "Siparişler ve ürünler senin adına",
  "settings.connections.toolkitTagline.stripe": "Ödemeler ve müşteriler senin adına",
  "settings.comms.channelsTitle": "Kanallarınız",
  "settings.comms.channelsDescription":
    "Zaten konuştuğunuz yerleri — kendi bağlantı noktalarınızı — bağlayın; Morrow sizi duysun ve size oradan ulaşabilsin. Her bağlantı yalnızca size aittir.",
  "settings.comms.signInBody":
    "Kanallarınızı bağlamak için giriş yapın — her bağlantı hesabınıza bağlıdır; Morrow’unuzla yalnızca siz konuşabilirsiniz.",
  "settings.comms.signInCta": "Bağlamak için giriş yap",
  "settings.comms.connected": "Bağlı",
  "settings.comms.serverError": "Sunucuya ulaşılamadı.",
  "settings.comms.disconnectAria": "{name} bağlantısını kes",
  "settings.comms.addTo": "{label} ekle",
  "settings.comms.connect": "Bağlan",
  "settings.comms.comingSoon": "Bu çalışma alanında yakında",
  "settings.comms.testSend": "Test mesajı gönder",
  "settings.comms.testSent": "Gönderildi — sohbetinizi kontrol edin",
  "settings.comms.testFailed": "Başarısız — tekrar deneyin",
  "settings.comms.allowance.title": "Onay kutusu",
  "settings.comms.allowance.description":
    "Morrow sizin adınıza hareket etmeden önce onayınızı bekliyor. Buradan onaylayın veya reddedin — ya da kanalda YES / NO yazın.",
  "settings.comms.allowance.waiting": "Onayınız bekleniyor",
  "settings.comms.allowance.approve": "Onayla",
  "settings.comms.allowance.deny": "Reddet",
  "settings.comms.whatsapp.label": "WhatsApp Business",
  "settings.comms.whatsapp.tagline": "Morrow’a kendi numarasından yazın.",
  "settings.comms.whatsapp.pitch":
    "Morrow’u işletme numarasındaki bir kişi gibi mesajlayın — soru sorun, ses notu veya dosya gönderin, günlük özetlerinizi zaten baktığınız sohbette alın.",
  "settings.comms.whatsapp.cap.answers": "Sor ve cevap al",
  "settings.comms.whatsapp.cap.voice": "Ses notları ve dosyalar",
  "settings.comms.whatsapp.cap.briefings": "Günlük özetler",
  "settings.comms.whatsapp.qrTitle": "WhatsApp bağla",
  "settings.comms.whatsapp.qrReadyHint":
    "Telefon kamerasıyla tarayın veya aşağıya dokunun — WhatsApp hazır mesajla açılır. Gönder’e basın, bağlantı tamam. Numara veya kod girmeniz gerekmez.",
  "settings.comms.whatsapp.openWhatsApp": "WhatsApp’ı aç ve gönder",
  "settings.comms.whatsapp.waitingMessage": "Mesajınız bekleniyor…",
  "settings.comms.whatsapp.scanHint": "WhatsApp ile QR tarayın — numara veya kod gerekmez.",
  "settings.comms.whatsapp.connect": "WhatsApp bağla",
  "settings.comms.telegram.label": "Telegram",
  "settings.comms.telegram.tagline": "Tek dokunuşla konuşmaya başlayın.",
  "settings.comms.telegram.pitch":
    "Tek dokunuşla bağlanın — kod yok. Morrow ile sohbet edin, hatırlaması için mesajları iletin, anında yanıt alın.",
  "settings.comms.telegram.cap.connect": "Tek dokunuşla bağlan",
  "settings.comms.telegram.cap.forward": "Hatırlamak için ilet",
  "settings.comms.telegram.cap.replies": "Anında yanıtlar",
  "settings.comms.telegram.pending":
    "Telegram’da Başlat’a dokunun — bağlandığınızda burası otomatik güncellenir.",
  "settings.comms.telegram.hint":
    "Tek dokunuşluk Başlat ile Telegram açılır. Kod girmeniz gerekmez.",
  "settings.comms.telegram.connect": "Telegram bağla",
  "settings.comms.slack.label": "Slack",
  "settings.comms.slack.tagline": "Morrow’u çalışma alanınıza getirin.",
  "settings.comms.slack.pitch":
    "Morrow’u tek tıkla Slack’e ekleyin. Her kanalda @ ile etiketleyin veya doğrudan DM atın — ekibinizin çalıştığı yerde yanıtlar, özetler ve güncellemeler.",
  "settings.comms.slack.cap.add": "Tek tıkla ekle",
  "settings.comms.slack.cap.mention": "Kanallarda @ ile etiketle",
  "settings.comms.slack.cap.dm": "Doğrudan mesajlar",
  "settings.comms.discord.label": "Discord",
  "settings.comms.discord.tagline": "Morrow botunu sunucunuza ekleyin.",
  "settings.comms.discord.pitch":
    "Morrow’u tek tıkla bir sunucuya davet edin. Kanalda veya DM’de etiketleyin — sizin ve topluluğunuz için satır içi yanıt verir.",
  "settings.comms.discord.cap.invite": "Tek tıkla davet",
  "settings.comms.discord.cap.mention": "Kanallarda etiketle",
  "settings.comms.discord.cap.dm": "Doğrudan mesajlar",
  "settings.comms.install.approveHint":
    "{label} üzerinde Morrow’u onaylayın — eklendiğinde burası otomatik güncellenir.",
  "settings.triggers.intro":
    "Tetikleyiciler, Morrow’un uygulamalarınızda izlediği anlardır — yeni e-posta, takvim daveti, bir mention. Birini açın; Morrow fark etmeye başlar.",
  "settings.triggers.introFollowUp":
    "İş akışları kurarken bunları eylemlere — yanıtlar, özetler, rutinler — yönlendireceksiniz.",
  "settings.triggers.listeningNow": "{count} şu an dinliyor.",
  "settings.triggers.when": "Ne zaman",
  "settings.triggers.needsSetup": "Kurulum gerekli",
  "settings.triggers.turnOn": "{name} aç",
  "settings.triggers.turnOff": "{name} kapat",
  "settings.triggers.needsValueFirst":
    "Bu tetikleyici önce bir değer istiyor — kurulum arayüzü yakında.",
  "settings.triggers.connectAppFirst": "Açmak önce uygulamayı bağlar.",
  "settings.triggers.noTriggersForApp": "Bu uygulama henüz tetikleyici sunmuyor.",
  "settings.triggers.connectThenListen":
    "Bunlardan birini açın; önce {app} bağlanır, sonra dinlemeye başlarız.",
  "settings.triggers.enabledCount": "{count} açık",
  "settings.triggers.connected": "Bağlı",
  "settings.triggers.notConnected": "Bağlı değil",
  "settings.triggers.genericWatches": "Morrow’un fark edebileceği bu uygulamadan olaylar.",
  "settings.triggers.watches.gmail": "Gelen kutunuza düşen yeni posta, yanıtlar ve etiketler.",
  "settings.triggers.watches.googlecalendar":
    "Davetler, değişiklikler ve başlamak üzere olan etkinlikler.",
  "settings.triggers.watches.slack": "Seçtiğiniz kanallarda mention, DM ve mesajlar.",
  "settings.triggers.watches.github": "Issue’lar, pull request’ler, push’lar ve incelemeler.",
  "settings.triggers.watches.notion": "Çalışma alanınızda yeni ve güncellenen sayfalar.",
  "settings.triggers.watches.linear": "Oluşturulan, atanan ve durum değiştiren görevler.",
  "settings.triggers.watches.googledrive": "Drive’ınıza eklenen, paylaşılan veya değişen dosyalar.",
  "settings.triggers.watches.googlesheets": "İzlediğiniz tablolarda yeni satırlar ve düzenlemeler.",
  "settings.triggers.whatsapp.summary":
    "Kişilerinizden gelen mesajlar — her kural bir iş akışı çalıştırır.",
  "settings.triggers.whatsapp.linked": "Bağlı",
  "settings.triggers.whatsapp.notLinked": "Bağlı değil",
  "settings.triggers.whatsapp.linkFirstBefore": "Önce şurada WhatsApp’ınızı bağlayın",
  "settings.triggers.whatsapp.linkFirstAfter": ", sonra burada kural ekleyin.",
  "settings.triggers.whatsapp.runs": "→ {name} çalıştırır",
  "settings.triggers.whatsapp.noRules":
    "Henüz kural yok — mesaj geldiğinde iş akışı çalıştırmak için altta bir kural ekleyin.",
  "settings.triggers.whatsapp.createWorkflowBefore": "Önce bir",
  "settings.triggers.whatsapp.createWorkflowAfter":
    "oluşturun, sonra bir WhatsApp kuralını ona yönlendirin.",
  "settings.triggers.whatsapp.match.all": "Her mesaj",
  "settings.triggers.whatsapp.match.contact": "Bir kişiden",
  "settings.triggers.whatsapp.match.keyword": "Anahtar kelime içerir",
  "settings.triggers.whatsapp.match.fromContact": "{value} kişisinden",
  "settings.triggers.whatsapp.match.aContact": "bir kişi",
  "settings.triggers.whatsapp.match.contains": '"{value}" içerir',
  "settings.triggers.whatsapp.run": "→ çalıştır",
  "settings.triggers.whatsapp.chooseWorkflow": "İş akışı seç…",
  "settings.triggers.whatsapp.addRule": "Kural ekle",
  "settings.triggers.whatsapp.remove": "Kaldır",
  "settings.triggers.whatsapp.aWorkflow": "bir iş akışı",
  "settings.triggers.whatsapp.workflowLink": "iş akışı",
  "settings.triggers.whatsapp.settingsWhatsApp": "Ayarlar › WhatsApp",
  "sidebar.errorOccurred": "Hata oluştu",
  "sidebar.branchMismatch": "Şu anda başka bir dalda çalışıyorsunuz.",
  "sidebar.terminalProcesses": "{count} terminal süreci çalışıyor",
  "sidebar.terminalProcess": "{count} terminal süreci çalışıyor",
  "chat.tool.readEmail": "E-postayı oku",
  "chat.tool.searchEmail": "E-postada ara",
  "chat.tool.sendEmail": "E-posta gönder",
  "chat.tool.app.browser": "Tarayıcı",
  "chat.tool.app.whatsapp": "WhatsApp",
  "chat.tool.app.morrow": "Morrow",
  "chat.tool.app.email": "E-posta",
  "chat.tool.app.vault": "Kasa",
  "chat.tool.vault.list": "Dosyaları listele",
  "chat.tool.vault.search": "Ara",
  "chat.tool.vault.read": "Oku",
  "chat.tool.vault.shareLink": "Bağlantı paylaş",
  "chat.tool.vault.makePublic": "Herkese aç",
  "chat.tool.browse": "Göz at",
  "chat.tool.message": "Mesaj",
  "chat.tool.browser.navigate": "Git",
  "chat.tool.browser.click": "Tıkla",
  "chat.tool.browser.type": "Yaz",
  "chat.tool.browser.screenshot": "Ekran görüntüsü",
  "chat.tool.browser.scroll": "Kaydır",
  "chat.tool.browser.wait": "Bekle",
  "chat.tool.browser.extract": "Çıkar",
  "chat.tool.browser.fill": "Doldur",
  "chat.tool.browser.back": "Geri",
  "chat.tool.browser.forward": "İleri",
  "chat.tool.browser.close": "Kapat",
  "chat.tool.browser.open": "Aç",
  "chat.tool.browser.generic": "{action}",
  "chat.tool.whatsapp.send": "Gönder",
  "chat.tool.whatsapp.read": "Oku",
  "chat.tool.memory.recall": "Bellek",
  "chat.tool.memory.save": "Hatırla",
  "chat.tool.listAgents": "Ajanları listele",
  "chat.tool.knowledge.search": "Bilgi",
  "chat.tool.searchItems": "Öğeleri ara",
  "chat.tool.showImage": "Görsel göster",
  "chat.tool.showImages": "Görselleri göster",
  "chat.tool.generateImage": "Görsel oluştur",
  "chat.tool.generatePdf": "PDF oluştur",
  "chat.tool.connectApp": "Uygulama bağla",
  "chat.tool.activateTools": "Araçları etkinleştir",
  "chat.tool.spawnSubagent": "Alt ajan başlat",
  "chat.tool.searchWeb": "Web’de aranıyor",
  "chat.tool.searchNews": "Haber ara",
  "chat.tool.searchTopic": "{topic} ara",
  "chat.tool.working": "Çalışıyor",
  "chat.work.searchingWeb": "Web’de aranıyor",
  "chat.work.searchedWeb": "Web’de arandı",
  "chat.work.reading": "Okunuyor",
  "chat.work.read": "Okundu",
  "chat.work.editingFiles": "Dosyalar düzenleniyor",
  "chat.work.editedFiles": "Dosyalar düzenlendi",
  "chat.work.runningCommand": "Komut çalışıyor",
  "chat.work.ranCommand": "Komut çalıştırıldı",
  "chat.work.thinking": "Düşünüyor",
  "chat.work.usingApp": "Bağlı uygulama kullanılıyor",
  "chat.work.usedApp": "Bağlı uygulama kullanıldı",
  "chat.work.working": "Çalışıyor",
  "chat.connect.title": "{app} bağla",
  "chat.connect.connectedTitle": "{app} bağlandı",
  "chat.connect.alreadyLinked": "{app} zaten bağlı",
  "chat.connect.needsAccess": "Devam etmek için Morrow’un {app} erişimine ihtiyacı var",
  "chat.connect.error": "Başlatılamadı — tekrar deneyin",
  "chat.connect.connected": "Bağlı",
  "chat.connect.connect": "Bağlan",
  "chat.connect.connecting": "Bağlanıyor…",
  "chat.agent.answer": "Yanıt",
  "workflows.title": "İş akışları",
  "workflows.subtitle":
    "Morrow’un sizin için kendi kendine yaptığı görevler. Birini oluşturun, kurun ve çalıştırmalarını görün.",
  "workflows.create": "Yeni iş akışı",
  "workflows.import": "İçe aktar",
  "workflows.import.reading": "Okunuyor…",
  "workflows.import.okTitle": "İş akışı içe aktarıldı",
  "workflows.import.okBody":
    "Kapalı olarak geldi, siz açana kadar hiçbir şey çalışmaz. Önce bir gözden geçirin.",
  "workflows.import.cleanBody": "Dosyadaki her şey aktarıldı.",
  "workflows.import.warningsTitle": "Çalışmaya başlaması için ilginizi bekleyenler:",
  "workflows.import.droppedTitle": "Bu dosyaya dahil edilmeyenler:",
  "workflows.import.dropped.vaultFiles": "{count} kasa dosyası",
  "workflows.import.dropped.contactTriggers":
    "Yalnızca tek bir kişi için çalışan {count} tetikleyici",
  "workflows.import.dropped.webhookUrls": "{count} webhook adresi",
  "workflows.import.errorTitle": "Bu dosya içe aktarılamadı",
  "workflows.import.error.unreadable":
    "Bu dosya geçerli JSON değil. Dışa aktarmanın ürettiği .json dosyasını seçin.",
  "workflows.import.error.notAnExport":
    "Bu bir MorrowOS iş akışı dışa aktarımı değil. Dışa aktar’ın indirdiği .json dosyasını seçin.",
  "workflows.import.error.unsupportedVersion":
    "Bu dışa aktarım daha yeni bir MorrowOS’tan geliyor. Güncelleyip yeniden deneyin.",
  "workflows.import.error.rejected": "Sunucu bu dışa aktarımı kabul etmedi.",
  "workflows.import.openWorkflow": "İş akışını aç",
  "workflows.import.dismiss": "Tamam",
  "workflows.export.failed": "Bu iş akışı dışa aktarılamadı.",
  "workflows.export.saved": "Dışa aktarıldı — indirilenlere bakın.",
  "workflows.create.failed": "İş akışı oluşturulamadı — hiçbir şey kaydedilmedi. Tekrar deneyin.",
  "workflows.loadFailed": "İş akışlarınız yüklenemedi. Hepsi yerinde — sorun yalnızca bu listede.",
  "workflows.loadRetry": "Tekrar dene",
  "browser.sessions.title": "Bağlı tarayıcılar",
  "browser.sessions.subtitleOne": "Morrow'un işlem yaptığı tarayıcı.",
  "browser.sessions.subtitleMany":
    "Birden fazla tarayıcı eşleşmiş. Morrow aşağıda işaretli olanı kullanır — kullandığınız tarayıcı o değilse başka birini seçin.",
  "browser.sessions.unnamed": "Adsız tarayıcı",
  "browser.sessions.driving": "Kullanılıyor",
  "browser.sessions.online": "Bağlı",
  "browser.sessions.offline": "Bağlı değil",
  "browser.sessions.lastSeen": "son görülme {when}",
  "browser.sessions.chosenByYou": "sizin seçiminiz",
  "browser.sessions.makePrimary": "Birincil yap",
  "browser.sessions.unsetPrimary": "Birincil",
  "browser.sessions.disconnect": "Bağlantıyı kes",
  "browser.sessions.disconnectAll": "Tümünün bağlantısını kes",
  "browser.sessions.forgetNote":
    "Bağlantıyı kesmek tarayıcıyı Morrow'dan kaldırır; uzantı anahtarını koruduğu için tarayıcıyı yeniden açarsanız bağlanır. Kalıcı olarak kaldırmak için uzantıdan eşleşmeyi kaldırın.",
  "browser.sessions.justNow": "az önce",
  "browser.sessions.minutesAgo": "{count} dk önce",
  "browser.sessions.hoursAgo": "{count} sa önce",
  "browser.sessions.daysAgo": "{count} gün önce",
  "browser.sessions.never": "hiç",
  "workflows.rename.hint": "Yeniden adlandırmak için tıklayın",
  "workflows.rename.label": "Ad",
  "workflows.rename.failed": "Yeniden adlandırılamadı — eski ad kayıtlı kaldı.",
  "workflows.duplicate.failed": "Bu iş akışı çoğaltılamadı.",
  "workflows.empty": "Henüz iş akışı yok. {create} tıkla.",
  "workflows.create.emptyCreate": "+ Oluştur",
  "workflows.empty.title": "Henüz iş akışı yok",
  "workflows.new.title": "Yeni iş akışı",
  "workflows.new.namePlaceholder": "İş akışı adı (ör. Satış yanıtları)",
  "workflows.new.instructionPlaceholder":
    "Bu iş akışının ne yapması gerektiğini anlatın — ne kadar net, o kadar iyi. Örn. Acme için satış temsilcisisin. Biri WhatsApp’tan ürün sorunca katalogdan yanıtla, hazır olana kadar sohbet et, sıcak lead olduğunda Slack’ten haber ver.",
  "workflows.new.manualShow": "Elle kur (tetikleyiciler, uygulamalar ve izinler) — isteğe bağlı",
  "workflows.new.manualHide": "Elle kurulumu gizle",
  "workflows.new.triggersSection": "Tetikleyiciler · ne zaman çalışır",
  "workflows.new.noTriggers":
    "Henüz tetikleyici yok — sohbetten istediğinizde çalışır. Altta mesaj, uygulama olayı ve zamanlama tetikleyicileri ekleyin (istediğiniz kadar).",
  "workflows.new.appsSection": "Kullanabileceği uygulamalar",
  "workflows.new.capabilities": "Yetenekler",
  "workflows.new.cap.browser": "Tarayıcı",
  "workflows.new.cap.memoryRead": "Belleği oku",
  "workflows.new.cap.memoryWrite": "Belleğe yaz",
  "workflows.new.cap.vault": "Dosyalar / kasa",
  "workflows.new.vaultAll": "Tüm kasa dosyaları (belirli dosyalar için işaretleyin).",
  "workflows.new.vaultCount": "Yalnızca bu {count} dosya.",
  "workflows.new.vaultEmpty": "Henüz kasa dosyası yok.",
  "workflows.new.autonomy": "Özerklik",
  "workflows.new.autonomy.read": "Salt okunur",
  "workflows.new.autonomy.approval": "Hareket etmeden önce sor",
  "workflows.new.autonomy.autonomous": "Özerk",
  "workflows.new.createButton": "İş akışı oluştur",
  "workflows.card.noDescription": "Henüz açıklama yok — kurmak için açın.",
  "workflows.card.triggers": "{count} tetikleyici",
  "workflows.card.triggersPlural": "{count} tetikleyici",
  "workflows.card.runs": "{count} çalıştırma",
  "workflows.card.runsPlural": "{count} çalıştırma",
  "workflows.card.edit": "Düzenle",
  "workflows.card.duplicate": "Çoğalt",
  "workflows.card.export": "Dışa aktar",
  "workflows.card.delete": "Sil",
  "workflows.card.enable": "Etkinleştir",
  "workflows.card.pause": "Duraklat",
  "workflows.card.paused": "Duraklatıldı",
  "workflows.card.active": "Etkin",
  "workflows.toggle.failed": "Şu anda değiştirilemedi — tekrar deneyin.",
  "workflows.card.viewRuns": "Çalıştırmaları gör",
  "workflows.card.hideRuns": "Çalıştırmaları gizle",
  "workflows.card.stopRun": "Durdur",
  "workflows.match.anyMessage": "her mesaj",
  "workflows.match.fromContact": "{value} kişisinden",
  "workflows.match.aContact": "bir kişi",
  "workflows.match.containing": '"{value}" içerir',
  "workflows.apps.searchPlaceholder": "1.000+ uygulama içinde ara…",
  "workflows.apps.searching": "Aranıyor…",
  "workflows.apps.noMatch": "Eşleşen uygulama yok.",
  "workflows.apps.connected": "bağlı",
  "workflows.apps.scopeEmpty": "Seçim yok → iş akışı bağlı tüm uygulamaları kullanabilir.",
  "workflows.apps.scopeFenced": "{count} uygulama ile sınırlı. Nokta = zaten bağlı.",
  "workflows.composer.source.chat": "Sohbetten",
  "workflows.composer.source.comms": "Mesaj tetikleyicisi",
  "workflows.composer.source.triggers": "Tetikleyiciler",
  "workflows.composer.source.schedule": "Zamanlama",
  "workflows.composer.source.vault": "Kasa klasörü",
  "workflows.composer.vault.hint":
    "Kasa klasörlerinizden birine bir dosya düştüğünde bunu çalıştır — dosya başına bir çalıştırma, dosyanın ne olduğu ve ne yazdığı iletilir.",
  "workflows.composer.vault.loading": "Klasörleriniz yükleniyor…",
  "workflows.composer.vault.noFolders": "Henüz kasa klasörünüz yok.",
  "workflows.composer.vault.goToVault": "Kasa'da bir tane oluşturun",
  "workflows.composer.vault.chip": "{folder} klasörüne yeni dosya",
  "workflows.composer.vault.unknownFolder": "bir kasa klasörü",
  "workflows.composer.whatsapp.selected":
    "Bu iş akışı, kişisel WhatsApp'ınıza biri mesaj attığında çalışır. Aşağıdan başka bir eşleşme ekleyin veya yukarıdan kaldırın.",
  "workflows.composer.whatsapp.hint":
    "Kişisel WhatsApp'ınıza biri mesaj attığında bunu çalıştır (herhangi bir mesaj, belirli bir kişi veya bir anahtar kelime).",
  "workflows.composer.chat.hint":
    "Zaten açık — herhangi bir sohbette bu iş akışını adıyla isteyin, çalışır. Burada kurulacak bir şey yok. Kendi kendine de başlamasını istiyorsanız yukarıdan başka bir kaynak seçin.",
  "workflows.composer.addTrigger": "Tetikleyici ekle",
  "workflows.composer.addSchedule": "Zamanlama ekle",
  "workflows.composer.discordNote":
    "Discord gelen mesajları için gateway botu gerekiyor (yayında); şimdi kaydedilir, hazır olunca tetiklenir.",
  "workflows.composer.noTriggersYet": "Henüz tetikleyici yok — önce şurada açın:",
  "workflows.composer.settingsTriggers": "Ayarlar › Tetikleyiciler",
  "workflows.composer.thenPick": ", sonra buradan seçin.",
  "workflows.composer.tapApp":
    "Tetikleyicisini eklemek için bir uygulamaya dokunun. Listeyi şurada yönetin:",
  "workflows.composer.schedule.next": "sıradaki: ",
  "workflows.composer.schedule.invalidCron":
    "Sonraki çalışmaları görmek için geçerli bir cron girin.",
  "workflows.composer.cadence.daily": "Her gün",
  "workflows.composer.cadence.weekdays": "Hafta içi",
  "workflows.composer.cadence.weekly": "Haftalık",
  "workflows.composer.cadence.hourly": "Saatlik",
  "workflows.composer.cadence.everyNMinutes": "Dakika",
  "workflows.composer.cadence.everyNHours": "Saat",
  "workflows.composer.cadence.custom": "Özel",
  "workflows.composer.every.prefix": "Her",
  "workflows.composer.every.minutes": "dakikada bir",
  "workflows.composer.every.hours": "saatte bir",
  "workflows.composer.atMinute": "dakikada",
  "workflows.composer.atTime": "saat",
  "workflows.composer.cronPlaceholder": "cron örn. 0 9 * * 1-5",
  "workflows.composer.matchPlaceholder.contact": "kişi / numara / jid",
  "workflows.composer.matchPlaceholder.keyword": "anahtar kelime",
  "workflows.setup.back": "İş akışları",
  "workflows.setup.overviewHint": "Etkinlik, tetikleyiciler ve çalıştırmalar bir bakışta.",
  "workflows.setup.triggers": "Tetikleyiciler",
  "workflows.setup.runsFromChat": "Sohbetten çalışır.",
  "workflows.setup.apps": "Uygulamalar",
  "workflows.setup.allConnectedApps": "Tüm bağlı uygulamalar",
  "workflows.setup.capabilities": "Yetenekler · özerklik",
  "workflows.setup.appsOnly": "yalnızca uygulamalar",
  "workflows.setup.runs": "Çalıştırmalar",
  "workflows.setup.testRun": "Test çalıştır",
  "workflows.setup.noRunsYet":
    "Henüz çalıştırma yok. Test edin veya bir tetikleyici bekleyin. Kayıt böyle görünecek:",
  "workflows.setup.runCompleted": "Tamamlandı",
  "workflows.setup.runFailed": "Başarısız — {error}",
  "workflows.setup.runFailedShort": "Başarısız",
  "workflows.setup.exampleRuns": "Örnek — gerçek çalıştırmalar bunun yerine geçer",
  "workflows.setup.edit": "Düzenle",
  "workflows.setup.chat": "Sohbet",
  "workflows.setup.test": "Test",
  "workflows.setup.save": "Kaydet",
  "workflows.setup.done": "Bitti",
  "workflows.setup.connect": "Bağlan",
  "workflows.setup.myWhatsapp": "WhatsApp’ım",
  "workflows.setup.runsFromChatAdd": "Sohbetten çalışır. Tetikleyici ekleyin:",
  "workflows.setup.instruction": "Talimat",
  "workflows.setup.instructionPlaceholder":
    "Morrow her seferinde ne yapar. Yazın veya Oluştur’u kullanın.",
  "workflows.setup.editWithAi": "AI ile düzenle",
  "workflows.setup.clarifyBuild": "Netleştirin, sonra tekrar Oluştur:",
  "workflows.setup.buildWorkflow": "Bu iş akışını oluştur",
  "workflows.setup.skipManual": "Atla — elle kur",
  "workflows.setup.send": "Gönder",
  "workflows.setup.chatEmpty":
    'İş akışını tarif ederek oluşturun veya değişiklik isteyin — örn. "Slack bildirimi ekle", "yalnızca Ali’ye yanıtla", "önce takvimime bak". Yapar ve ne değiştiğini söylerim.',
  "workflows.setup.chatWorking": "çalışıyor…",
  "workflows.schedule.dow.0": "Pazar",
  "workflows.schedule.dow.1": "Pazartesi",
  "workflows.schedule.dow.2": "Salı",
  "workflows.schedule.dow.3": "Çarşamba",
  "workflows.schedule.dow.4": "Perşembe",
  "workflows.schedule.dow.5": "Cuma",
  "workflows.schedule.dow.6": "Cumartesi",
  "workflows.schedule.noSchedule": "(zamanlama yok)",
  "workflows.schedule.everyHour": "Her saat :{minute}’de",
  "workflows.schedule.everyMinute": "Her dakika",
  "workflows.schedule.everyNMinutes": "{n} dakikada bir",
  "workflows.schedule.everyNHours": "{n} saatte bir, :{minute}",
  "workflows.schedule.everyDayAt": "Her gün {time}",
  "workflows.schedule.everyWeekdayAt": "Hafta içi her gün {time}",
  "workflows.schedule.everyDowAt": "Her {day} {time}",
  "routines.title": "Rutinler",
  "routines.subtitle":
    "Zamanlanmış bir iş akışı — ne yapacağını ve ne zaman çalışacağını ayarlayın; kendi kendine çalışır.",
  "routines.new": "Yeni rutin",
  "routines.loading": "Yükleniyor…",
  "routines.empty": "Henüz rutin yok. Bir tane oluştur — bir ad, ne yaptığı ve ne zaman.",
  "routines.nameLabel": "Ad",
  "routines.namePlaceholder": "Ad — örn. Sabah özet",
  "routines.descriptionPlaceholder":
    "Ne yapmalı? örn. Okunmamış e-postalarımı özetle ve öne çıkanları WhatsApp’tan gönder.",
  "routines.whenItRuns": "Ne zaman çalışır",
  "routines.instructionLabel": "Ne yapmalı",
  "routines.nextRunLabel": "Sonraki {when}",
  "routines.cancel": "İptal",
  "routines.create": "Rutin oluştur",
  "routines.empty.title": "Henüz rutin yok",
  "routines.empty.description":
    "Adını verin, ne yapacağını yazın ve zamanlamayı seçin — gerisini Morrow iş akışına dönüştürür.",
  "routines.newDialog.description":
    "Rutin, zamanlanmış bir iş akışıdır. Oluşturduktan sonra akışı düzenleyebilirsiniz.",
  "routines.nextRun": "· sonraki {when}",
  "routines.deleteAria": "Rutinin zamanlamasını sil",
  "routines.duplicateAria": "Rutini çoğalt",
  "workflows.canvas.kind.trigger": "Tetikleyici",
  "workflows.canvas.kind.app": "Uygulama",
  "workflows.canvas.kind.browser": "Tarayıcı (cihazınız)",
  "workflows.canvas.kind.cloudBrowser": "Bulut Tarayıcı",
  "workflows.canvas.kind.computer": "Bulut Bilgisayar",
  "workflows.canvas.kind.vault": "Kasa",
  "workflows.canvas.kind.decision": "Koşul",
  "workflows.canvas.kind.foreach": "Her biri için",
  "workflows.canvas.forEach.list": "Liste",
  "workflows.canvas.forEach.sourceSheet": "Google E-Tablo satırları",
  "workflows.canvas.forEach.sourceStep": "Önceki adımın öğeleri",
  "workflows.canvas.forEach.sheetLink": "Tablo bağlantısı veya kimliği",
  "workflows.canvas.forEach.sheetTab": "Sayfa adı",
  "workflows.canvas.forEach.skipWhere": "Şu satırları atla:",
  "workflows.canvas.forEach.column": "sütun",
  "workflows.canvas.forEach.value": "değer",
  "workflows.canvas.forEach.eachItem": "Her öğe için",
  "workflows.canvas.forEach.bodyBrowser": "Tarayıcıda",
  "workflows.canvas.forEach.bodyApp": "Bağlı bir uygulamayla",
  "workflows.canvas.forEach.bodyAi": "Yalnızca yapay zekâ (yaz, özetle)",
  "workflows.canvas.forEach.bodyPlaceholder":
    "ör. Ekteki görseli {item.Link} adresine açıklamasız paylaş. Herhangi bir sütun için {item.Sütun} kullan.",
  "workflows.canvas.forEach.atOnce": "Aynı anda kaç tane",
  "workflows.canvas.forEach.secondsApart": "sn arayla",
  "workflows.canvas.forEach.onFailSkip": "Biri başarısız olursa: devam et",
  "workflows.canvas.forEach.onFailStop": "Biri başarısız olursa: dur",
  "workflows.canvas.forEach.saveTo": "Her sonucu tabloya kaydet",
  "workflows.canvas.forEach.outcomeColumn": "Sonuç sütunu",
  "workflows.canvas.forEach.noteColumn": "Not sütunu",
  "workflows.canvas.forEach.dryRun": "Deneme çalıştırması",
  "workflows.canvas.forEach.dryRunHint":
    "Her öğede son tıklamaya kadar gider ama basmaz. Hiçbir şey kaydetmez.",
  "workflows.canvas.trigger.needsImage": "Çalışmak için görsel gerekir",
  "workflows.canvas.trigger.needsAttachment": "Çalışmak için ek gerekir",
  "workflows.canvas.trigger.att.any": "Herhangi bir dosya",
  "workflows.canvas.trigger.att.image": "Görsel",
  "workflows.canvas.trigger.att.document": "Belge",
  "workflows.canvas.forEach.bodyEmptyTitle": "Her öğe için çalışır",
  "workflows.canvas.forEach.bodyEmptyHint":
    "Her öğe için yapılacak adımı ekle. Paralel çalışırlar.",
  "workflows.canvas.forEach.addStep": "Adım ekle",
  "workflows.canvas.forEach.summary": "Aynı anda {n} · {fail}",
  "workflows.canvas.forEach.perItem": "Her öğe için",
  "workflows.canvas.kind.output": "Çıktı",
  "workflows.canvas.delete": "Sil",
  "workflows.canvas.editTriggers": "Tetikleyicileri düzenle",
  "workflows.canvas.edit": "Düzenle",
  "workflows.canvas.insertTitle": "Buraya adım ekle",
  "workflows.canvas.insertApp": "+ Uygulama",
  "workflows.canvas.insertBrowser": "+ Tarayıcı",
  "workflows.canvas.insertDecision": "+ Koşul",
  "workflows.canvas.feedsData": "Veri aktar",
  "workflows.canvas.feedsDataOn": "✓ Veri aktar",
  "workflows.canvas.dependsHint":
    "Bunu AÇIK bir veri kaynağı yap: çıktısı, sonraki adım çalışmadan önce ona aktarılır. (Düz bir bağlantı çıktıyı zaten aktarır; bu onu veri olarak adlandırır.)",
  "workflows.canvas.dependsEdgeTitle": "Açık veri kaynağı — düzenlemek için tıkla",
  "workflows.canvas.modelGate": "Geçit · hızlı",
  "workflows.canvas.modelQuick": "Hızlı · ucuz",
  "workflows.canvas.modelFull": "Kapsamlı",
  "workflows.canvas.modelFullTitle": "Enine boyuna düşünür ve araç kullanabilir",
  "workflows.canvas.chipGate": "Önce çalışır · ucuz",
  "workflows.canvas.chipRouter": "Bir yol seçer · ucuz",
  "workflows.canvas.chipLoopsBack": "{target} adımına döner",
  "workflows.canvas.chipUses": "Kullanır: {source}",
  "workflows.canvas.chipParallel": "Paralel çalışabilir",
  "workflows.canvas.chipAgent": "Ajan {n}",
  "workflows.canvas.agentHint":
    "Her adım KENDİ ajan turunda (kendi renginde) çalışır ve yalnızca kendi kaynaklarının çıktılarını görür — ortak bir konuşmayı değil. Karar her iki durumda da ucuz modelle çalışır: düz bir evet/hayır kontrolü pahalı adımlardan önce çalışır, yolları olan bir karar ise akıştaki kendi yerinde çalışır ve sıradakini seçer.",
  "workflows.canvas.dependsHandle":
    "Bağlıdır — başka bir adımın çıktısını, bu adım çalışmadan önce verisini beslemek için buraya sürükle. Birden fazla olabilir.",
  "workflows.canvas.dependsHandleLabel": "bağlı",
  "workflows.canvas.removeEdge": "Bağlantıyı kes",
  "workflows.canvas.removeApp": "Bu uygulamayı kaldır",
  "workflows.canvas.loopsBack": "geri döner",
  "workflows.canvas.addAnotherApp": "Başka bir uygulama ekle…",
  "workflows.setup.branchKept":
    "Dallanan akışın korundu. Yapay zekâ oluşturucu yalnızca düz bir çizgi çizebiliyor; kendi sürümünü uygulamak yollarını ve döngünü silerdi — diğer değişiklikleri uygulandı.",
  "workflows.canvas.appModeAll": "İkisi de gerekli",
  "workflows.canvas.appModeAny": "Herhangi biri",
  "workflows.canvas.removeEdgeHint":
    "Bu bağlantıyı kaldır. Adımlar kalır; yalnızca aralarındaki bağ gider.",
  "workflows.canvas.close": "Kapat",
  "workflows.canvas.routes.title": "Yollar",
  "workflows.canvas.routes.hint":
    "Bu adım TEK bir yol seçer. Bir yolun kendi noktasını sıradaki adıma bağla — birini önceki bir adıma geri bağlarsan döngü olur.",
  "workflows.canvas.routes.add": "Yol ekle",
  "workflows.canvas.routes.remove": "Bu yolu kaldır",
  "workflows.canvas.routes.label": "Ad",
  "workflows.canvas.routes.labelPlaceholder": "Kalan satırlar",
  "workflows.canvas.routes.when": "Şu durumda seç",
  "workflows.canvas.routes.enable": "Bu adım yollar arasında seçsin",
  "workflows.canvas.routes.enableHint":
    "Akışı sadece durdurmak yerine, ayrı ayrı bağlayabileceğin adlandırılmış çıkışlar ver.",
  "workflows.canvas.routes.moreDefault": "Daha var",
  "workflows.canvas.routes.doneDefault": "Bitti",
  "workflows.canvas.routes.loopsTo": "geri döner",
  "workflows.canvas.routes.when.hasMoreItems": "Hâlâ işlenecek öğe var",
  "workflows.canvas.routes.when.contains": "Sonuçta şu geçiyor",
  "workflows.canvas.routes.when.notContains": "Sonuçta şu geçmiyor",
  "workflows.canvas.routes.when.ask": "Kararı modele bırak",
  "workflows.canvas.routes.when.always": "Diğer her durumda",
  "workflows.canvas.routes.valuePlaceholder": "BLOCKED",
  "workflows.canvas.routes.askPlaceholder": "Gönderi gerçekten yayına girdi mi?",
  "workflows.canvas.routes.orderHint": "Yukarıdan aşağıya bakılır — ilk uyan kazanır.",
  "workflows.canvas.routes.maxPasses": "Döngü sınırı",
  "workflows.canvas.routes.maxPassesHint":
    "Durup yaptığını bildirmeden önce kaç tur atabilir. Hiç bitmeyen bir döngünün sonsuza kadar çalışmasını engeller.",
  "workflows.canvas.end.whenDone": "Bitince",
  "workflows.canvas.end.modeMessage": "Mesaj gönder",
  "workflows.canvas.end.modeSave": "Kasa'ya kaydet",
  "workflows.canvas.end.modeWebhook": "Webhook çağır",
  "workflows.canvas.end.modeNone": "Sadece bitir (mesaj yok)",
  "workflows.canvas.end.webhookPlaceholder": "https://… (sonucu buraya POST et)",
  "workflows.canvas.insp.close": "Kapat",
  "workflows.canvas.insp.instruction": "Bu adımın talimatı",
  "workflows.canvas.insp.notes": "Notlar (isteğe bağlı)",
  "workflows.canvas.insp.instructionPlaceholder": "Bu adım ne yapmalı…",
  "workflows.canvas.insp.model": "Ne kadar dikkatli düşünsün",
  "workflows.canvas.insp.modelFast": "Hızlı",
  "workflows.canvas.insp.modelHint":
    "Kapsamlı, araç kullanabilir ve içinde yargı gerektiren bir adımı yürütebilir. Hızlı ise ucuz bir evet/hayır düzeyinde kontroldür — çok daha ucuz ve hızlıdır ama araç kullanamaz; bu yüzden yalnızca basit bir ayıklama/sınıflandırma adımı için seç.",
  "workflows.canvas.insp.decisionModelNote":
    "Karar her zaman hızlı yolu kullanır ve bunun gibi düz bir evet/hayır kontrolü pahalı adımlardan önce çalışır — böylece ilgisiz bir çalışma neredeyse hiç maliyet çıkarmaz.",
  "workflows.canvas.insp.routerModelNote":
    "Karar her zaman hızlı yolu kullanır. Bunun yolları var, bu yüzden akışta durduğu yerde — kendisini besleyen adımlardan sonra — çalışır ve hangi yolun devam edeceğini seçer.",
  "workflows.canvas.insp.uses": "Bu adım neyi okur",
  "workflows.canvas.insp.removeSource": "Bu adımı okumayı bırak",
  "workflows.canvas.insp.noSources":
    "Yalnızca kendinden önceki adımı. Akışın daha önceki bir yerinden de bir şey okuması için aşağıdan adım ekle.",
  "workflows.canvas.insp.addSource": "Ayrıca bir adımı oku…",
  "workflows.canvas.insp.waitsHint":
    "Bu adım kaynaklarının verisini bekler, sonra her birini adıyla etiketlenmiş görür.",
  "workflows.canvas.insp.parallelHint":
    "Bu adım bir önceki adımdan sonra çalışır ve onun çıktısını alır.",
  "workflows.canvas.insp.outputs": "Adlandırılmış çıktılar",
  "workflows.canvas.insp.outputsHint":
    "Sonraki bir adımın {{BuAdım.alan}} olarak okuyabileceği alanlar. Bu adımdan, yanıtını tam olarak bu anahtarları içeren bir JSON nesnesiyle bitirmesi istenir.",
  "workflows.canvas.insp.outputsPlaceholder": "Bir alan ekle, örn. fiyat — Enter",
  "workflows.canvas.insp.removeOutput": "Alanı kaldır",
  "workflows.canvas.insp.forEachSource": "Döngü yapılacak liste",
  "workflows.canvas.insp.forEachSourceHint":
    "Bu adımın üzerinde döngü yapacağı liste hangi kaynağın çıktısıdır.",
  "workflows.canvas.addKind": "{kind} ekle",
  "workflows.canvas.chooseApp": "Uygulama seç…",
  "workflows.canvas.searchApps": "1000+ uygulama ara…",
  "workflows.canvas.noConnectedApps": "Bağlı uygulama yok — tümünü aramak için yazın.",
  "workflows.canvas.noMatches": "Eşleşme yok.",
  "workflows.canvas.badgePersonal": "kişisel",
  "workflows.canvas.appDoInOrder": "Sırayla yap",
  "workflows.canvas.appActionPlaceholder": "örn. son e-postaları oku",
  "workflows.canvas.removeAction": "Eylemi kaldır",
  "workflows.canvas.thenMore": "sonra…",
  "workflows.canvas.browserPlaceholder": "Web’de ne yapılacak — örn. CRM’i aç ve lead durumunu al",
  "workflows.canvas.cloudBrowserPlaceholder":
    "Web’de ne yapılacak (yönetilen tarayıcı, cihaz gerekmez) — örn. giriş yap ve raporu dışa aktar",
  "workflows.canvas.computerPlaceholder":
    "Ne çalıştırılacak — örn. bu API’yi çağır ve JSON’u ayrıştır, ya da yüklenen dosyayı işle",
  "workflows.canvas.outputPlaceholder":
    "Ne çıkar — örn. kişiye yanıtla / boş slotları mesajla gönder",
  "workflows.canvas.sendOn": "Gönderim kanalı",
  "workflows.canvas.autonomous": "Çalışmaya devam et (tek mesajda durma, karşılıklı yanıtla)",
  "workflows.canvas.decisionHint": "Yalnızca bu doğruysa devam et — değilse akışı durdur.",
  "workflows.canvas.routes.cardHint":
    "TEK bir yoldan gider. Bir yolun noktasını sıradaki adıma bağla — önceki bir adıma bağlarsan döngü olur.",
  "workflows.canvas.decisionPlaceholder":
    "örn. e-posta Summing’den biri / mesaj toplantıyla ilgili",
  "workflows.canvas.vaultPickFiles": "Kullanabileceği dosyaları seç",
  "workflows.canvas.vaultFilesSelected": "{count} dosya seçildi",
  "workflows.canvas.vaultFilesSelectedPlural": "{count} dosya seçildi",
  "workflows.canvas.vaultEmpty":
    "Kasanızda henüz dosya yok — Kasaya ekleyin, sonra buradan işaretleyin.",
  "workflows.canvas.defaultTrigger": "Sohbetten / bir tetikleyiciden",
  "workflows.canvas.defaultNewTrigger": "Yeni tetikleyici",
  "workflows.setup.fromChat": "Sohbetten",
  "workflows.setup.fromChatTrigger": "Sohbetten / bir tetikleyiciden",
  "workflows.setup.defaultOutputText": "Sonucu bana mesajla",
  "workflows.setup.eventFallback": "olay",
  "workflows.setup.notFound": "İş akışı bulunamadı.",
  "workflows.setup.loadingWorkflow": "İş akışı yükleniyor…",
  "workflows.setup.runsTab": "Çalıştırmalar",
  "workflows.setup.runsTabCount": "Çalıştırmalar ({count})",
  "workflows.setup.noRunsChat": "Henüz çalıştırma yok. Test’e basın veya bir tetikleyici bekleyin.",
  "workflows.setup.chatAiPlaceholder": "AI’dan oluşturmasını veya değiştirmesini isteyin…",
  "workflows.setup.plan.buildingTitle": "İş akışınız oluşturuluyor…",
  "workflows.setup.plan.understandingTitle": "İsteğiniz anlaşılıyor…",
  "workflows.setup.plan.buildingBody":
    "Plan tetikleyicilere, adımlara ve talimatlara dönüştürülüyor.",
  "workflows.setup.plan.understandingBody":
    "Açıklamanız okunuyor, sadeleştiriliyor ve ne gerektiği belirleniyor.",
  "workflows.setup.plan.heresThePlan": "Plan",
  "workflows.setup.plan.startsWhen": "Ne zaman başlar",
  "workflows.setup.plan.tools": "Kullanacağı araçlar",
  "workflows.setup.plan.howItWorks": "Nasıl çalışır",
  "workflows.setup.plan.worthClarifying": "Netleştirmeye değer",
  "workflows.setup.plan.clarifyHint":
    "Bunları alttaki sohbette yanıtlayın veya şimdi oluşturup sonra iyileştirin.",
  "workflows.setup.plan.chatTitle": "Sohbet — planı netleştir",
  "workflows.setup.plan.thinking": "düşünüyor…",
  "workflows.setup.plan.inputPlaceholder": "Değişiklik isteyin veya soruları yanıtlayın…",
  "workflows.setup.toast.typeIntent": "Ne yapması gerektiğini yazın, sonra Oluştur’a basın.",
  "workflows.setup.toast.couldNotBuild":
    "Şu an oluşturulamadı — model relay’i kontrol edin veya adımları elle ekleyin.",
  "workflows.setup.toast.builtEndToEnd":
    "Uçtan uca kuruldu — tetikleyiciler, akış ve talimat hazır. Test edin.",
  "workflows.setup.toast.builtLive":
    "Kuruldu — tetikleyiciler, akış ve adımlar ayarlandı. Yayında.",
  "workflows.setup.toast.couldNotBuildShort":
    "Şu an oluşturulamadı — tekrar deneyin veya adımları elle ekleyin.",
  "workflows.setup.toast.saved": "Kaydedildi — bu iş akışı yayında.",
  "workflows.setup.toast.buildFirst": "Önce akışı kurun (adım ekleyin veya AI ile taslak çıkarın).",
  "workflows.setup.toast.couldNotRun": "Çalıştırma başlatılamadı.",
  "workflows.setup.missing.prefix": "Çalıştırmak için hâlâ gereken:",
  "workflows.setup.missing.connect": "{apps} bağlayın",
  "workflows.setup.missing.pickApp": "boş adımlar için bir uygulama seçin",
  "workflows.canvas.channel.any": "Herhangi / karar versin",
  "workflows.canvas.channel.personalWhatsapp": "WhatsApp — kişisel (bağlantı)",
  "workflows.canvas.channel.whatsapp": "WhatsApp — mesajlaşma",
  "workflows.canvas.channel.telegram": "Telegram — mesajlaşma",
  "workflows.canvas.channel.slack": "Slack — mesajlaşma",
  "workflows.canvas.channel.discord": "Discord — mesajlaşma",
  "workflows.canvas.channel.chat": "Morrow sohbet",
  "settings.search.organization": "Organizasyon",
  "settings.search.organizationMembers": "Üyeler ve roller",
  "settings.search.packages": "Paketler",
  "settings.search.packagesAddons": "Eklentiler ve kredi fonları",
  "settings.search.archive": "Arşivlenen sohbetler",
  "settings.search.helpCenter": "Yardım Merkezi",
  "settings.search.submitRequest": "Talep gönder",
  "settings.search.systemStatus": "Sistem durumu",
  "settings.search.supportSetup": "Kurulum ve başlangıç",
  "settings.search.supportIntegrations": "Entegrasyonlar",
  "settings.search.supportMemory": "Şirket belleği",
  "settings.search.supportSecurity": "Güvenlik ve gizlilik",
  "settings.search.supportBilling": "Faturalama ve planlar",
  "settings.search.supportFaq": "SSS",
  "settings.search.supportEmail": "Genel destek",
  "settings.search.supportSecurityEmail": "Güvenlik iletişim",
  "settings.search.supportLegalEmail": "Yasal iletişim",
  "settings.search.supportPhone": "Telefon",
  "settings.search.supportBookCall": "Görüşme ayarla",
  "settings.search.privacyPolicy": "Gizlilik Politikası",
  "settings.search.termsOfService": "Kullanım Koşulları",
  "settings.search.dpa": "Veri İşleme Eki",
  "settings.search.cookiePolicy": "Çerez Politikası",
  "settings.search.trustCenter": "Güven Merkezi",
  "settings.search.legalCompany": "Enortic, Inc.",
  "settings.language.description":
    "Arayüz dili. Sistem varsayılanı tarayıcı veya işletim sistemini izler.",
  "settings.timeFormat.description":
    "Sistem varsayılanı tarayıcı veya işletim sistemi saatini izler.",
  "settings.timeFormat.12hour": "12 saat",
  "settings.timeFormat.24hour": "24 saat",
  "settings.timeFormat.aria": "Saat biçimi",
  "settings.glassOpacity.description":
    "Cam yüzeylerin ne kadar saydam olacağını ayarlar. Yüksek değerler menüleri, pencereleri ve yazma kutusunu daha opak yapar.",
  "settings.environmentIdentification.description":
    "Dev ve Nightly ortamlarının nasıl ayırt edileceğini seçin.",
  "settings.environmentIdentification.artwork": "Görsel",
  "settings.environmentIdentification.pill": "Sürüm etiketi",
  "settings.environmentIdentification.none": "Yok",
  "settings.interfaceFont.description": "MorrowOS arayüzünün tamamında kullanılan yazı tipi.",
  "settings.interfaceFont.size": "Arayüz yazı tipi boyutu",
  "settings.promptFont.description": "Yalnızca istem yazdığınız kutu. Burada mono iyi durur.",
  "settings.promptFont.size": "İstem yazı tipi boyutu",
  "settings.fontSmoothing.description":
    "Metni macOS’un daha kalın varsayılanı yerine daha ince gri tonlu kenar yumuşatma ile çizer.",
  "settings.archiveConfirmation.description":
    "Bir sohbet arşivlenmeden önce satır içi arşiv eyleminde ikinci bir tıklama iste.",
  "settings.deleteConfirmation.description": "Bir sohbeti ve geçmişini silmeden önce sor.",
  "settings.textGenerationModel.description":
    "Sohbet başlığı gibi üretilen metinler için varsayılan model.",
  "settings.about.version": "Uygulamanın güncel sürümü.",
  "settings.diagnostics.view": "Tanılamayı gör",
  "settings.appearance.mode": "Görünüm kipi",
  "settings.appearance.system": "Sistem",
  "settings.appearance.light": "Açık",
  "settings.appearance.dark": "Koyu",
  "settings.appearance.followSystem": "Sistem görünümünü izle",
  "settings.appearance.useLight": "Açık kipi kullan",
  "settings.appearance.useDark": "Koyu kipi kullan",
  "settings.appearance.intro":
    "MorrowOS’un görünümünü seçin. Hazır bir tema kullanın veya kendinizinkini yapın.",
  "settings.appearance.createTheme": "Tema oluştur",
  "settings.appearance.importTheme": "Tema içe aktar",
  "settings.typography": "Tipografi",
  "settings.reset.language": "dil",
  "settings.reset.timeFormat": "saat biçimi",
  "settings.reset.toDefault": "Varsayılana sıfırla",
  "settings.reset.aria": "{label} varsayılana sıfırla",
  "settings.reset.glassOpacity": "cam opaklığı",
  "settings.reset.environmentIdentification": "ortam kimliği",
  "settings.reset.fontSmoothing": "yazı tipi yumuşatma",
  "settings.reset.backgroundActivity": "arka plan etkinliği",
  "settings.reset.archiveConfirmation": "arşiv onayı",
  "settings.reset.deleteConfirmation": "silme onayı",
  "settings.reset.textGenerationModel": "metin üretim modeli",
  "settings.glassOpacity.aria": "Cam opaklığı",
  "settings.fontSmoothing.aria": "Yazı tipi yumuşatma",
  "settings.archiveConfirmation.aria": "Sohbet arşivlemeyi onayla",
  "settings.deleteConfirmation.aria": "Sohbet silmeyi onayla",
  "settings.backgroundActivity": "Arka plan etkinliği",
  "settings.backgroundActivity.balanced": "Dengeli",
  "settings.backgroundActivity.performance": "Performans",
  "settings.backgroundActivity.batterySaver": "Pil tasarrufu",
  "settings.backgroundActivity.advanced": "Gelişmiş",
  "settings.backgroundActivity.description.balanced":
    "İstemciler boştayken, ana makine kilitliyken veya düşük güç kipinde arka plan yoklamalarını duraklatır.",
  "settings.backgroundActivity.description.performance":
    "Abone bir istemci bağlı kaldığı sürece sınırlı arka plan yoklamalarına izin verir.",
  "settings.backgroundActivity.description.batterySaver":
    "Ana makine veya istemci pildeyken de arka plan yoklamalarını duraklatır.",
  "settings.backgroundActivity.description.advanced":
    "Seçilen ortak güç politikasıyla özel arka plan aralıkları kullanır.",
  "settings.backgroundActivity.description.advancedCurrent":
    "{description} Geçerli ortak politika: {policy}.",
  "settings.backgroundActivity.policyTooltip":
    "Bu ortak politika, Git yenilemeleri ve sağlayıcı sağlık yoklamaları gibi arka plan işlerini kendi aralıkları dolduktan sonra kısıtlar.",
  "settings.backgroundActivity.aria": "Arka plan etkinliği profili",
  "settings.backgroundActivity.configure": "Arka plan etkinliğini yapılandır",
  "settings.backgroundActivity.configureAria": "Gelişmiş arka plan etkinliğini yapılandır",
  "settings.backgroundActivity.dialogTitle": "Arka plan etkinliği",
  "settings.backgroundActivity.dialogDescription":
    "Ortak güç politikasını ve onu besleyen arka plan aralıklarını ayarlayın.",
  "settings.backgroundActivity.sharedPolicy": "Ortak politika",
  "settings.backgroundActivity.sharedPolicyDescription":
    "Abone bir aralık tetiklendikten sonra arka plan işinin çalışıp çalışamayacağını denetler.",
  "settings.backgroundActivity.sharedPolicyAria": "Ortak arka plan politikası",
  "settings.backgroundActivity.gitFetch": "Git fetch aralığı",
  "settings.backgroundActivity.gitFetchDescription": "Uzak dal durumunu arka planda yeniler.",
  "settings.backgroundActivity.gitFetchDecrease": "Git fetch aralığını azalt",
  "settings.backgroundActivity.gitFetchInput": "Git fetch aralığı (saniye)",
  "settings.backgroundActivity.gitFetchIncrease": "Git fetch aralığını artır",
  "settings.backgroundActivity.providerHealth": "Sağlayıcı sağlık aralığı",
  "settings.backgroundActivity.providerHealthDescription":
    "Sağlayıcı kullanılabilirliğini, sürümleri, kimlik durumunu ve model meta verisini yeniler.",
  "settings.backgroundActivity.providerHealthDecrease": "Sağlayıcı sağlık aralığını azalt",
  "settings.backgroundActivity.providerHealthInput": "Sağlayıcı sağlık aralığı (saniye)",
  "settings.backgroundActivity.providerHealthIncrease": "Sağlayıcı sağlık aralığını artır",
  "settings.backgroundActivity.hostPower": "Ana makine güç izleyicisi",
  "settings.backgroundActivity.hostPowerDescription":
    "İstemciler etkinken ana makine güç durumunu yoklar.",
  "settings.backgroundActivity.hostPowerDecrease": "Etkin ana makine güç aralığını azalt",
  "settings.backgroundActivity.hostPowerInput": "Etkin ana makine güç aralığı (saniye)",
  "settings.backgroundActivity.hostPowerIncrease": "Etkin ana makine güç aralığını artır",
  "settings.backgroundActivity.idleHost": "Boşta ana makine izleyicisi",
  "settings.backgroundActivity.idleHostDescription":
    "Ön planda istemci yokken ana makine güç durumunu yoklar.",
  "settings.backgroundActivity.idleHostDecrease": "Boşta ana makine güç aralığını azalt",
  "settings.backgroundActivity.idleHostInput": "Boşta ana makine güç aralığı (saniye)",
  "settings.backgroundActivity.idleHostIncrease": "Boşta ana makine güç aralığını artır",
  "settings.backgroundActivity.seconds": "saniye",
  "settings.backgroundActivity.pauseHostLocked": "Ana makine kilitliyken duraklat",
  "settings.backgroundActivity.pauseHostLowPower": "Ana makine düşük güçte duraklat",
  "settings.backgroundActivity.pauseClientLowPower": "İstemci düşük güçte duraklat",
  "settings.backgroundActivity.pauseOnBattery": "Pilde duraklat",
  "settings.backgroundActivity.resetAll": "Tümünü sıfırla",
  "settings.backgroundActivity.policyDetails": "Arka plan politikası ayrıntıları",
  "settings.archive.loading": "Arşivlenen sohbetler yükleniyor",
  "settings.archive.loadError": "Arşivlenen sohbetler yüklenemedi",
  "settings.archive.empty": "Arşivlenen sohbet yok",
  "settings.archive.checking": "Bağlı ortamlar kontrol ediliyor.",
  "settings.archive.emptyDescription": "Arşivlenen sohbetler burada görünür.",
  "settings.archive.unarchive": "Arşivden çıkar",
  "settings.archive.delete": "Sil",
  "settings.archive.archivedRelative": "Arşivlendi {time}",
  "settings.archive.createdRelative": "Oluşturuldu {time}",
  "settings.archive.unarchiveFailed": "Sohbet arşivden çıkarılamadı",
  "settings.archive.deleteFailed": "Sohbet silinemedi",
  "settings.archive.actionFailed": "Arşiv eylemi başarısız",
  "settings.archive.errorOccurred": "Bir hata oluştu.",
  "settings.organization.signIn": "Organizasyonları yönetmek için giriş yapın.",
  "settings.organization.personalAccount":
    "Şu anda kişisel hesabınızı kullanıyorsunuz. Üye davet etmek ve rolleri yönetmek için kenar çubuğundaki seçiciden bir organizasyon oluşturun veya seçin.",
  "settings.organization.disabled":
    "Bu örnekte organizasyonlar açık değil. Takım oluşturmak, üye davet etmek ve rolleri yönetmek için Clerk panonuzda Organizasyonları etkinleştirin.",
  "settings.organization.personal": "Kişisel hesap",
  "settings.organization.currentDescription":
    "Çalışma alanınızın şu anda etkin olduğu organizasyon.",
  "settings.organization.manageAction": "Yönet",
  "settings.organization.switchTitle": "Organizasyon değiştir",
  "settings.organization.switchDescription":
    "Hangi organizasyonun etkin olduğunu değiştirin veya kişisel hesabınıza geri dönün.",
  "settings.organization.createTitle": "Organizasyon oluştur",
  "settings.organization.createDescription":
    "Takımınızla iş birliği yapmak için yeni bir organizasyon başlatın.",
  "settings.organization.createAction": "Oluştur",
  "settings.organization.changeLogo": "Logoyu değiştir",
  "settings.organization.changeLogoDescription":
    "MorrowOS genelinde organizasyonunuzu temsil edecek kare bir görsel yükleyin.",
  "settings.organization.uploadingLogo": "Yükleniyor…",
  "settings.organization.pageDescription":
    "Takımınızı, rolleri ve organizasyon kimliğinizi yönetin.",
  "settings.organization.membersTitle": "Üyeler ve roller",
  "settings.organization.membersDescription":
    "Takım arkadaşlarınızı davet edin, roller atayın ve erişimi yönetin.",
  "settings.organization.roleAdmin": "Yönetici",
  "settings.organization.roleMember": "Üye",
  "settings.organization.memberCount": "{count} üye",
  "settings.organization.inviteTitle": "Üye davet et",
  "settings.organization.inviteDescription":
    "Bu organizasyona katılmaları için e-posta daveti gönderin.",
  "settings.organization.inviteEmailPlaceholder": "isim@sirket.com",
  "settings.organization.inviteAction": "Davet et",
  "settings.organization.inviting": "Davet ediliyor…",
  "settings.organization.inviteFailed": "Davet gönderilemedi. Tekrar deneyin.",
  "settings.organization.noMembers": "Henüz üye yok.",
  "settings.organization.pendingInvitations": "Bekleyen davetler",
  "settings.organization.revokeInvitation": "Geri al",
  "settings.organization.removeMember": "{name} kullanıcısını kaldır",
  "settings.organization.changeRole": "{name} için rolü değiştir",
  "settings.providers.description":
    "MorrowOS’un çalıştırabildiği modellerin salt okunur özeti; Cloudflare Workers AI ve AWS Bedrock genelinde şirkete göre gruplanır. Kendi sağlayıcı anahtarlarınızı eklemek henüz kullanılamıyor.",
  "settings.providers.comingSoon": "Yakında",
  "settings.providers.moreOnTheWay": "Daha fazla sağlayıcı yolda",
  "settings.providers.requestAccess": "Erken erişim isteyin, geldiklerinde sizi bilgilendirelim.",
  "settings.providers.soon": "Yakında",
  "settings.providers.models": "{count} model",
  "settings.providers.model": "{count} model",
  "settings.keybindings.search": "Kısayollarda ara",
  "settings.keybindings.add": "Kısayol ekle",
  "settings.keybindings.openFile": "keybindings.json dosyasını aç",
  "settings.keybindings.browserWarning":
    "Bazı kısayolları tarayıcı MorrowOS’tan önce alabilir. Daha iyi kısayol desteği için masaüstü uygulamasını kullanın.",
  "settings.keybindings.binding": "{count} kısayol",
  "settings.keybindings.bindings": "{count} kısayol",
  "settings.about.versionLabel": "Sürüm",
  "settings.support.open": "Aç",
  "settings.support.email": "E-posta",
  "settings.support.call": "Ara",
  "settings.support.getHelp": "Yardım al",
  "settings.support.helpCenter.description":
    "Kurulum, bellek, entegrasyonlar, faturalama ve kurumsal konuları tarayın.",
  "settings.support.submitRequest.description":
    "30 dakikalık bir destek talebi açın. Doğru ekibe yönlendiririz.",
  "settings.support.systemStatus.description":
    "Morrow için bileşen sağlığı ve olay güncellemeleri.",
  "settings.support.topics": "Yardım konuları",
  "settings.support.topic.setup.description":
    "İlk proje, ekip davetleri, roller ve Mor’un şirket belleğinden nasıl başladığı.",
  "settings.support.topic.integrations.description":
    "Slack, Jira, GitHub, Notion ve katalogdaki diğer uygulamaları bağlayın.",
  "settings.support.topic.memory.description":
    "Nelerin yazıldığı, kimlerin görebileceği, dışa aktarma ve bir projeyi silme.",
  "settings.support.topic.security.description":
    "Yerel öncelikli veri, KVKK, DPA talebi, SSO ve model eğitimi politikası.",
  "settings.support.topic.billing.description":
    "Koltuklar, entegrasyonlar, faturalar, iptal ve bulut verisini silme.",
  "settings.support.topic.faq.description": "Morrow ve şirket belleği hakkında sık sorulanlar.",
  "settings.support.contact": "İletişim",
  "settings.support.bookCall.description":
    "Daha hızlı yanıt için ayrıntıları paylaşın; ekibimiz devamını halleder.",
  "settings.legal.documents": "Belgeler",
  "settings.legal.privacy.description":
    "Enortic’in Morrow’u kullanırken kişisel verileri nasıl topladığı, kullandığı ve koruduğu.",
  "settings.legal.terms.description": "Morrow ve Morrow sitesinin kullanımını yöneten koşullar.",
  "settings.legal.dpa.description":
    "Bulut, yönetilen ve paylaşılan çalışma alanı kullanımı için veri işleme eki.",
  "settings.legal.cookies.description": "Morrow sitesinde çerezlerin nasıl kullanıldığı.",
  "settings.legal.trust.description": "Morrow için güvenlik, erişim, şifreleme ve uyumluluk.",
  "settings.legal.company": "Şirket",
  "settings.legal.company.description":
    "Enortic, Inc., Delaware şirketi. Dover, DE 19904, Amerika Birleşik Devletleri.",

  "onboarding.stepOf": "Adım {current} / {total}",
  "onboarding.accountType.title": "Morrow’u nasıl kullanacaksın?",
  "onboarding.accountType.subtitle": "Birini seç — sonra değiştirebilirsin.",
  "onboarding.accountType.individual": "Sadece ben",
  "onboarding.accountType.individualHint": "Kendi uygulamalarına bağlı kişisel bir çalışma alanı.",
  "onboarding.accountType.company": "Şirketim",
  "onboarding.accountType.companyHint": "Bir organizasyon oluştur ve ekibini davet et.",
  "onboarding.company.title": "Şirketiniz",
  "onboarding.company.subtitle":
    "Bir ad, logo ve site ya da LinkedIn — Morrow’un sizi tanıması için.",
  "onboarding.tools.title": "Araçlarını bağla",
  "onboarding.tools.subtitle":
    "Şimdi bir uygulama bağla. Gerisini sonra Ayarlar’dan ekleyebilirsin.",
  "onboarding.invite.title": "Ekibi davet et",
  "onboarding.invite.subtitle": "Çalışma alanının bir adı ve aracı olduktan sonra insanları çağır.",
  "onboarding.companyName": "Şirket adı",
  "onboarding.website": "Web sitesi veya LinkedIn",
  "onboarding.websitePlaceholder": "acme.com veya linkedin.com/company/acme",
  "onboarding.websiteError": "Geçerli bir link gir, örneğin acme.com veya LinkedIn sayfası",
  "onboarding.inviteError": "Bu bir e-posta gibi durmuyor",
  "onboarding.connectedCount": "{total} uygulamadan {connected} tanesi bağlı",
  "onboarding.addEmail": "E-posta ekle",
  "onboarding.removeEmail": "{email} adresini kaldır",
  "onboarding.addEmailsHint": "E-posta ekle veya şimdilik atla.",
  "onboarding.personTitle": "Unvan",
  "onboarding.personTitlePlaceholder": "Ürün sorumlusu",
  "onboarding.personRole": "Rol",
  "onboarding.personRolePlaceholder": "Ürün",
  "onboarding.invitePerson.email": "E-posta",
  "onboarding.invitePerson.title": "Unvan",
  "onboarding.invitePerson.titlePlaceholder": "Ürün sorumlusu",
  "onboarding.invitePerson.function": "Ne yapıyor",
  "onboarding.invitePerson.functionPlaceholder": "örn. Büyüme pazarlamasını yürütüyor",
  "onboarding.invitePerson.description": "Hakkında",
  "onboarding.invitePerson.descriptionPlaceholder": "Burada ne yapıyor",
  "onboarding.invitePerson.access": "Erişim düzeyi",
  "onboarding.invitePerson.add": "Ekle",
  "onboarding.pendingInvite": "Davet edildi",
  "onboarding.signInToInvite":
    "Davet göndermek için giriş yap. Yine de atlayıp sonra yapabilirsin.",
  "onboarding.sendAndStart": "Gönder ve başla",
  "onboarding.startChatting": "Sohbete başla",
  "onboarding.teamFallback": "Ekibim",
  "onboarding.orgLogo": "Logo",
  "onboarding.orgLogoAdd": "Logo ekle",
  "onboarding.orgLogoChange": "Logoyu değiştir",
  "onboarding.orgExisting": "Mevcut organizasyonun {name} kullanılıyor.",
  "onboarding.orgDisabled":
    "Organizasyonlar henüz etkin değil, bu yüzden yerel olarak kaydettik. Yine de devam edebilirsin.",
  "onboarding.lookingUpCompany": "Şirket bilgisi alınıyor…",
  "onboarding.connectCap": "{max} uygulamadan fazlasını bağlamak için ücretli plana geç.",
  "onboarding.profile.title": "Bize kendinden bahset",
  "onboarding.profile.subtitle": "Morrow’un işine göre uyarlanabilmesi için birkaç hızlı yanıt.",
  "onboarding.profile.role": "Rolün",
  "onboarding.profile.rolePlaceholder": "Kurucu, mühendis, pazarlamacı…",
  "onboarding.profile.roleOption.founder": "Kurucu",
  "onboarding.profile.roleOption.ceo": "CEO",
  "onboarding.profile.roleOption.cto": "CTO",
  "onboarding.profile.roleOption.engineer": "Mühendis",
  "onboarding.profile.roleOption.devops": "DevOps",
  "onboarding.profile.roleOption.product": "Ürün yöneticisi",
  "onboarding.profile.roleOption.designer": "Tasarımcı",
  "onboarding.profile.roleOption.marketer": "Pazarlamacı",
  "onboarding.profile.roleOption.sales": "Satış",
  "onboarding.profile.roleOption.operations": "Operasyon",
  "onboarding.profile.roleOption.projectManager": "Proje yöneticisi",
  "onboarding.profile.roleOption.customerSuccess": "Müşteri başarısı",
  "onboarding.profile.roleOption.dataAnalyst": "Veri analisti",
  "onboarding.profile.roleOption.hr": "İK",
  "onboarding.profile.roleOption.finance": "Finans",
  "onboarding.profile.roleOption.legal": "Hukuk",
  "onboarding.profile.roleOption.support": "Destek",
  "onboarding.profile.roleOption.content": "İçerik üreticisi",
  "onboarding.profile.roleOption.consultant": "Danışman",
  "onboarding.profile.roleOption.freelancer": "Serbest çalışan",
  "onboarding.profile.roleOption.student": "Öğrenci",
  "onboarding.profile.industry": "Sektör",
  "onboarding.profile.industryPlaceholder": "SaaS, ajans, e-ticaret…",
  "onboarding.profile.industryOption.saas": "SaaS",
  "onboarding.profile.industryOption.startup": "Girişim",
  "onboarding.profile.industryOption.technology": "Teknoloji",
  "onboarding.profile.industryOption.agency": "Ajans",
  "onboarding.profile.industryOption.marketing": "Pazarlama",
  "onboarding.profile.industryOption.ecommerce": "E-ticaret",
  "onboarding.profile.industryOption.retail": "Perakende",
  "onboarding.profile.industryOption.consulting": "Danışmanlık",
  "onboarding.profile.industryOption.finance": "Finans",
  "onboarding.profile.industryOption.insurance": "Sigorta",
  "onboarding.profile.industryOption.healthcare": "Sağlık",
  "onboarding.profile.industryOption.education": "Eğitim",
  "onboarding.profile.industryOption.media": "Medya",
  "onboarding.profile.industryOption.gaming": "Oyun",
  "onboarding.profile.industryOption.realEstate": "Gayrimenkul",
  "onboarding.profile.industryOption.manufacturing": "Üretim",
  "onboarding.profile.industryOption.logistics": "Lojistik",
  "onboarding.profile.industryOption.hospitality": "Otelcilik",
  "onboarding.profile.industryOption.foodBeverage": "Yiyecek & içecek",
  "onboarding.profile.industryOption.travel": "Seyahat",
  "onboarding.profile.industryOption.construction": "İnşaat",
  "onboarding.profile.industryOption.energy": "Enerji",
  "onboarding.profile.industryOption.fashion": "Moda",
  "onboarding.profile.industryOption.legal": "Hukuk",
  "onboarding.profile.industryOption.nonprofit": "Sivil toplum",
  "onboarding.profile.industryOption.government": "Kamu",
  "onboarding.profile.teamSize": "Ekip büyüklüğü",
  "onboarding.profile.teamSizePlaceholder": "Bir boyut seç",
  "onboarding.profile.goal": "Ne konuda yardım istersin?",
  "onboarding.profile.goalPlaceholder": "E-posta yaz, haftamı planla…",

  "landing.greeting": "Hazırım, {name}.",
  "landing.subtitle": "İstediğini sor, ya da bunlardan biriyle başla.",
  "landing.quickPicks": "Hızlı başlangıçlar",
  "landing.cta": "Bunu yapalım",
  "landing.connectApp": "Bunu çalıştırmak için {app} bağla",

  "authWelcome.title": "Merhaba, ben Morrow.",
  "authWelcome.subtitle":
    "Şirketinin yapay zeka operatörü. Araçlarını bağla; e-posta, Slack ve CRM'deki veriyi bugün harekete geçirebileceğin brifing, taslak ve planlara dönüştüreyim.",
  "authWelcome.outcomesHeading": "Şirketin için neler yaparım",
  "authWelcome.trial.badge": "7 gün ücretsiz deneme",
  "authWelcome.trial.tagline": "Şirketin için gerçek bir brifle başla — 7 gün ücretsiz.",
  "authWelcome.cta": "Ücretsiz denemeni başlat",
  "authWelcome.reassure": "Ücretsiz başla · İstediğin zaman iptal et, taahhüt yok",
  "authWelcome.signin.prompt": "Zaten hesabın var mı?",
  "authWelcome.signin.link": "Giriş yap",
  "authWelcome.outcome.briefing.title": "Müşterilere ulaş",
  "authWelcome.outcome.briefing.desc":
    "Outreach ve takip e-postalarını yaz — doğru kişiye, göndermeye hazır.",
  "authWelcome.outcome.pipeline.title": "Sosyal medyada paylaş",
  "authWelcome.outcome.pipeline.desc": "Post hazırla, görseli ekle, yayınla veya zamanla.",
  "authWelcome.outcome.align.title": "Toplantıları planla",
  "authWelcome.outcome.align.desc": "Müşteri görüşmelerini ayarla, davet gönder — takvimine işle.",
  "landing.suggest.siteClause": " Kaynak olarak {website} kullan.",
  "landing.suggest.briefClause": " Bildiğimiz: {brief}",
  "landing.suggest.income": "Gelir tablosu",
  "landing.suggest.expenses": "Giderler",
  "landing.suggest.invoices": "Faturalar",
  "landing.suggest.incomeDesc": "Bu ay ne kazandın",
  "landing.suggest.expensesDesc": "Bu ay ne harcadın",
  "landing.suggest.invoicesDesc": "Kimden ne bekleniyor",
  "landing.suggest.report": "Haftalık rapor",
  "landing.suggest.marketingPlan": "Pazarlama planı",
  "landing.suggest.productBrief": "Ürün brifi",
  "landing.suggest.pipeline": "Satış planı",
  "landing.suggest.competitors": "Rakip bakışı",
  "landing.suggest.thisWeek": "Bu haftanın planı",
  "landing.suggest.campaign": "Kampanya fikri",
  "landing.suggest.brand": "Marka brifi",
  "landing.suggest.nextShip": "Sıradaki teslim",
  "landing.suggest.outreach": "Outreach taslağı",
  "landing.suggest.week": "Haftamı planla",
  "landing.suggest.email": "E-posta yaz",
  "landing.suggest.decide": "Karar ver",
  "landing.suggest.write": "Bir şey yaz",
  "landing.suggest.incomePrompt":
    "Bu ay için gelir tablomu hazırla. Ne gerektiğini sor, sonra sade şekilde yaz.",
  "landing.suggest.expensesPrompt":
    "Bu ayki giderlerimi listele ve özetle. Önce ne gerektiğini sor.",
  "landing.suggest.invoicesPrompt":
    "Faturaları takip etmeme yardım et — kimden ne bekleniyor, ne zaman ödenecek.",
  "landing.suggest.reportDesc": "Haftanın rakamları, kazanımları ve takıldığın yerler",
  "landing.suggest.marketingPlanDesc": "Bu ay erişimi artıracak net bir plan",
  "landing.suggest.productBriefDesc": "Sıradaki özelliği net bir brife dönüştür",
  "landing.suggest.pipelineDesc": "Anlaşmaları ilerletecek bir plan",
  "landing.suggest.competitorsDesc": "Rakiplerin karşısında nerede olduğunu gör",
  "landing.suggest.thisWeekDesc": "Bu hafta önemli olan birkaç şey",
  "landing.suggest.campaignDesc": "Yakında çıkarabileceğin keskin bir fikir",
  "landing.suggest.brandDesc": "Ses, görünüş ve vaat tek yerde",
  "landing.suggest.nextShipDesc": "Sıradaki neyin çıkması gerektiğine karar ver",
  "landing.suggest.outreachDesc": "Sıcak ve kişisel bir ilk mesaj",
  "landing.suggest.weekDesc": "Yoğun haftayı net bir plana dök",
  "landing.suggest.emailDesc": "Birkaç net satır",
  "landing.suggest.decideDesc": "Seçenekleri tart ve bir yol seç",
  "landing.suggest.writeDesc": "Paylaşmaya değer bir metin yaz",
  "landing.suggest.memory": "Ne biliyorsun",
  "landing.suggest.meetingPrep": "Toplantı hazırlığı",
  "landing.suggest.standup": "Standup",
  "landing.suggest.vaultSearch": "Dosya bul",
  "landing.suggest.memoryDesc": "Hedefler ve bağlam tek yerde",
  "landing.suggest.meetingPrepDesc": "Hazırlıklı gir",
  "landing.suggest.standupDesc": "Dün, bugün, blokajlar",
  "landing.suggest.vaultSearchDesc": "Aradığın dosyayı bul",
  "landing.suggest.reportPrompt":
    "{name} için haftalık rapor yaz.{site} Neyin işe yaradığını, nerede takıldığını ve sonraki üç aksiyonu çıkar.",
  "landing.suggest.marketingPlanPrompt":
    "{name} için 30 günlük pazarlama planı yaz.{site} Kitle, teklif, kanallar ve ilk çalıştırılacak kampanyayı koy.",
  "landing.suggest.productBriefPrompt":
    "{name} için bir ürün brifi yaz.{site} Kitle, teklif ve sıradaki teslimi çıkar.",
  "landing.suggest.pipelinePrompt":
    "{name} için satış planı yaz.{site} Kime satılacağını, teklifi ve sonraki beş outreach’i koy.",
  "landing.suggest.competitorsPrompt": "{name} kiminle yarışıyor ve nasıl konumlanmalıyız?{site}",
  "landing.suggest.thisWeekPrompt":
    "Haftamı planla. Ne önemli, ne bekleyebilir ve ilk üç hamle nedir.",
  "landing.suggest.campaignPrompt": "{name}’in iki haftada çıkarabileceği bir kampanya öner.{site}",
  "landing.suggest.brandPrompt":
    "{name} için marka brifi yaz.{site} Ses, vaat ve sırada ne söyleneceğini koy.",
  "landing.suggest.nextShipPrompt":
    "{name} sırada ne teslim etmeli?{site} Kapsam, neden şimdi ve ilk kilometre taşını yaz.",
  "landing.suggest.outreachPrompt":
    "{name}’in bu hafta gönderebileceği outreach yaz.{site} Kime, neden onlara ve mesajı koy.",
  "landing.suggest.weekPrompt":
    "Haftamı planla. Ne önemli, ne bekleyebilir ve ilk üç hamle nedir, onu çıkar.",
  "landing.suggest.emailPrompt":
    "Net bir e-posta yazmama yardım et. Ne gerektiğini sor, sonra taslağı yaz.",
  "landing.suggest.decidePrompt":
    "Karar vermeme yardım et. Seçenekleri, ödünleri ve bir tavsiyeyi yaz.",
  "landing.suggest.writePrompt": "Bugün gönderebileceğim kısa ve net bir metin yaz.",
  "landing.suggest.memoryPrompt":
    "{name} hakkında neler biliyorsun?{site} Hedefleri, bağlamı ve aklımda tutmam gereken açık konuları özetle.",
  "landing.suggest.meetingPrepPrompt":
    "Bugünkü toplantılarıma hazırlan.{site} Bağlamı, olası soruları ve üç konuşma noktasını çıkar.",
  "landing.suggest.standupPrompt":
    "{name} için standup taslağı yaz.{site} Dün, bugün, blokajlar — kısa tut.",
  "landing.suggest.vaultSearchPrompt":
    "{name} için Vault'ta doğru dokümanı bulmama yardım et.{site} Ne aradığımı sor, sonra eşleşmeleri ara ve özetle.",

  "connect.connected": "Bağlı",
  "connect.connect": "Bağla",
  "connect.connecting": "Bağlanıyor…",
  "connect.disconnect": "Bağlantıyı kes",
  "connect.disconnectApp": "{name} bağlantısını kes",
  "connect.logoAlt": "{name} logosu",
  "connect.connectApp": "{name} bağla",

  "composer.placeholder": "İstediğini sor, ya da bir uygulama bağla…",
  "composer.placeholderApproval": "Devam etmek için bu onay isteğini çöz",
  "composer.placeholderPending":
    "Kendi yanıtını yaz, ya da seçili seçeneği kullanmak için boş bırak",
  "composer.placeholderPlan":
    "Planı iyileştirmek için geri bildirim ekle, ya da uygulamak için boş bırak",
  "composer.placeholderChooseProject": "Sohbet başlatmak için yukarıdan bir proje seç",
  "composer.placeholderEnableProvider": "Mesaj göndermek için Ayarlar’dan bir sağlayıcı aç",
  "composer.send": "Mesaj gönder",
  "composer.sending": "Gönderiliyor",
  "composer.sendingEllipsis": "Gönderiliyor...",
  "composer.connecting": "Bağlanıyor",
  "composer.preparingWorktree": "Çalışma ağacı hazırlanıyor",
  "composer.environmentDisconnected": "Ortam bağlantısı koptu",
  "composer.stop": "Üretimi durdur",
  "workflowRun.badge": "İş akışı",
  "workflowRun.stop": "Çalıştırmayı durdur",
  "workflowRun.finished": "Çalıştırma tamamlandı",
  "workflowRun.statusRunning": "Çalışıyor",
  "workflowRun.statusOk": "Tamamlandı",
  "workflowRun.statusFailed": "Başarısız",
  "workflowRun.statusSkipped": "Atlandı",
  "composer.refine": "İyileştir",
  "composer.implement": "Uygula",
  "composer.implementNewThread": "Yeni sohbette uygula",
  "composer.implementationActions": "Uygulama eylemleri",
  "composer.submit": "Gönder",
  "composer.next": "İleri",
  "composer.nextQuestion": "Sonraki soru",
  "composer.submitAnswer": "Yanıtı gönder",
  "composer.submitAnswers": "Yanıtları gönder",
  "composer.submitting": "Gönderiliyor...",
  "composer.previous": "Önceki",
  "composer.previousQuestion": "Önceki soru",
  "composer.emptyConversation": "Sohbeti başlatmak için bir mesaj gönder.",
  "composer.dictationUnsupported": "Bu tarayıcıda sesle yazdırma desteklenmiyor",
  "composer.dictationBlocked":
    "Konuşma tanıma engellendi. Sistem ayarlarından Dikte’yi açın veya Chrome deneyin.",
  "composer.dictationMicDenied": "Mikrofon izni reddedildi",
  "composer.dictationNoMic": "Mikrofon bulunamadı",
  "composer.dictationMicBusy":
    "Mikrofona erişilemedi. Başka bir uygulama kullanıyor veya sistem engellemiş olabilir.",
  "composer.dictationNetwork": "Sesle yazdırma konuşma servisine ulaşamadı",
  "composer.unconnectedTools": "Bağlayabileceğin uygulamalar",
  "composer.dictationInsecure": "Sesle yazdırma için HTTPS veya localhost gerekir",
  "composer.dictationFailed": "Sesle yazdırma başlatılamadı",

  "chat.newThreadIn": "{name} içinde yeni sohbet",
  "chat.threadTitle": "Sohbet başlığı",
  "chat.threadActions": "{title} sohbet eylemleri",
  "chat.threadBreadcrumb": "Sohbet yolu",
  "chat.working": "Çalışıyor…",

  "memory.title": "Bellek",
  "memory.subtitle": "CogniMemo’dan uzun vadeli bağlam",
  "memory.subtitlePersonal": "Sohbet ve bağlı uygulamalardan kişisel anıların",
  "memory.subtitleOrg": "CogniMemo’dan paylaşılan kuruluş anıları",
  "memory.subtitleUnconfigured": "Şirket belleğini görmek için CogniMemo’yu bağla",
  "memory.toggle": "CogniMemo belleği",
  "memory.resultsFor": "“{query}” için sonuçlar",
  "memory.searchPlaceholder": "Anılarda ara",
  "memory.search": "Ara",
  "memory.loading": "Anılar yükleniyor…",
  "memory.emptyUnconfigured":
    "Bu sunucuda CogniMemo henüz yapılandırılmadı. API anahtarı ayarlanınca anılar burada görünür.",
  "memory.emptySearch": "Bu aramayla eşleşen anı yok.",
  "memory.empty": "Henüz anı yok. CogniMemo’ya kaydettiklerin burada görünür.",

  "knowledge.title": "Bilgi tabanı",
  "knowledge.subtitle": "MorrowOS’un senin hakkında bildikleri",
  "vault.title": "Kasa",
  "vault.subtitle": "Dosyaların, eklemek için her zaman burada",
  "vault.empty": "Kasan boş",
  "vault.emptyHint": "Yüklediğin veya sohbette eklediğin dosyalar burada görünür.",
  "vault.upload": "Yükle",
  "vault.uploading": "Yükleniyor…",
  "vault.reindex": "Yeniden dizinle",
  "vault.reindexing": "Yeniden dizinleniyor…",
  "vault.reindexHint":
    "Önceden yüklenmiş dosyaları aranabilir yap ve öğelerini asistan için dizinle",
  "vault.reindexStarted":
    "{count} dosya yeniden dizinleniyor — sonuçlar kısa süre içinde aranabilir olur",
  "vault.reindexFailed": "Yeniden dizinleme başlatılamadı",
  "vault.itemsIndexed": "{count} ürün · aranabilir",
  "vault.dropHint": "Yüklemek için dosyaları buraya bırak",
  "vault.deleteFailed": "Bu dosya silinemedi",
  "vault.folderCreateFailed": "Bu klasör oluşturulamadı",
  "vault.moveFailed": "Bu dosya taşınamadı",
  "vault.dropIntoFolder": "{name} içine koymak için bırak",
  "vault.openFailed": "Bu dosya açılamadı",
  "vault.folders": "Klasörler",
  "vault.files": "Dosyalar",
  "vault.folder.all": "Tüm dosyalar",
  "vault.folder.documents": "Belgeler",
  "vault.folder.spreadsheets": "Tablolar",
  "vault.folder.images": "Görseller",
  "vault.folder.media": "Medya",
  "vault.folder.other": "Diğer",
  "vault.filesCount": "{count} Dosya",
  "vault.folderEmpty": "Bu klasörde henüz dosya yok.",
  "vault.col.name": "Ad",
  "vault.col.type": "Tür",
  "vault.col.size": "Boyut",
  "vault.col.addedBy": "Ekleyen",
  "vault.col.actions": "İşlemler",
  "vault.addedByYou": "Sen",
  "vault.viewList": "Liste görünümü",
  "vault.viewGrid": "Izgara görünümü",
  "vault.createFolder": "Yeni klasör",
  "vault.createFolderTitle": "Klasör oluştur",
  "vault.createFolderHint": "Kasa dosyalarınızı klasörlerle düzenleyin.",
  "vault.folderName": "Klasör adı",
  "vault.folderNamePlaceholder": "ör. Onboarding",
  "vault.createFolderCancel": "İptal",
  "vault.moveToFolder": "Klasöre taşı",
  "vault.removeFromFolder": "Klasörden çıkar",
  "vault.folderActions": "Klasör seçenekleri",
  "vault.renameFolder": "Klasörü yeniden adlandır",
  "vault.renameFolderTitle": "Klasörü yeniden adlandır",
  "vault.rename": "Yeniden adlandır",
  "vault.deleteFolder": "Klasörü sil",
  "vault.deleteFolderTitle": "“{name}” silinsin mi?",
  "vault.deleteFolderBody": "Bu klasörde {count} dosya var. Onlara ne olacağını seçin.",
  "vault.deleteFolderBodyEmpty": "Bu klasör boş.",
  "vault.deleteFolderKeepFiles": "Klasörü kaldır, dosyaları tut",
  "vault.deleteFolderKeepFilesHint": "Klasör kaldırılır. Dosyaları “Klasörsüz”e döner.",
  "vault.deleteFolderWithFiles": "Klasörü ve dosyalarını sil",
  "vault.deleteFolderWithFilesHint": "Klasör ve içindeki her şey kalıcı olarak silinir.",
  "vault.folderDeleted": "Klasör silindi",
  "vault.folderDeleteFailed": "Klasör silinemedi.",
  "vault.folderRenamed": "Klasör yeniden adlandırıldı",
  "vault.folderRenameFailed": "Klasör yeniden adlandırılamadı.",
  "vault.cancel": "İptal",
  "vault.uploadingFile": "Dosya yükleniyor…",
  "vault.previewUnavailable": "Bu dosya türü için önizleme kullanılamıyor.",
  "vault.download": "İndir",
  "vault.viewText": "Metni görüntüle",
  "vault.attachFromDevice": "Cihazdan",
  "vault.attachFromVault": "Kasadan",
  "vault.pickTitle": "Kasadan ekle",
  "vault.pickSubtitle": "Mesajına eklemek için bir dosya seç",
  "knowledge.docHeading": "Profil",
  "knowledge.loading": "Bilgi tabanın yükleniyor…",
  "knowledge.empty":
    "MorrowOS seni hâlâ tanıyor… Birlikte çalıştıkça öğrendikleri burada görünecek.",
  "knowledge.emptyTitle": "MorrowOS seni tanımaya başlıyor",
  "knowledge.emptyBody":
    "Burada henüz bir şey yok — bu beklenen bir durum. Birlikte sohbet edip çalıştıkça MorrowOS senin kim olduğuna dair bir resim oluşturur. Öğrendikleri bu sayfada büyüyecek.",
  "knowledge.emptyCategoriesLabel": "Burada neler görünecek",
  "knowledge.catPreferences": "Tercihler",
  "knowledge.catProjects": "Projeler ve iş",
  "knowledge.catGoals": "Hedefler",
  "knowledge.catStyle": "Çalışma tarzı",
  "knowledge.tabAboutYou": "Hakkında",
  "knowledge.tabStyle": "Tarzın",
  "knowledge.tabPreferences": "Tercihler",
  "knowledge.tabOrganization": "Kuruluş",
  "knowledge.emptyTabTitle": "Henüz bir şey öğrenilmedi",
  "knowledge.emptyTabBody":
    "Sen ve MorrowOS birlikte çalıştıkça, bu bölüm için öğrendikleri burada görünecek.",

  "usage.title": "Kullanım ve Krediler",
  "usage.subtitle": "Tüm model çağrılarının ölçümü",
  "usage.unavailable":
    "Kullanım uçları kullanılamıyor. Henüz ölçülen çağrı yok, ya da sunucu çevrimdışı.",
  "usage.yourUsage": "Senin kullanımın",
  "usage.user": "Kullanıcı:",
  "usage.credits": "Krediler",
  "usage.calls": "Çağrılar",
  "usage.tokensIn": "Gelen token",
  "usage.tokensOut": "Giden token",
  "usage.globalMonitor": "Genel izleme",
  "usage.totalCredits": "Toplam kredi",
  "usage.users": "Kullanıcılar",
  "usage.totalCalls": "Toplam çağrı",
  "usage.totalTokens": "Toplam token",
  "usage.topUsers": "Krediye göre en çok kullananlar",
  "usage.empty": "Henüz kullanım kaydı yok.",

  "commandPalette.openSettings": "Ayarları aç",
  "commandPalette.openMemory": "Belleği aç",
  "commandPalette.openUsage": "Kullanımı aç",
  "commandPalette.openTeam": "Takımı aç",
  "commandPalette.openAgents": "Ajanları aç",
  "commandPalette.openMessages": "Mesajlaşmayı aç",

  "team.title": "Takım",
  "team.subtitle": "{name} içindeki kişiler",
  "team.untitled": "bu çalışma alanı",
  "team.joinHint": "Birini e-postayla davet et. Unvan ve rolü kendisi veya bir admin ayarlasın.",
  "team.joinName": "Ad",
  "team.joinEmail": "E-posta",
  "team.joinTitle": "Unvan",
  "team.joinRole": "Rol",
  "team.joinFunction": "Ne yapıyor",
  "team.joinDescription": "Hakkında",
  "team.joinAccess": "Erişim düzeyi",
  "team.roleAdmin": "Yönetici",
  "team.roleMember": "Üye",
  "team.join": "Davet et",
  "team.addMember": "Üye ekle",
  "team.namePlaceholder": "Ad",
  "team.emailPlaceholder": "teammate@acme.com",
  "team.titlePlaceholder": "Ürün sorumlusu",
  "team.rolePlaceholder": "Ürün",
  "team.functionPlaceholder": "örn. Büyüme pazarlamasını yürütüyor",
  "team.descriptionPlaceholder": "Burada ne yapıyor",
  "team.members": "Üyeler",
  "team.empty": "Henüz kimse katılmadı.",
  "team.emptyHint":
    "Takım arkadaşlarını davet et; ajanları, bilgiyi ve bağlı uygulamaları paylaş, her üyenin erişimini ayarla.",
  "team.seatsUsage": "{used} / {limit} koltuk",
  "team.orgMemory": "Kurumsal hafıza",
  "team.orgMemoryEmpty":
    "MorrowOS henüz kuruluşunuz hakkında bir şey öğrenmedi. Çalıştıkça gelişir.",
  "team.orgMemoryRebuild": "Yeniden oluştur",
  "team.orgMemoryRebuilding": "Yeniden oluşturuluyor…",
  "organization.title": "Kuruluş",
  "organization.subtitle": "Şirketinizin ortak hafızası, kişileri ve AI çalışanları.",
  "organization.noOrg":
    "Etkin kuruluş yok. Kuruluşunuzu burada görmek için bir tane oluşturun veya katılın.",
  "identity.personBadge": "Kişisel profil",
  "identity.organizationBadge": "Şirket profili",
  "identity.email": "E-posta",
  "identity.members": "Ekip",
  "identity.industry": "Sektör",
  "identity.website": "Web sitesi",
  "identity.memberSince": "Üyelik başlangıcı",
  "identity.about": "Hakkında",
  "identity.knowledgeHint":
    "MorrowOS bu profili sohbetlerinizden, bağlı uygulamalardan ve çalışma tarzınızdan oluşturur.",
  "identity.orgHint":
    "Kuruluşunuzdaki herkes için ortak bağlam — projeler, normlar ve nasıl çalıştığınız.",
  "team.invited": "Davet edilenler",
  "team.pendingInvite": "Davet edildi",
  "team.profileHint": "Unvan ve rolünü ayarla.",
  "team.profilePending": "Unvan ve rol henüz yok",
  "team.openProfile": "Profili aç",
  "team.openDetail": "{name} profilini aç",
  "team.editOtherSubtitle": "Bu kişinin takımda nasıl görüneceğini güncelle.",
  "team.viewOnlyHint": "Bu profili yalnızca kendisi veya bir admin düzenleyebilir.",
  "team.grant.title": "Erişim izinleri",
  "team.grant.vaultManage": "Kurum kasasını yönet",
  "team.grant.vaultRequest": "Kasalar arası erişim",
  "team.grant.billingAccess": "Faturalandırma erişimi",
  "team.grant.orgKbAccess": "Kurum bilgi tabanı",
  "team.you": "Sen",
  "team.websiteHint": "Öneriler ve aksiyonlar {website} verisine göre gelecek.",
  "profile.team.title": "Unvan ve rol",
  "profile.team.subtitle": "Takımda böyle görünürsün.",
  "profile.team.save": "Kaydet",
  "profile.avatar.title": "Portre",
  "profile.avatar.choose": "{character} seç",
  "profile.avatar.upload": "Yükle",
  "profile.avatar.uploadError": "Bu görsel kullanılamadı. Daha küçük bir fotoğraf deneyin.",
  "profile.clerk.profileNav": "Profil",
  "profile.clerk.firstName": "Ad",
  "profile.clerk.lastName": "Soyad",
  "profile.clerk.avatarHint": "Portre seçmek için Profili güncelle'yi aç.",

  "agents.title": "Ajanlar",
  "agents.subtitle": "İşi kendi alan roller",
  "agents.openDetail": "{role} detayını aç",
  "agents.hr.role": "İK",
  "agents.hr.blurb": "İnsan işini yürütür: işe alım notları, unvanlar, oryantasyon, ekip sağlığı.",
  "agents.hr.skill.hiring": "İşe alım",
  "agents.hr.skill.onboarding": "Oryantasyon",
  "agents.hr.skill.health": "Ekip sağlığı",
  "agents.marketing.role": "Pazarlama",
  "agents.marketing.blurb": "Hikayeyi kurar, kampanya yazar ve şirket sitesini brife çevirir.",
  "agents.marketing.skill.story": "Hikaye",
  "agents.marketing.skill.campaigns": "Kampanya",
  "agents.marketing.skill.brief": "Brief",
  "agents.mor.role": "CEO",
  "agents.mor.blurb": "Mavi maskot. Takım işini kendi alır ve sonucu yazar.",
  "agents.mor.skill.team": "Takım",
  "agents.mor.skill.pickup": "Üstlenir",
  "agents.mor.skill.result": "Sonuç",
  "agents.product.role": "Ürün",
  "agents.product.blurb": "İstekleri backlog’a çevirir: kapsam, öncelik ve sonraki teslim.",
  "agents.product.skill.scope": "Kapsam",
  "agents.product.skill.priority": "Öncelik",
  "agents.product.skill.ship": "Teslim",
  "agents.strategy.role": "Strateji",
  "agents.strategy.blurb":
    "Seçenekleri karşılaştırır, riskleri çıkarır ve takıma kısa bir plan getirir.",
  "agents.strategy.skill.options": "Seçenek",
  "agents.strategy.skill.risks": "Risk",
  "agents.strategy.skill.plan": "Plan",
  "agents.finance.role": "Finans",
  "agents.finance.blurb": "Harcamayı, kullanımı ve kararın arkasındaki sayıları takip eder.",
  "agents.finance.skill.spend": "Harcama",
  "agents.finance.skill.usage": "Kullanım",
  "agents.finance.skill.numbers": "Sayılar",
  "agents.sales.role": "Satış",
  "agents.sales.blurb": "Pipeline’ı izler, outreach yazar ve sonraki kapanışı işaretler.",
  "agents.sales.skill.pipeline": "Pipeline",
  "agents.sales.skill.outreach": "Outreach",
  "agents.sales.skill.close": "Kapanış",
  "agents.support.role": "Destek",
  "agents.support.blurb": "Gelen kutusu ve Slack’i takımın işine yarayan yanıtlara çevirir.",
  "agents.support.skill.inbox": "Gelen kutusu",
  "agents.support.skill.slack": "Slack",
  "agents.support.skill.answers": "Yanıt",

  "agents.workspace.subtitle": "Zamanla kendi başına çalışan özerk roller.",
  "agents.workspace.loading": "Ajanlar yükleniyor…",
  "agents.workspace.empty.title": "Henüz ajan yok",
  "agents.workspace.empty.description":
    "Ajan, devrettiğiniz bir roldür — hedef ve erişim verin; zamanla kendi başına çalışır.",
  "agents.workspace.newAgent": "Yeni ajan",
  "agents.workspace.demo": "Demo",
  "agents.workspace.resume": "Sürdür",
  "agents.workspace.pause": "Duraklat",
  "agents.workspace.status.active": "Aktif",
  "agents.workspace.status.paused": "Duraklatıldı",
  "agents.workspace.status.archived": "Arşivlendi",
  "agents.workspace.create.title": "Yeni ajan",
  "agents.workspace.create.description":
    "Rolü ve hedefini adlandırın. Oluşturduktan sonra her şeyi düzenleyebilirsiniz.",
  "agents.workspace.field.mascot": "Maskot",
  "agents.workspace.field.name": "Ad",
  "agents.workspace.field.role": "Rol",
  "agents.workspace.field.goals": "Hedef / yetki",
  "agents.workspace.field.autonomy": "Özerklik",
  "agents.workspace.field.tools": "Araçlar / uygulamalar",
  "agents.workspace.field.capabilities": "Yetenekler",
  "agents.workspace.placeholder.mascot": "…veya emoji / görsel URL’si yapıştırın",
  "agents.workspace.placeholder.name": "ör. Ravi — İK",
  "agents.workspace.placeholder.role": "ör. İşe Alım Direktörü",
  "agents.workspace.placeholder.goals": "Bu ajan kendi başına neyi hedeflemeli?",
  "agents.workspace.placeholder.appsAdvanced": "Gelişmiş: ek slug’lar, virgülle ayrılmış",
  "agents.workspace.connectedApps.hint":
    "Bağlı uygulamalardan seçin. Hiçbiri seçilmezse tüm bağlı uygulamalara izin verilir.",
  "agents.workspace.connectedApps.none":
    "Henüz bağlı uygulama yok — Ayarlar’dan bağlayın veya altta slug yazın.",
  "agents.workspace.createAgent": "Ajan oluştur",
  "agents.workspace.untitled": "Adsız ajan",
  "agents.workspace.notFound": "Ajan bulunamadı",
  "agents.workspace.backToAgents": "Ajanlara dön",
  "agents.workspace.backAria": "Ajanlara dön",
  "agents.workspace.detailsTitle": "Ajan detayları",
  "agents.workspace.computer": "Bilgisayar",
  "agents.workspace.computerOpenTitle": "Ajanın Bilgisayarını aç — tarayıcı ve terminali izle",
  "agents.workspace.typing": "yazıyor…",
  "agents.workspace.statusLabel.paused": "duraklatıldı",
  "agents.workspace.statusLabel.active": "aktif",
  "agents.workspace.emptyChat.title": "{name} ile tanış",
  "agents.workspace.emptyChat.body":
    "Kendi kişiliği, araçları ve özerkliğiyle çalışır. Bir şey isteyin veya izlemek için Bilgisayar’a dokunun.",
  "agents.workspace.preparingConversation": "Sohbet hazırlanıyor…",
  "agents.workspace.messagePlaceholder": "{name}’a mesaj…",
  "agents.workspace.listening": "Dinleniyor…",
  "agents.workspace.attachFiles": "Dosya ekle",
  "agents.workspace.dictate": "Dikte",
  "agents.workspace.stopDictation": "Dikteyi durdur",
  "agents.workspace.dictateTitle": "Mikrofonla dikte et",
  "agents.workspace.send": "Gönder",
  "agents.workspace.removeAttachment": "{name} kaldır",
  "agents.workspace.autonomy.read": "Salt okunur — önerir, asla hareket etmez",
  "agents.workspace.autonomy.approval": "Onay — dışa dönük işlemlerden önce sorar",
  "agents.workspace.autonomy.autonomous": "Özerk — yetkisi dahilinde hareket eder",
  "agents.workspace.cap.cloudBrowser": "Bulut tarayıcı",
  "agents.workspace.cap.browser": "Yerel tarayıcı",
  "agents.workspace.cap.vault": "Kasa / dosyalar",
  "agents.workspace.cap.memoryWrite": "Bellek",
  "agents.workspace.cap.email": "E-posta",
  "agents.workspace.source.message": "Mesaj",
  "agents.workspace.source.comms": "Mesajlaşma",
  "agents.workspace.source.event": "Olay",
  "agents.workspace.source.schedule": "Zamanlama",
  "agents.workspace.source.delegation": "Delegasyon",
  "agents.workspace.source.test": "Elle çalıştırma",
  "agents.workspace.computerTitle": "{name} Bilgisayarı",
  "agents.workspace.computer.using": "Bilgisayar kullanılıyor",
  "agents.workspace.computer.liveHost": "Canlı · {host}",
  "agents.workspace.computer.liveAgentBrowser": "Canlı · ajanın tarayıcısı",
  "agents.workspace.computer.yourBrowser": "Sizin tarayıcınız · sürün",
  "agents.workspace.computer.tab.browser": "Tarayıcı",
  "agents.workspace.computer.tab.terminal": "Bilgisayar",
  "agents.workspace.computer.restartScreen": "Ekranı yeniden başlat",
  "agents.workspace.computer.restartBrowser": "Tarayıcıyı yeniden başlat",
  "agents.workspace.computer.collapse": "Bilgisayarı daralt",
  "agents.workspace.computer.collapseTitle": "Daralt",
  "agents.workspace.computer.live": "canlı",
  "agents.workspace.computer.idle": "boşta",
  "agents.workspace.computer.jumpToLive": "Canlıya geç",
  "agents.workspace.computer.shellOutput": "Kabuk çıktısı",
  "agents.workspace.computer.startingBrowser": "{name} tarayıcısı başlatılıyor…",
  "agents.workspace.computer.screenError":
    "Ekran başlatılamadı — yeniden denemek için yeniden başlat’a dokunun.",
  "agents.workspace.computer.retry": "Yeniden dene",
  "agents.workspace.computer.iframeTitle": "Ajan tarayıcısı",
  "agents.workspace.computer.embedBlocked": "Canlı görünüm burada gömülemedi.",
  "agents.workspace.computer.openInTab": "Ekranı sekmede aç",
  "agents.workspace.computer.preparingScreen": "Ekran hazırlanıyor…",
  "agents.workspace.computer.terminalEmpty":
    "Henüz komut çıktısı yok. {name}’dan bir şey çalıştırmasını isteyin —",
  "agents.workspace.computer.terminalExample": 'python3 -c "print(2+2)" çalıştır',
  "agents.workspace.computer.outputLabel": "çıktı · {index}",
  "agents.workspace.profile.roleFallback": "Ajan",
  "agents.workspace.profile.runNow": "Şimdi çalıştır",
  "agents.workspace.profile.section.mascot": "Maskot",
  "agents.workspace.profile.section.identity": "Kimlik",
  "agents.workspace.profile.section.personality": "Kişilik ve hedefler",
  "agents.workspace.profile.personalityHint": "Bu ajan ne ve neyi hedefliyor",
  "agents.workspace.profile.section.permissions": "İzinler",
  "agents.workspace.profile.connectedApps": "Bağlı uygulamalar",
  "agents.workspace.profile.connectedAppsHint": "· virgülle ayrılmış, boş = hepsi",
  "agents.workspace.profile.appsPlaceholder": "gmail, googlecalendar, slack",
  "agents.workspace.profile.section.autonomy": "Özerklik ve zamanlama",
  "agents.workspace.profile.schedule": "Zamanlama",
  "agents.workspace.profile.scheduleHint": "· cron, boş = yalnızca mesajla",
  "agents.workspace.profile.schedulePlaceholder": "0 9 * * *",
  "agents.workspace.profile.section.tags": "Etiketler (mesajlaşmadan ulaş)",
  "agents.workspace.profile.tagPlaceholder": "yeni etiket (@ olmadan)",
  "agents.workspace.profile.removeTag": "Kaldır",
  "agents.workspace.profile.runLogs": "Çalıştırma kayıtları ({count})",
  "agents.workspace.profile.noRuns": "Henüz bir şey yok — çalışmadı.",
  "agents.workspace.profile.runFallback": "çalıştırma",
  "agents.workspace.profile.delete": "Sil",
  "agents.workspace.profile.save": "Değişiklikleri kaydet",

  "messages.title": "Mesajlaşma",
  "messages.subtitle": "Takım konuşması",
  "messages.placeholder": "Takıma yaz. Mor’u çağırmak için @mor kullan.",
  "messages.empty": "Henüz mesaj yok. Takım konuşmasını burada başlat.",
  "messages.send": "Gönder",
  "messages.you": "Sen",
  "messages.morPickedUp": "Mor bu işi sohbet içinde aldı.",
  "messages.flow.briefing": "Sabah brifingi",
  "messages.flow.briefingPrompt": "@mor takıma sabah brifingi ver.",
  "messages.flow.inbox": "Gelen kutusu",
  "messages.flow.inboxPrompt": "@mor takım için gelen kutusunu özetle.",
  "messages.flow.calendar": "Takvim",
  "messages.flow.calendarPrompt": "@mor bugün takvimde ne var?",
  "commandPalette.newThreadIn": "Şurada yeni sohbet...",
  "commandPalette.toggleThemeEditor": "Tema düzenleyiciyi aç/kapat",

  "sidebar.searchUniversal": "Sohbet, kişi, dosya ve sayfalarda ara",
  "sidebar.searchPlaceholder": "Sohbet, kişi, dosya ara…",
  "sidebar.noSearchResults": "Sonuç bulunamadı",
  "sidebar.searchGroup.threads": "Sohbetler",
  "sidebar.searchGroup.pages": "Sayfalar",
  "sidebar.searchGroup.agents": "Ajanlar",
  "sidebar.searchGroup.members": "Takım",
  "sidebar.searchGroup.vault": "Kasa",
  "sidebar.searchGroup.knowledge": "Bilgi",
  "settings.organization.demoHint": "Demo veri — bu örnekte Clerk Organizasyonları etkin değil.",
  "memory.count": "{count} anı",
  "memory.emptyTitle": "Uzun vadeli belleğin boş",
  "memory.emptyTitleOrg": "Kuruluş belleği boş",
  "memory.emptyBody":
    "Burada henüz bir şey yok — bu normal. MorrowOS ile çalıştıkça CogniMemo önemli olanları saklar; agent’lar seni sohbetler ve oturumlar arasında hatırlayabilir.",
  "memory.emptyBodyOrg":
    "Burada henüz bir şey yok — bu normal. Ekibin MorrowOS ile çalıştıkça CogniMemo ortak bağlamı saklar; herkes sohbetler ve oturumlar arasında uyumlu kalır.",
  "memory.emptySectionsLabel": "CogniMemo ne yapar",
  "memory.sectionWhat": "Ne olduğu",
  "memory.sectionWhatHint":
    "CogniMemo, MorrowOS’un harici bellek katmanı — tek bir sohbetin ötesinde kalıcı tutulan gerçekler, kararlar ve bağlam.",
  "memory.sectionWhatHintOrg":
    "CogniMemo kuruluşunuzun paylaşılan belleğini tutar — tüm ekibe ait kalıcı gerçekler, kararlar ve bağlam.",
  "memory.sectionPurpose": "Neye yaradığı",
  "memory.sectionPurposeHint":
    "Daha önce paylaştıklarını her yeni sohbete taşır; kendini tekrar etmezsin ve agent’lar hedeflerinle uyumlu kalır.",
  "memory.sectionPurposeHintOrg":
    "Ekibin daha önce paylaştıklarını her sohbete taşır; insanlar kendini tekrar etmez ve agent’lar şirket hedefleriyle uyumlu kalır.",
  "memory.sectionCapture": "Nasıl kaydeder",
  "memory.sectionCaptureHint":
    "Agent’lar sohbetten önemli anları — tercihler, proje detayları, kararlar — CogniMemo’da ayrı anılar olarak saklar.",
  "memory.sectionCaptureHintOrg":
    "Agent’lar ekip sohbetinden önemli anları — proje detayları, normlar, kararlar — CogniMemo’da paylaşılan anılar olarak saklar.",
  "memory.sectionRecall": "Nasıl hatırlar",
  "memory.sectionRecallHint":
    "Sohbet ederken veya burada aradığında anılar anlama göre, sadece kelime eşleşmesiyle değil, yüzeye çıkar — doğru bağlam gerektiğinde gelir.",
  "memory.graph.selectNode": "Ayrıntıları görmek için grafikte bir düğüm seç.",
  "memory.graph.kind.company": "Şirket",
  "memory.graph.kind.department": "Departman",
  "memory.graph.kind.employee": "Çalışan",
  "memory.graph.kind.round": "Round",
  "memory.graph.kind.tool": "Araç",
  "memory.graph.zoomIn": "Yakınlaştır",
  "memory.graph.zoomOut": "Uzaklaştır",
  "memory.graph.resetView": "Görünümü sıfırla",
  "memory.graph.aria": "Şirket bellek grafiği",
  "memory.graph.ariaPersonal": "Kişisel bellek grafiği",
  "memory.graph.ariaOrg": "Kuruluş bellek grafiği",
  "memory.graph.hoverHint": "Ayrıntıları görmek için bir düğümün üzerine gel veya seç.",
  "memory.graph.filterDepartment": "Departman",
  "memory.graph.allDepartments": "Tüm departmanlar",
  "memory.graph.filterKind": "Düğüm türü",
  "memory.graph.allKinds": "Tüm türler",
  "memory.detail.title": "Ünvan",
  "memory.detail.role": "Rol",
  "memory.detail.email": "E-posta",
  "memory.detail.about": "Hakkında",
  "memory.detail.content": "İçerik",
  "memory.detail.type": "Tür",
  "memory.detail.created": "Oluşturulma",
  "memory.detail.score": "İlgililik",
  "memory.detail.tool": "Araç",
  "memory.detail.toolHint": "Şirket belleğinin bu bölümüne bağlı bir entegrasyon.",
  "memory.detail.departmentHint":
    "Takımın nasıl organize olduğuna göre gruplanan kişiler ve anılar.",
  "memory.detail.companyHint": "Organizasyonunuzun paylaşılan bellek grafiğinin merkezi.",
  "memory.detail.breadcrumb": "Yol",
  "memory.detail.clusterItems": "Gruplanan öğeler",
  "memory.detail.related": "İlgili",
  "memory.detail.department": "Departman",
  "memory.detail.owner": "Sahip",
  "memory.view.graph": "Graf",
  "memory.view.list": "Liste",
  "knowledge.catPreferencesHint": "Kullandığın araçlar, bildirimler ve varsayılanlar.",
  "knowledge.catProjectsHint": "Ne inşa ettiğin, rolün ve güncel odağın.",
  "knowledge.catGoalsHint": "Zaman içinde neye doğru çalıştığın.",
  "knowledge.catStyleHint": "Nasıl iletişim kurduğun ve iş birliği tercihlerin.",
  "knowledge.error.forbidden":
    "Bu bilgiyi görüntüleme iznin yok. Erişim için organizasyon yöneticine danış.",
  "knowledge.error.notFound": "Henüz burada bir şey yok.",
  "knowledge.error.unavailable": "Şu anda yüklenemedi. Yenilemeyi dene.",
  "usage.currentPlan": "Mevcut paket",
  "usage.recommendedPlan": "Sen için önerilen",
  "usage.topPlan": "En üst paketteysin.",
  "usage.upgrade": "Yükselt",
  "usage.usageThisPeriod": "Bu dönem kullanımı",
  "usage.includedFeatures": "Dahil özellikler",
  "pricing.title": "Planlar",
  "pricing.subtitle": "{planName} paketi · {tier} katmanı",
  "pricing.subtitleAudience": "{audience} planları",
  "pricing.individual": "Bireysel",
  "pricing.business": "İş",
  "pricing.manageBilling": "Faturalamayı yönet",
  "pricing.opening": "Açılıyor…",
  "pricing.loading": "Planlar yükleniyor…",
  "pricing.unavailable": "Planlar şu anda kullanılamıyor. Biraz sonra yenilemeyi dene.",
  "pricing.noPlans": "Bu kitle için henüz yayınlanmış plan yok.",
  "pricing.current": "Mevcut",
  "pricing.popular": "Popüler",
  "pricing.currentPlan": "Mevcut plan",
  "pricing.included": "Dahil",
  "pricing.upgrade": "Yükselt",
  "pricing.redirecting": "Yönlendiriliyor…",
  "pricing.perMonth": "/ ay",
  "pricing.free": "Ücretsiz",
  "pricing.unlimited": "Sınırsız",
  "pricing.compareTitle": "Planları karşılaştır",
  "pricing.compareSubtitle": "Her katman için tam özellik dökümü",
  "pricing.featureColumn": "Özellik",
  "pricing.detailsTitle": "Faturalama ayrıntıları",
  "pricing.cap.modelPay": "Pay katmanı modeller",
  "pricing.cap.modelSuper": "Super katmanı modeller",
  "pricing.cap.modelMax": "Max katmanı modeller",
  "pricing.cap.agentTurns": "Ajan dönüşü / ay",
  "pricing.cap.toolCalls": "Araç çağrısı / ay",
  "pricing.cap.subagents": "Eşzamanlı alt ajan",
  "pricing.cap.connectors": "Bağlı uygulama",
  "pricing.cap.seats": "Dahil koltuk",
  "pricing.faq.resetQ": "Kullanım ne zaman sıfırlanır?",
  "pricing.faq.resetA":
    "Ölçülen limitler her faturalama döneminin başında sıfırlanır. Ücretsiz planlar hesap oluşturma tarihinden itibaren aylık sıfırlanır.",
  "pricing.faq.changeQ": "Planı istediğim zaman değiştirebilir miyim?",
  "pricing.faq.changeA":
    "Evet. Yükseltmeler hemen geçerli olur ve orantılı faturalandırılır. Düşürmeler mevcut dönemin sonunda uygulanır.",
  "pricing.faq.limitQ": "Limite ulaşınca ne olur?",
  "pricing.faq.limitA":
    "MorrowOS limite yaklaştıkça uyarır, kota tükenince işlemi engeller. Devam etmek için yükselt veya sonraki dönemi bekle.",
  "pricing.faq.billingQ": "Takım faturalaması nasıl çalışır?",
  "pricing.faq.billingA":
    "İş planları belirli sayıda koltuk içerir. Koltuk kotasına kadar üye davet edebilirsin. Faturalama Stripe üzerinden yönetilir.",
  "pricing.faq.cancelQ": "İstediğim zaman iptal edebilir miyim?",
  "pricing.faq.cancelA":
    "Evet. Faturalamayı yönet ile Stripe portalını aç; iptal, ödeme yöntemi güncelleme ve fatura indirme orada yapılır.",
  "pricing.introBusiness":
    "Organizasyonunuz için iş planlarını karşılaştırın veya tek seferlik bir fon ile bakiyenizi artırın.",
  "pricing.introIndividual": "Planları karşılaştırın ve iş akışınıza uyan pakete geçin.",
  "pricing.addonsTitle": "Eklentiler ve kredi fonları",
  "pricing.addonsIntro": "Mevcut paketinize eklenen tek seferlik bakiye yüklemeleri.",
  "pricing.loadingAddons": "Eklentiler yükleniyor…",
  "pricing.buy": "Satın al",
  "pricing.oneOff": "tek seferlik",
  "pricing.includedAria": "Dahil",
  "pricing.notIncludedAria": "Dahil değil",
  "pricing.saveUpTo": "%{percent}’e varan tasarruf",
  "pricing.discountOff": "%{percent} indirim",
  "pricing.billedPerMonth": "aylık, {note}",
  "pricing.startTrial": "7 günlük ücretsiz denemeyi başlat",
  "pricing.trialNote": "7 gün ücretsiz, ardından {price}/ay · istediğin zaman iptal et",
  "pricing.modelsRow": "Yapay zeka modelleri",
  "pricing.modelsRowDescription": "Ajanlarınızın hangi modelleri çalıştırabileceği.",
  "pricing.interval.month": "Aylık",
  "pricing.interval.quarter": "Üç aylık",
  "pricing.interval.year": "Yıllık",
  "pricing.interval.billedMonthly": "aylık faturalandırılır",
  "pricing.interval.billedQuarterly": "üç ayda bir faturalandırılır",
  "pricing.interval.billedYearly": "yıllık faturalandırılır",
  "pricing.tagline.free": "Çok küçük ekipler için",
  "pricing.tagline.pay": "Büyüyen ekipler için",
  "pricing.tagline.super": "Ölçeklenen işletmeler için",
  "pricing.tagline.max": "Büyük organizasyonlar için",
  "pricing.category.modelsAi": "Modeller ve yapay zeka",
  "pricing.category.agentsAutomation": "Ajanlar ve otomasyon",
  "pricing.category.toolsConnectors": "Araçlar ve bağlayıcılar",
  "pricing.category.browserCompute": "Tarayıcı ve hesaplama",
  "pricing.category.storageKnowledge": "Depolama ve bilgi",
  "pricing.category.collaborationOrg": "İş birliği ve organizasyon",
  "pricing.category.other": "Diğer",
  "pricing.cap.agentsMax": "Ajanlar",
  "pricing.cap.workflows": "İş akışları",
  "pricing.cap.routines": "Zamanlanmış rutinler",
  "pricing.cap.fullToolLibrary": "Tam araç kütüphanesi (1.100+)",
  "pricing.cap.customConnectors": "Özel bağlayıcılar",
  "pricing.cap.customAgents": "Özel ajanlar",
  "pricing.cap.browser": "Tarayıcı otomasyonu",
  "pricing.cap.vaultStorage": "Kasa depolaması",
  "pricing.cap.persistentMemory": "Kalıcı bellek",
  "pricing.cap.memoryStorage": "Bellek depolaması",
  "pricing.cap.knowledgeBase": "Bilgi tabanı",
  "pricing.cap.orgMemory": "Organizasyon belleği",
  "pricing.cap.rolesPermissions": "Roller ve izinler",
  "pricing.feature.allModels": "Tüm modellere erişim",
  "pricing.feature.advancedStandard": "Gelişmiş + standart modeller",
  "pricing.feature.standardModels": "Standart modeller",
  "pricing.feature.freeModels": "Ücretsiz modeller",
  "pricing.feature.unlimitedToolCalls": "Sınırsız araç çağrısı",
  "pricing.feature.toolCallsMonth": "Ayda {count} araç çağrısı",
  "pricing.feature.unlimitedAgents": "Sınırsız ajan",
  "pricing.feature.agents": "{count} ajan",
  "pricing.feature.agentsPlural": "{count} ajan",
  "pricing.feature.concurrentSubagents": "Eşzamanlı {count} alt ajan",
  "pricing.feature.unlimitedConnectors": "Sınırsız bağlı uygulama",
  "pricing.feature.connectors": "{count} bağlı uygulama",
  "pricing.feature.unlimitedVault": "Sınırsız kasa depolaması",
  "pricing.feature.vaultStorage": "{size} kasa depolaması",
  "pricing.feature.persistentMemory": "Kalıcı bellek",
  "pricing.feature.memoryStorage": "{size} bellek depolaması",
  "pricing.feature.knowledgeBase": "Bilgi tabanı",
  "pricing.feature.orgMemory": "Organizasyon belleği",
  "pricing.feature.rolesPermissions": "Roller ve izinler",
  "pricing.feature.memberSeats": "{count} üye koltuğu",
  "team.edit": "Düzenle",
  "team.detail.about": "Hakkında",
  "team.detail.email": "E-posta",
  "team.detail.location": "Konum",
  "team.detail.joined": "Katılım",
  "team.detail.reportsTo": "Bağlı olduğu kişi",
  "team.detail.timezone": "Saat dilimi",
  "contextPanel.title": "Bağlamsal panel",
  "contextPanel.actions": "Aksiyonlar",
  "contextPanel.toggle": "Bağlamsal paneli aç/kapat",
  "contextPanel.close": "Paneli kapat",
  "contextPanel.subAgentDetail": "Alt ajan detayı",
  "contextPanel.stagingTitle": "Bağlamsal panel (tasarım)",
  "contextPanel.stagingHint": "Tasarım önizlemesi — canlı thread olaylarına bağlı değil.",

  "activities.title": "Aktiviteler",
  "activities.subtitle": "Morrow ve takımın yaptıkları — günün özeti.",
  "activities.prompt.placeholder": "Morrow'a bir şey sor…",
  "activities.prompt.send": "Sohbet başlat",
  "activities.prompt.noProjectTitle": "Önce bir proje seçin",
  "activities.prompt.noProjectDescription": "Buradan sohbet başlatmak için bir proje ekleyin.",
  "activities.mock.banner":
    "Önizleme — yalnızca örnek veri. Gerçek org akışı activity API ile gelecek (Faz 1). Kapatmak için ?mock=0.",
  "activities.apiPending":
    "Canlı org akışı henüz bağlı değil. Geliştirmede önizleme veya ?mock=1 kullanın.",
  "activities.timeline": "Zaman çizelgesi",
  "activities.timeline.hint": "Seçilen günün kronolojik sırası — tam adımlar için öğeye dokunun.",
  "activities.timeline.empty": "Bu gün ve filtreler için aktivite yok.",
  "activities.quickAccess.title": "Hızlı erişim",
  "activities.quickAccess.hint": "Bu günün son dosya, thread ve iş akışları.",
  "activities.quickAccess.empty": "Bu gün ve filtreler için dosya veya bağlantı yok.",
  "activities.detail.progress": "İlerleme",
  "activities.step.queued": "Kuyrukta",
  "activities.step.executing": "Çalışıyor",
  "activities.step.finished": "Bitti",
  "activities.step.requested": "İstek",
  "activities.step.review": "İnceleme",
  "activities.step.decision": "Karar",
  "activities.step.triggered": "Tetiklendi",
  "activities.step.scheduled": "Planlandı",
  "activities.step.due": "Vadesi",
  "activities.step.ran": "Çalıştı",
  "activities.step.received": "Alındı",
  "activities.step.processing": "İşleniyor",
  "activities.step.delivered": "Ulaştı",
  "activities.step.started": "Başladı",
  "activities.step.inProgress": "Devam ediyor",
  "activities.lane.todo": "Yapılacak",
  "activities.lane.doing": "Yapılıyor",
  "activities.lane.done": "Yapılan",
  "activities.lane.empty": "Bu gün için kayıt yok.",
  "activities.lane.viewAll": "Hepsini gör",
  "activities.lane.allDialogHint": "Bu gün bu sütunda {count} kayıt.",
  "activities.lane.showStack": "Yığın görünümü",
  "activities.lane.moreCount": "+{count} daha",
  "activities.lane.expandStack": "Bu sütundaki {count} kaydın tamamını göster",
  "activities.filter.member": "Ekip üyesi",
  "activities.filter.memberShort": "Üye",
  "activities.filter.allMembers": "Tüm üyeler",
  "activities.filter.status": "Durum",
  "activities.filter.statusShort": "Durum",
  "activities.filter.allStatuses": "Tüm durumlar",
  "activities.filter.kind": "Kaynak",
  "activities.filter.kindShort": "Kaynak",
  "activities.filter.allKinds": "Tüm kaynaklar",
  "activities.filter.tapToChoose": "Filtrelemek için dokun",
  "activities.status.needsApproval": "Onay bekliyor",
  "activities.status.pending": "Planlı",
  "activities.status.running": "Devam ediyor",
  "activities.status.completed": "Tamamlandı",
  "activities.status.failed": "Başarısız",
  "activities.status.approved": "Onaylandı",
  "activities.status.denied": "Reddedildi",
  "activities.kind.tool": "Morrow aracı",
  "activities.kind.allowance": "Onay",
  "activities.kind.workflow": "İş akışı",
  "activities.kind.agent": "Ajan",
  "activities.kind.comms": "Mesajlaşma",
  "activities.kind.schedule": "Rutin",
  "activities.kind.board": "Ajan panosu",
  "activities.detail.agent": "Ajan",
  "activities.detail.tool": "Araç",
  "activities.detail.file": "Dosya",
  "activities.detail.workflow": "İş akışı",
  "activities.detail.links": "Aç",
  "activities.detail.openThread": "Sohbet",
  "activities.detail.runSteps": "Adımlar",
  "activities.detail.viewFullConversation": "Tüm görüşmeyi görüntüle",
  "activities.detail.openAgent": "Ajan",
  "activities.detail.openWorkflow": "İş akışı",
  "activities.detail.openAllowance": "Onay",
  "activities.detail.openFile": "Kasada dosya",
  "activities.mock.linksHint": "Önizlemede bağlantılar kapalı — kimlikler örnektir.",
  "activities.action.review": "İncele",
  "activities.action.runNow": "Şimdi çalıştır",
  "activities.action.view": "Görüntüle",
  "activities.action.cancel": "İptal",
  "activities.action.retry": "Yeniden dene",
} as const satisfies Record<MessageKey, string>;
